(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
!function(A,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.vueTagsInput=t():A.vueTagsInput=t()}(window,function(){return function(A){var t={};function e(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return A[n].call(i.exports,i,i.exports,e),i.l=!0,i.exports}return e.m=A,e.c=t,e.d=function(A,t,n){e.o(A,t)||Object.defineProperty(A,t,{enumerable:!0,get:n})},e.r=function(A){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(A,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(A,"__esModule",{value:!0})},e.t=function(A,t){if(1&t&&(A=e(A)),8&t)return A;if(4&t&&"object"==typeof A&&A&&A.__esModule)return A;var n=Object.create(null);if(e.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:A}),2&t&&"string"!=typeof A)for(var i in A)e.d(n,i,function(t){return A[t]}.bind(null,i));return n},e.n=function(A){var t=A&&A.__esModule?function(){return A.default}:function(){return A};return e.d(t,"a",t),t},e.o=function(A,t){return Object.prototype.hasOwnProperty.call(A,t)},e.p="/dist/",e(e.s=6)}([function(A,t,e){var n=e(8);"string"==typeof n&&(n=[[A.i,n,""]]),n.locals&&(A.exports=n.locals);(0,e(4).default)("7ec05f6c",n,!1,{})},function(A,t,e){var n=e(10);"string"==typeof n&&(n=[[A.i,n,""]]),n.locals&&(A.exports=n.locals);(0,e(4).default)("3453d19d",n,!1,{})},function(A,t,e){"use strict";A.exports=function(A){var t=[];return t.toString=function(){return this.map(function(t){var e=function(A,t){var e=A[1]||"",n=A[3];if(!n)return e;if(t&&"function"==typeof btoa){var i=(r=n,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */"),a=n.sources.map(function(A){return"/*# sourceURL="+n.sourceRoot+A+" */"});return[e].concat(a).concat([i]).join("\n")}var r;return[e].join("\n")}(t,A);return t[2]?"@media "+t[2]+"{"+e+"}":e}).join("")},t.i=function(A,e){"string"==typeof A&&(A=[[null,A,""]]);for(var n={},i=0;i<this.length;i++){var a=this[i][0];null!=a&&(n[a]=!0)}for(i=0;i<A.length;i++){var r=A[i];null!=r[0]&&n[r[0]]||(e&&!r[2]?r[2]=e:e&&(r[2]="("+r[2]+") and ("+e+")"),t.push(r))}},t}},function(A,t){A.exports="data:application/vnd.ms-fontobject;base64,aAUAAMQEAAABAAIAAAAAAAAAAAAAAAAAAAABAJABAAAAAExQAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAUdPJHwAAAAAAAAAAAAAAAAAAAAAAAA4AaQBjAG8AbQBvAG8AbgAAAA4AUgBlAGcAdQBsAGEAcgAAABYAVgBlAHIAcwBpAG8AbgAgADEALgAwAAAADgBpAGMAbwBtAG8AbwBuAAAAAAAAAQAAAAsAgAADADBPUy8yDxIFrAAAALwAAABgY21hcBdW0okAAAEcAAAAVGdhc3AAAAAQAAABcAAAAAhnbHlmpZ+jMAAAAXgAAAD8aGVhZA/FmAgAAAJ0AAAANmhoZWEHgAPIAAACrAAAACRobXR4EgABvgAAAtAAAAAcbG9jYQCSAOIAAALsAAAAEG1heHAACQAfAAAC/AAAACBuYW1lmUoJ+wAAAxwAAAGGcG9zdAADAAAAAASkAAAAIAADA4ABkAAFAAACmQLMAAAAjwKZAswAAAHrADMBCQAAAAAAAAAAAAAAAAAAAAEQAAAAAAAAAAAAAAAAAAAAAEAAAOkCA8D/wABAA8AAQAAAAAEAAAAAAAAAAAAAACAAAAAAAAMAAAADAAAAHAABAAMAAAAcAAMAAQAAABwABAA4AAAACgAIAAIAAgABACDpAv/9//8AAAAAACDpAP/9//8AAf/jFwQAAwABAAAAAAAAAAAAAAABAAH//wAPAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAVgEBA74CgQAcAAABMhceARcWFwcmJy4BJyYjIgYHFyERFzY3PgE3NgIWSkNDbykpF2QQIB9VMzQ5P3AtnP6AmB0iIkspKAJVFxhSODlCIDMrKz4REislmgGAmhkVFBwICAABANYAgQMqAtUACwAAAQcXBycHJzcnNxc3Ayru7jzu7jzu7jzu7gKZ7u487u487u487u4AAQCSAIEDgAK9AAUAACUBFwEnNwGAAcQ8/gDuPPkBxDz+AO48AAAAAAEAAAAAAAAfydNRXw889QALBAAAAAAA1nUqGwAAAADWdSobAAAAAAO+AtUAAAAIAAIAAAAAAAAAAQAAA8D/wAAABAAAAAAAA74AAQAAAAAAAAAAAAAAAAAAAAcEAAAAAAAAAAAAAAACAAAABAAAVgQAANYEAACSAAAAAAAKABQAHgBQAGoAfgABAAAABwAdAAEAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAADgCuAAEAAAAAAAEABwAAAAEAAAAAAAIABwBgAAEAAAAAAAMABwA2AAEAAAAAAAQABwB1AAEAAAAAAAUACwAVAAEAAAAAAAYABwBLAAEAAAAAAAoAGgCKAAMAAQQJAAEADgAHAAMAAQQJAAIADgBnAAMAAQQJAAMADgA9AAMAAQQJAAQADgB8AAMAAQQJAAUAFgAgAAMAAQQJAAYADgBSAAMAAQQJAAoANACkaWNvbW9vbgBpAGMAbwBtAG8AbwBuVmVyc2lvbiAxLjAAVgBlAHIAcwBpAG8AbgAgADEALgAwaWNvbW9vbgBpAGMAbwBtAG8AbwBuaWNvbW9vbgBpAGMAbwBtAG8AbwBuUmVndWxhcgBSAGUAZwB1AGwAYQByaWNvbW9vbgBpAGMAbwBtAG8AbwBuRm9udCBnZW5lcmF0ZWQgYnkgSWNvTW9vbi4ARgBvAG4AdAAgAGcAZQBuAGUAcgBhAHQAZQBkACAAYgB5ACAASQBjAG8ATQBvAG8AbgAuAAAAAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=="},function(A,t,e){"use strict";function n(A,t){for(var e=[],n={},i=0;i<t.length;i++){var a=t[i],r=a[0],o={id:A+":"+i,css:a[1],media:a[2],sourceMap:a[3]};n[r]?n[r].parts.push(o):e.push(n[r]={id:r,parts:[o]})}return e}e.r(t),e.d(t,"default",function(){return g});var i="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!i)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var a={},r=i&&(document.head||document.getElementsByTagName("head")[0]),o=null,s=0,u=!1,c=function(){},d=null,l="data-vue-ssr-id",p="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function g(A,t,e,i){u=e,d=i||{};var r=n(A,t);return f(r),function(t){for(var e=[],i=0;i<r.length;i++){var o=r[i];(s=a[o.id]).refs--,e.push(s)}t?f(r=n(A,t)):r=[];for(i=0;i<e.length;i++){var s;if(0===(s=e[i]).refs){for(var u=0;u<s.parts.length;u++)s.parts[u]();delete a[s.id]}}}}function f(A){for(var t=0;t<A.length;t++){var e=A[t],n=a[e.id];if(n){n.refs++;for(var i=0;i<n.parts.length;i++)n.parts[i](e.parts[i]);for(;i<e.parts.length;i++)n.parts.push(v(e.parts[i]));n.parts.length>e.parts.length&&(n.parts.length=e.parts.length)}else{var r=[];for(i=0;i<e.parts.length;i++)r.push(v(e.parts[i]));a[e.id]={id:e.id,refs:1,parts:r}}}}function B(){var A=document.createElement("style");return A.type="text/css",r.appendChild(A),A}function v(A){var t,e,n=document.querySelector("style["+l+'~="'+A.id+'"]');if(n){if(u)return c;n.parentNode.removeChild(n)}if(p){var i=s++;n=o||(o=B()),t=C.bind(null,n,i,!1),e=C.bind(null,n,i,!0)}else n=B(),t=function(A,t){var e=t.css,n=t.media,i=t.sourceMap;n&&A.setAttribute("media",n);d.ssrId&&A.setAttribute(l,t.id);i&&(e+="\n/*# sourceURL="+i.sources[0]+" */",e+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */");if(A.styleSheet)A.styleSheet.cssText=e;else{for(;A.firstChild;)A.removeChild(A.firstChild);A.appendChild(document.createTextNode(e))}}.bind(null,n),e=function(){n.parentNode.removeChild(n)};return t(A),function(n){if(n){if(n.css===A.css&&n.media===A.media&&n.sourceMap===A.sourceMap)return;t(A=n)}else e()}}var m,h=(m=[],function(A,t){return m[A]=t,m.filter(Boolean).join("\n")});function C(A,t,e,n){var i=e?"":n.css;if(A.styleSheet)A.styleSheet.cssText=h(t,i);else{var a=document.createTextNode(i),r=A.childNodes;r[t]&&A.removeChild(r[t]),r.length?A.insertBefore(a,r[t]):A.appendChild(a)}}},function(A,t,e){"use strict";var n=Array.isArray,i=Object.keys,a=Object.prototype.hasOwnProperty;A.exports=function A(t,e){if(t===e)return!0;if(t&&e&&"object"==typeof t&&"object"==typeof e){var r,o,s,u=n(t),c=n(e);if(u&&c){if((o=t.length)!=e.length)return!1;for(r=o;0!=r--;)if(!A(t[r],e[r]))return!1;return!0}if(u!=c)return!1;var d=t instanceof Date,l=e instanceof Date;if(d!=l)return!1;if(d&&l)return t.getTime()==e.getTime();var p=t instanceof RegExp,g=e instanceof RegExp;if(p!=g)return!1;if(p&&g)return t.toString()==e.toString();var f=i(t);if((o=f.length)!==i(e).length)return!1;for(r=o;0!=r--;)if(!a.call(e,f[r]))return!1;for(r=o;0!=r--;)if(!A(t[s=f[r]],e[s]))return!1;return!0}return t!=t&&e!=e}},function(A,t,e){A.exports=e(14)},function(A,t,e){"use strict";var n=e(0);e.n(n).a},function(A,t,e){(A.exports=e(2)(!0)).push([A.i,".ti-tag-input[data-v-108f4f13] {\n  background-color: transparent;\n  color: inherit;\n  border: none;\n  padding: 0px;\n  margin: 0px;\n  display: flex;\n  top: 0px;\n  position: absolute;\n  width: 100%;\n  line-height: inherit;\n}\n.ti-tag-input[data-v-108f4f13]::-ms-clear {\n  display: none;\n}\ninput[data-v-108f4f13]:focus {\n  outline: none;\n}\ninput[disabled][data-v-108f4f13] {\n  background-color: transparent;\n}\n","",{version:3,sources:["C:/Users/johan/dev/vue-tags-input/vue-tags-input/C:/Users/johan/dev/vue-tags-input/vue-tags-input/tag-input.vue"],names:[],mappings:"AAAA;EACE,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,aAAa;EACb,YAAY;EACZ,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;CAAE;AAEzB;EACE,cAAc;CAAE;AAElB;EACE,cAAc;CAAE;AAElB;EACE,8BAA8B;CAAE",file:"tag-input.vue?vue&type=style&index=0&id=108f4f13&lang=css&scoped=true&",sourcesContent:[".ti-tag-input {\n  background-color: transparent;\n  color: inherit;\n  border: none;\n  padding: 0px;\n  margin: 0px;\n  display: flex;\n  top: 0px;\n  position: absolute;\n  width: 100%;\n  line-height: inherit; }\n\n.ti-tag-input::-ms-clear {\n  display: none; }\n\ninput:focus {\n  outline: none; }\n\ninput[disabled] {\n  background-color: transparent; }\n"],sourceRoot:""}])},function(A,t,e){"use strict";var n=e(1);e.n(n).a},function(A,t,e){t=A.exports=e(2)(!0);var n=e(11),i=n(e(3)),a=n(e(3)+"#iefix"),r=n(e(12)),o=n(e(13));t.push([A.i,"@font-face {\n  font-family: 'icomoon';\n  src: url("+i+");\n  src: url("+a+') format("embedded-opentype"), url('+r+') format("truetype"), url('+o+') format("woff");\n  font-weight: normal;\n  font-style: normal;\n}\n[class^="ti-icon-"][data-v-61d92e31], [class*=" ti-icon-"][data-v-61d92e31] {\n  font-family: \'icomoon\' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.ti-icon-check[data-v-61d92e31]:before {\n  content: "\\e902";\n}\n.ti-icon-close[data-v-61d92e31]:before {\n  content: "\\e901";\n}\n.ti-icon-undo[data-v-61d92e31]:before {\n  content: "\\e900";\n}\nul[data-v-61d92e31] {\n  margin: 0px;\n  padding: 0px;\n  list-style-type: none;\n}\n*[data-v-61d92e31], *[data-v-61d92e31]:before, *[data-v-61d92e31]:after {\n  box-sizing: border-box;\n}\ninput[data-v-61d92e31]:focus {\n  outline: none;\n}\ninput[disabled][data-v-61d92e31] {\n  background-color: transparent;\n}\n.vue-tags-input[data-v-61d92e31] {\n  max-width: 450px;\n  position: relative;\n  background-color: #fff;\n}\ndiv.vue-tags-input.disabled[data-v-61d92e31] {\n  opacity: 0.5;\n}\ndiv.vue-tags-input.disabled *[data-v-61d92e31] {\n    cursor: default;\n}\n.ti-input[data-v-61d92e31] {\n  border: 1px solid #ccc;\n  display: flex;\n  padding: 4px;\n  flex-wrap: wrap;\n}\n.ti-tags[data-v-61d92e31] {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  line-height: 1em;\n}\n.ti-tag[data-v-61d92e31] {\n  background-color: #5C6BC0;\n  color: #fff;\n  border-radius: 2px;\n  display: flex;\n  padding: 3px 5px;\n  margin: 2px;\n  font-size: .85em;\n}\n.ti-tag[data-v-61d92e31]:focus {\n    outline: none;\n}\n.ti-tag .ti-content[data-v-61d92e31] {\n    display: flex;\n    align-items: center;\n}\n.ti-tag .ti-tag-center[data-v-61d92e31] {\n    position: relative;\n}\n.ti-tag span[data-v-61d92e31] {\n    line-height: .85em;\n}\n.ti-tag span.ti-hidden[data-v-61d92e31] {\n    padding-left: 14px;\n    visibility: hidden;\n    height: 0px;\n    white-space: pre;\n}\n.ti-tag .ti-actions[data-v-61d92e31] {\n    margin-left: 2px;\n    display: flex;\n    align-items: center;\n    font-size: 1.15em;\n}\n.ti-tag .ti-actions i[data-v-61d92e31] {\n      cursor: pointer;\n}\n.ti-tag[data-v-61d92e31]:last-child {\n    margin-right: 4px;\n}\n.ti-tag.ti-invalid[data-v-61d92e31], .ti-tag.ti-tag.ti-deletion-mark[data-v-61d92e31] {\n    background-color: #e54d42;\n}\n.ti-new-tag-input-wrapper[data-v-61d92e31] {\n  display: flex;\n  flex: 1 0 auto;\n  padding: 3px 5px;\n  margin: 2px;\n  font-size: .85em;\n}\n.ti-new-tag-input-wrapper input[data-v-61d92e31] {\n    flex: 1 0 auto;\n    min-width: 100px;\n    border: none;\n    padding: 0px;\n    margin: 0px;\n}\n.ti-new-tag-input[data-v-61d92e31] {\n  line-height: initial;\n}\n.ti-autocomplete[data-v-61d92e31] {\n  border: 1px solid #ccc;\n  border-top: none;\n  position: absolute;\n  width: 100%;\n  background-color: #fff;\n  z-index: 20;\n}\n.ti-item > div[data-v-61d92e31] {\n  cursor: pointer;\n  padding: 3px 6px;\n  width: 100%;\n}\n.ti-selected-item[data-v-61d92e31] {\n  background-color: #5C6BC0;\n  color: #fff;\n}\n',"",{version:3,sources:["C:/Users/johan/dev/vue-tags-input/vue-tags-input/C:/Users/johan/dev/vue-tags-input/vue-tags-input/vue-tags-input.scss"],names:[],mappings:"AAAA;EACE,uBAAuB;EACvB,mCAA8C;EAC9C,+JAAuM;EACvM,oBAAoB;EACpB,mBAAmB;CAAE;AAEvB;EACE,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,oCAAoC;EACpC,mCAAmC;CAAE;AAEvC;EACE,iBAAiB;CAAE;AAErB;EACE,iBAAiB;CAAE;AAErB;EACE,iBAAiB;CAAE;AAErB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;CAAE;AAE1B;EACE,uBAAuB;CAAE;AAE3B;EACE,cAAc;CAAE;AAElB;EACE,8BAA8B;CAAE;AAElC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;CAAE;AAE3B;EACE,aAAa;CAAE;AACf;IACE,gBAAgB;CAAE;AAEtB;EACE,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;CAAE;AAEpB;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;CAAE;AAErB;EACE,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;CAAE;AACnB;IACE,cAAc;CAAE;AAClB;IACE,cAAc;IACd,oBAAoB;CAAE;AACxB;IACE,mBAAmB;CAAE;AACvB;IACE,mBAAmB;CAAE;AACvB;IACE,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;CAAE;AACrB;IACE,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;CAAE;AACpB;MACE,gBAAgB;CAAE;AACtB;IACE,kBAAkB;CAAE;AACtB;IACE,0BAA0B;CAAE;AAEhC;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;CAAE;AACnB;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,YAAY;CAAE;AAElB;EACE,qBAAqB;CAAE;AAEzB;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,YAAY;CAAE;AAEhB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;CAAE;AAEhB;EACE,0BAA0B;EAC1B,YAAY;CAAE",file:"vue-tags-input.scss?vue&type=style&index=0&id=61d92e31&lang=scss&scoped=true&",sourcesContent:['@font-face {\n  font-family: \'icomoon\';\n  src: url("./assets/fonts/icomoon.eot?7grlse");\n  src: url("./assets/fonts/icomoon.eot?7grlse#iefix") format("embedded-opentype"), url("./assets/fonts/icomoon.ttf?7grlse") format("truetype"), url("./assets/fonts/icomoon.woff?7grlse") format("woff");\n  font-weight: normal;\n  font-style: normal; }\n\n[class^="ti-icon-"], [class*=" ti-icon-"] {\n  font-family: \'icomoon\' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.ti-icon-check:before {\n  content: "\\e902"; }\n\n.ti-icon-close:before {\n  content: "\\e901"; }\n\n.ti-icon-undo:before {\n  content: "\\e900"; }\n\nul {\n  margin: 0px;\n  padding: 0px;\n  list-style-type: none; }\n\n*, *:before, *:after {\n  box-sizing: border-box; }\n\ninput:focus {\n  outline: none; }\n\ninput[disabled] {\n  background-color: transparent; }\n\n.vue-tags-input {\n  max-width: 450px;\n  position: relative;\n  background-color: #fff; }\n\ndiv.vue-tags-input.disabled {\n  opacity: 0.5; }\n  div.vue-tags-input.disabled * {\n    cursor: default; }\n\n.ti-input {\n  border: 1px solid #ccc;\n  display: flex;\n  padding: 4px;\n  flex-wrap: wrap; }\n\n.ti-tags {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  line-height: 1em; }\n\n.ti-tag {\n  background-color: #5C6BC0;\n  color: #fff;\n  border-radius: 2px;\n  display: flex;\n  padding: 3px 5px;\n  margin: 2px;\n  font-size: .85em; }\n  .ti-tag:focus {\n    outline: none; }\n  .ti-tag .ti-content {\n    display: flex;\n    align-items: center; }\n  .ti-tag .ti-tag-center {\n    position: relative; }\n  .ti-tag span {\n    line-height: .85em; }\n  .ti-tag span.ti-hidden {\n    padding-left: 14px;\n    visibility: hidden;\n    height: 0px;\n    white-space: pre; }\n  .ti-tag .ti-actions {\n    margin-left: 2px;\n    display: flex;\n    align-items: center;\n    font-size: 1.15em; }\n    .ti-tag .ti-actions i {\n      cursor: pointer; }\n  .ti-tag:last-child {\n    margin-right: 4px; }\n  .ti-tag.ti-invalid, .ti-tag.ti-tag.ti-deletion-mark {\n    background-color: #e54d42; }\n\n.ti-new-tag-input-wrapper {\n  display: flex;\n  flex: 1 0 auto;\n  padding: 3px 5px;\n  margin: 2px;\n  font-size: .85em; }\n  .ti-new-tag-input-wrapper input {\n    flex: 1 0 auto;\n    min-width: 100px;\n    border: none;\n    padding: 0px;\n    margin: 0px; }\n\n.ti-new-tag-input {\n  line-height: initial; }\n\n.ti-autocomplete {\n  border: 1px solid #ccc;\n  border-top: none;\n  position: absolute;\n  width: 100%;\n  background-color: #fff;\n  z-index: 20; }\n\n.ti-item > div {\n  cursor: pointer;\n  padding: 3px 6px;\n  width: 100%; }\n\n.ti-selected-item {\n  background-color: #5C6BC0;\n  color: #fff; }\n'],sourceRoot:""}])},function(A,t,e){"use strict";A.exports=function(A){return"string"!=typeof A?A:(/^['"].*['"]$/.test(A)&&(A=A.slice(1,-1)),/["'() \t\n]/.test(A)?'"'+A.replace(/"/g,'\\"').replace(/\n/g,"\\n")+'"':A)}},function(A,t){A.exports="data:font/ttf;base64,AAEAAAALAIAAAwAwT1MvMg8SBawAAAC8AAAAYGNtYXAXVtKJAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5ZqWfozAAAAF4AAAA/GhlYWQPxZgIAAACdAAAADZoaGVhB4ADyAAAAqwAAAAkaG10eBIAAb4AAALQAAAAHGxvY2EAkgDiAAAC7AAAABBtYXhwAAkAHwAAAvwAAAAgbmFtZZlKCfsAAAMcAAABhnBvc3QAAwAAAAAEpAAAACAAAwOAAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADpAgPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg6QL//f//AAAAAAAg6QD//f//AAH/4xcEAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAFYBAQO+AoEAHAAAATIXHgEXFhcHJicuAScmIyIGBxchERc2Nz4BNzYCFkpDQ28pKRdkECAfVTM0OT9wLZz+gJgdIiJLKSgCVRcYUjg5QiAzKys+ERIrJZoBgJoZFRQcCAgAAQDWAIEDKgLVAAsAAAEHFwcnByc3JzcXNwMq7u487u487u487u4Cme7uPO7uPO7uPO7uAAEAkgCBA4ACvQAFAAAlARcBJzcBgAHEPP4A7jz5AcQ8/gDuPAAAAAABAAAAAAAAH8nTUV8PPPUACwQAAAAAANZ1KhsAAAAA1nUqGwAAAAADvgLVAAAACAACAAAAAAAAAAEAAAPA/8AAAAQAAAAAAAO+AAEAAAAAAAAAAAAAAAAAAAAHBAAAAAAAAAAAAAAAAgAAAAQAAFYEAADWBAAAkgAAAAAACgAUAB4AUABqAH4AAQAAAAcAHQABAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAA4ArgABAAAAAAABAAcAAAABAAAAAAACAAcAYAABAAAAAAADAAcANgABAAAAAAAEAAcAdQABAAAAAAAFAAsAFQABAAAAAAAGAAcASwABAAAAAAAKABoAigADAAEECQABAA4ABwADAAEECQACAA4AZwADAAEECQADAA4APQADAAEECQAEAA4AfAADAAEECQAFABYAIAADAAEECQAGAA4AUgADAAEECQAKADQApGljb21vb24AaQBjAG8AbQBvAG8AblZlcnNpb24gMS4wAFYAZQByAHMAaQBvAG4AIAAxAC4AMGljb21vb24AaQBjAG8AbQBvAG8Abmljb21vb24AaQBjAG8AbQBvAG8AblJlZ3VsYXIAUgBlAGcAdQBsAGEAcmljb21vb24AaQBjAG8AbQBvAG8AbkZvbnQgZ2VuZXJhdGVkIGJ5IEljb01vb24uAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgAAAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA="},function(A,t){A.exports="data:font/woff;base64,d09GRgABAAAAAAUQAAsAAAAABMQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABPUy8yAAABCAAAAGAAAABgDxIFrGNtYXAAAAFoAAAAVAAAAFQXVtKJZ2FzcAAAAbwAAAAIAAAACAAAABBnbHlmAAABxAAAAPwAAAD8pZ+jMGhlYWQAAALAAAAANgAAADYPxZgIaGhlYQAAAvgAAAAkAAAAJAeAA8hobXR4AAADHAAAABwAAAAcEgABvmxvY2EAAAM4AAAAEAAAABAAkgDibWF4cAAAA0gAAAAgAAAAIAAJAB9uYW1lAAADaAAAAYYAAAGGmUoJ+3Bvc3QAAATwAAAAIAAAACAAAwAAAAMDgAGQAAUAAAKZAswAAACPApkCzAAAAesAMwEJAAAAAAAAAAAAAAAAAAAAARAAAAAAAAAAAAAAAAAAAAAAQAAA6QIDwP/AAEADwABAAAAAAQAAAAAAAAAAAAAAIAAAAAAAAwAAAAMAAAAcAAEAAwAAABwAAwABAAAAHAAEADgAAAAKAAgAAgACAAEAIOkC//3//wAAAAAAIOkA//3//wAB/+MXBAADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQBWAQEDvgKBABwAAAEyFx4BFxYXByYnLgEnJiMiBgcXIREXNjc+ATc2AhZKQ0NvKSkXZBAgH1UzNDk/cC2c/oCYHSIiSykoAlUXGFI4OUIgMysrPhESKyWaAYCaGRUUHAgIAAEA1gCBAyoC1QALAAABBxcHJwcnNyc3FzcDKu7uPO7uPO7uPO7uApnu7jzu7jzu7jzu7gABAJIAgQOAAr0ABQAAJQEXASc3AYABxDz+AO48+QHEPP4A7jwAAAAAAQAAAAAAAB/J01FfDzz1AAsEAAAAAADWdSobAAAAANZ1KhsAAAAAA74C1QAAAAgAAgAAAAAAAAABAAADwP/AAAAEAAAAAAADvgABAAAAAAAAAAAAAAAAAAAABwQAAAAAAAAAAAAAAAIAAAAEAABWBAAA1gQAAJIAAAAAAAoAFAAeAFAAagB+AAEAAAAHAB0AAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAHAAAAAQAAAAAAAgAHAGAAAQAAAAAAAwAHADYAAQAAAAAABAAHAHUAAQAAAAAABQALABUAAQAAAAAABgAHAEsAAQAAAAAACgAaAIoAAwABBAkAAQAOAAcAAwABBAkAAgAOAGcAAwABBAkAAwAOAD0AAwABBAkABAAOAHwAAwABBAkABQAWACAAAwABBAkABgAOAFIAAwABBAkACgA0AKRpY29tb29uAGkAYwBvAG0AbwBvAG5WZXJzaW9uIDEuMABWAGUAcgBzAGkAbwBuACAAMQAuADBpY29tb29uAGkAYwBvAG0AbwBvAG5pY29tb29uAGkAYwBvAG0AbwBvAG5SZWd1bGFyAFIAZQBnAHUAbABhAHJpY29tb29uAGkAYwBvAG0AbwBvAG5Gb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA"},function(A,t,e){"use strict";e.r(t);var n=function(){var A=this,t=A.$createElement,e=A._self._c||t;return e("div",{staticClass:"vue-tags-input",class:[{"ti-disabled":A.disabled},{"ti-focus":A.focused}]},[e("div",{staticClass:"ti-input"},[A.tagsCopy?e("ul",{staticClass:"ti-tags"},[A._l(A.tagsCopy,function(t,n){return e("li",{key:n,staticClass:"ti-tag",class:[{"ti-editing":A.tagsEditStatus[n]},t.tiClasses,t.classes,{"ti-deletion-mark":A.isMarked(n)}],style:t.style,attrs:{tabindex:"0"},on:{click:function(e){return A.$emit("tag-clicked",{tag:t,index:n})}}},[e("div",{staticClass:"ti-content"},[A.$scopedSlots["tag-left"]?e("div",{staticClass:"ti-tag-left"},[A._t("tag-left",null,{tag:t,index:n,edit:A.tagsEditStatus[n],performSaveEdit:A.performSaveTag,performDelete:A.performDeleteTag,performCancelEdit:A.cancelEdit,performOpenEdit:A.performEditTag,deletionMark:A.isMarked(n)})],2):A._e(),A._v(" "),e("div",{ref:"tagCenter",refInFor:!0,staticClass:"ti-tag-center"},[A.$scopedSlots["tag-center"]?A._e():e("span",{class:{"ti-hidden":A.tagsEditStatus[n]},on:{click:function(t){return A.performEditTag(n)}}},[A._v(A._s(t.text))]),A._v(" "),A.$scopedSlots["tag-center"]?A._e():e("tag-input",{attrs:{scope:{edit:A.tagsEditStatus[n],maxlength:A.maxlength,tag:t,index:n,validateTag:A.createChangedTag,performCancelEdit:A.cancelEdit,performSaveEdit:A.performSaveTag}}}),A._v(" "),A._t("tag-center",null,{tag:t,index:n,maxlength:A.maxlength,edit:A.tagsEditStatus[n],performSaveEdit:A.performSaveTag,performDelete:A.performDeleteTag,performCancelEdit:A.cancelEdit,validateTag:A.createChangedTag,performOpenEdit:A.performEditTag,deletionMark:A.isMarked(n)})],2),A._v(" "),A.$scopedSlots["tag-right"]?e("div",{staticClass:"ti-tag-right"},[A._t("tag-right",null,{tag:t,index:n,edit:A.tagsEditStatus[n],performSaveEdit:A.performSaveTag,performDelete:A.performDeleteTag,performCancelEdit:A.cancelEdit,performOpenEdit:A.performEditTag,deletionMark:A.isMarked(n)})],2):A._e()]),A._v(" "),e("div",{staticClass:"ti-actions"},[A.$scopedSlots["tag-actions"]?A._e():e("i",{directives:[{name:"show",rawName:"v-show",value:A.tagsEditStatus[n],expression:"tagsEditStatus[index]"}],staticClass:"ti-icon-undo",on:{click:function(t){return A.cancelEdit(n)}}}),A._v(" "),A.$scopedSlots["tag-actions"]?A._e():e("i",{directives:[{name:"show",rawName:"v-show",value:!A.tagsEditStatus[n],expression:"!tagsEditStatus[index]"}],staticClass:"ti-icon-close",on:{click:function(t){return A.performDeleteTag(n)}}}),A._v(" "),A.$scopedSlots["tag-actions"]?A._t("tag-actions",null,{tag:t,index:n,edit:A.tagsEditStatus[n],performSaveEdit:A.performSaveTag,performDelete:A.performDeleteTag,performCancelEdit:A.cancelEdit,performOpenEdit:A.performEditTag,deletionMark:A.isMarked(n)}):A._e()],2)])}),A._v(" "),e("li",{staticClass:"ti-new-tag-input-wrapper"},[e("input",A._b({ref:"newTagInput",staticClass:"ti-new-tag-input",class:[A.createClasses(A.newTag,A.tags,A.validation,A.isDuplicate)],attrs:{placeholder:A.placeholder,maxlength:A.maxlength,disabled:A.disabled,type:"text",size:"1"},domProps:{value:A.newTag},on:{keydown:[function(t){return A.performAddTags(A.filteredAutocompleteItems[A.selectedItem]||A.newTag,t)},function(t){return t.type.indexOf("key")||8===t.keyCode?A.invokeDelete(t):null},function(t){return t.type.indexOf("key")||9===t.keyCode?A.performBlur(t):null},function(t){return t.type.indexOf("key")||38===t.keyCode?A.selectItem(t,"before"):null},function(t){return t.type.indexOf("key")||40===t.keyCode?A.selectItem(t,"after"):null}],paste:A.addTagsFromPaste,input:A.updateNewTag,blur:function(t){return A.$emit("blur",t)},focus:function(t){A.focused=!0,A.$emit("focus",t)},click:function(t){!A.addOnlyFromAutocomplete&&(A.selectedItem=null)}}},"input",A.$attrs,!1))])],2):A._e()]),A._v(" "),A._t("between-elements"),A._v(" "),A.autocompleteOpen?e("div",{staticClass:"ti-autocomplete",on:{mouseout:function(t){A.selectedItem=null}}},[A._t("autocomplete-header"),A._v(" "),e("ul",A._l(A.filteredAutocompleteItems,function(t,n){return e("li",{key:n,staticClass:"ti-item",class:[t.tiClasses,t.classes,{"ti-selected-item":A.isSelected(n)}],style:t.style,on:{mouseover:function(t){!A.disabled&&(A.selectedItem=n)}}},[A.$scopedSlots["autocomplete-item"]?A._t("autocomplete-item",null,{item:t,index:n,performAdd:function(t){return A.performAddTags(t,void 0,"autocomplete")},selected:A.isSelected(n)}):e("div",{on:{click:function(e){return A.performAddTags(t,void 0,"autocomplete")}}},[A._v("\n          "+A._s(t.text)+"\n        ")])],2)}),0),A._v(" "),A._t("autocomplete-footer")],2):A._e()],2)};n._withStripped=!0;var i=e(5),a=e.n(i),r=function(A){return JSON.parse(JSON.stringify(A))},o=function(A,t){var e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],n=arguments.length>3?arguments[3]:void 0;void 0===A.text&&(A={text:A});var i=function(A,t){return t.filter(function(t){var e=A.text;return"string"==typeof t.rule?!new RegExp(t.rule).test(e):t.rule instanceof RegExp?!t.rule.test(e):"[object Function]"==={}.toString.call(t.rule)?t.rule(A):void 0}).map(function(A){return A.classes})}(A,e),a=function(A,t){for(var e=0;e<A.length;){if(t(A[e],e,A))return e;e++}return-1}(t,function(t){return t===A}),o=r(t),s=-1!==a?o.splice(a,1)[0]:r(A);return(n?n(o,s):-1!==o.map(function(A){return A.text}).indexOf(s.text))&&i.push("ti-duplicate"),0===i.length?i.push("ti-valid"):i.push("ti-invalid"),i},s=function(A){void 0===A.text&&(A={text:A});for(var t=r(A),e=arguments.length,n=new Array(e>1?e-1:0),i=1;i<e;i++)n[i-1]=arguments[i];return t.tiClasses=o.apply(void 0,[A].concat(n)),t},u=function(A){for(var t=arguments.length,e=new Array(t>1?t-1:0),n=1;n<t;n++)e[n-1]=arguments[n];return A.map(function(t){return s.apply(void 0,[t,A].concat(e))})},c=function(){var A=this,t=A.$createElement,e=A._self._c||t;return A.scope.edit?e("input",{directives:[{name:"model",rawName:"v-model",value:A.scope.tag.text,expression:"scope.tag.text"}],staticClass:"ti-tag-input",attrs:{maxlength:A.scope.maxlength,type:"text",size:"1"},domProps:{value:A.scope.tag.text},on:{input:[function(t){t.target.composing||A.$set(A.scope.tag,"text",t.target.value)},function(t){return A.scope.validateTag(A.scope.index,t)}],blur:function(t){return A.scope.performCancelEdit(A.scope.index)},keydown:function(t){return A.scope.performSaveEdit(A.scope.index,t)}}}):A._e()};c._withStripped=!0;var d={name:"TagInput",props:{scope:{type:Object}}};e(7);function l(A,t,e,n,i,a,r,o){var s,u="function"==typeof A?A.options:A;if(t&&(u.render=t,u.staticRenderFns=e,u._compiled=!0),n&&(u.functional=!0),a&&(u._scopeId="data-v-"+a),r?(s=function(A){(A=A||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(A=__VUE_SSR_CONTEXT__),i&&i.call(this,A),A&&A._registeredComponents&&A._registeredComponents.add(r)},u._ssrRegister=s):i&&(s=o?function(){i.call(this,this.$root.$options.shadowRoot)}:i),s)if(u.functional){u._injectStyles=s;var c=u.render;u.render=function(A,t){return s.call(t),c(A,t)}}else{var d=u.beforeCreate;u.beforeCreate=d?[].concat(d,s):[s]}return{exports:A,options:u}}var p=l(d,c,[],!1,null,"108f4f13",null);p.options.__file="vue-tags-input/tag-input.vue";var g=p.exports,f=function(A){return!A.some(function(A){var t=!A.text;t&&console.warn('Missing property "text"',A);var e=!1;return A.classes&&(e="string"!=typeof A.classes),e&&console.warn('Property "classes" must be type of string',A),t||e})},B=function(A){return!A.some(function(A){if("number"==typeof A){var t=isFinite(A)&&Math.floor(A)===A;return t||console.warn("Only numerics are allowed for this prop. Found:",A),!t}if("string"==typeof A){var e=/\W|[a-z]|!\d/i.test(A);return e||console.warn("Only alpha strings are allowed for this prop. Found:",A),!e}return console.warn("Only numeric and string values are allowed. Found:",A),!1})},v={value:{type:String,default:"",required:!0},tags:{type:Array,default:function(){return[]},validator:f},autocompleteItems:{type:Array,default:function(){return[]},validator:f},allowEditTags:{type:Boolean,default:!1},autocompleteFilterDuplicates:{default:!0,type:Boolean},addOnlyFromAutocomplete:{type:Boolean,default:!1},autocompleteMinLength:{type:Number,default:1},autocompleteAlwaysOpen:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},placeholder:{type:String,default:"Add Tag"},addOnKey:{type:Array,default:function(){return[13]},validator:B},saveOnKey:{type:Array,default:function(){return[13]},validator:B},maxTags:{type:Number},maxlength:{type:Number},validation:{type:Array,default:function(){return[]},validator:function(A){return!A.some(function(A){var t=!A.rule;t&&console.warn('Property "rule" is missing',A);var e=A.rule&&("string"==typeof A.rule||A.rule instanceof RegExp||"[object Function]"==={}.toString.call(A.rule));e||console.warn("A rule must be type of string, RegExp or function. Found:",JSON.stringify(A.rule));var n=!A.classes;n&&console.warn('Property "classes" is missing',A);var i=A.type&&"string"!=typeof A.type;return i&&console.warn('Property "type" must be type of string. Found:',A),!e||t||n||i})}},separators:{type:Array,default:function(){return[";"]},validator:function(A){return!A.some(function(A){var t="string"!=typeof A;return t&&console.warn("Separators must be type of string. Found:",A),t})}},avoidAddingDuplicates:{type:Boolean,default:!0},addOnBlur:{type:Boolean,default:!0},isDuplicate:{type:Function,default:null},addFromPaste:{type:Boolean,default:!0},deleteOnBackspace:{default:!0,type:Boolean}};function m(A){return(m="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(A){return typeof A}:function(A){return A&&"function"==typeof Symbol&&A.constructor===Symbol&&A!==Symbol.prototype?"symbol":typeof A})(A)}var h={name:"VueTagsInput",components:{TagInput:g},props:v,data:function(){return{newTag:null,tagsCopy:null,tagsEditStatus:null,deletionMark:null,deletionMarkTime:null,selectedItem:null,focused:null}},computed:{autocompleteOpen:function(){return!!this.autocompleteAlwaysOpen||null!==this.newTag&&this.newTag.length>=this.autocompleteMinLength&&this.filteredAutocompleteItems.length>0&&this.focused},filteredAutocompleteItems:function(){var A=this,t=this.autocompleteItems.map(function(t){return s(t,A.tags,A.validation,A.isDuplicate)});return this.autocompleteFilterDuplicates?t.filter(this.duplicateFilter):t}},methods:{createClasses:o,getSelectedIndex:function(A){var t=this.filteredAutocompleteItems,e=this.selectedItem,n=t.length-1;if(0!==t.length)return null===e?0:"before"===A&&0===e?n:"after"===A&&e===n?0:"after"===A?e+1:e-1},selectDefaultItem:function(){this.addOnlyFromAutocomplete&&this.filteredAutocompleteItems.length>0?this.selectedItem=0:this.selectedItem=null},selectItem:function(A,t){A.preventDefault(),this.selectedItem=this.getSelectedIndex(t)},isSelected:function(A){return this.selectedItem===A},isMarked:function(A){return this.deletionMark===A},invokeDelete:function(){var A=this;if(this.deleteOnBackspace&&!(this.newTag.length>0)){var t=this.tagsCopy.length-1;null===this.deletionMark?(this.deletionMarkTime=setTimeout(function(){return A.deletionMark=null},1e3),this.deletionMark=t):this.performDeleteTag(t)}},addTagsFromPaste:function(){var A=this;this.addFromPaste&&setTimeout(function(){return A.performAddTags(A.newTag)},10)},performEditTag:function(A){var t=this;this.allowEditTags&&(this._events["before-editing-tag"]||this.editTag(A),this.$emit("before-editing-tag",{index:A,tag:this.tagsCopy[A],editTag:function(){return t.editTag(A)}}))},editTag:function(A){this.allowEditTags&&(this.toggleEditMode(A),this.focus(A))},toggleEditMode:function(A){this.allowEditTags&&!this.disabled&&this.$set(this.tagsEditStatus,A,!this.tagsEditStatus[A])},createChangedTag:function(A,t){var e=this.tagsCopy[A];e.text=t?t.target.value:this.tagsCopy[A].text,this.$set(this.tagsCopy,A,s(e,this.tagsCopy,this.validation,this.isDuplicate))},focus:function(A){var t=this;this.$nextTick(function(){var e=t.$refs.tagCenter[A].querySelector("input.ti-tag-input");e&&e.focus()})},quote:function(A){return A.replace(/([()[{*+.$^\\|?])/g,"\\$1")},cancelEdit:function(A){this.tags[A]&&(this.tagsCopy[A]=r(s(this.tags[A],this.tags,this.validation,this.isDuplicate)),this.$set(this.tagsEditStatus,A,!1))},hasForbiddingAddRule:function(A){var t=this;return A.some(function(A){var e=t.validation.find(function(t){return A===t.classes});return!!e&&e.disableAdd})},createTagTexts:function(A){var t=this,e=new RegExp(this.separators.map(function(A){return t.quote(A)}).join("|"));return A.split(e).map(function(A){return{text:A}})},performDeleteTag:function(A){var t=this;this._events["before-deleting-tag"]||this.deleteTag(A),this.$emit("before-deleting-tag",{index:A,tag:this.tagsCopy[A],deleteTag:function(){return t.deleteTag(A)}})},deleteTag:function(A){this.disabled||(this.deletionMark=null,clearTimeout(this.deletionMarkTime),this.tagsCopy.splice(A,1),this._events["update:tags"]&&this.$emit("update:tags",this.tagsCopy),this.$emit("tags-changed",this.tagsCopy))},noTriggerKey:function(A,t){var e=-1!==this[t].indexOf(A.keyCode)||-1!==this[t].indexOf(A.key);return e&&A.preventDefault(),!e},performAddTags:function(A,t,e){var n=this;if(!(this.disabled||t&&this.noTriggerKey(t,"addOnKey"))){var i=[];"object"===m(A)&&(i=[A]),"string"==typeof A&&(i=this.createTagTexts(A)),(i=i.filter(function(A){return A.text.trim().length>0})).forEach(function(A){A=s(A,n.tags,n.validation,n.isDuplicate),n._events["before-adding-tag"]||n.addTag(A,e),n.$emit("before-adding-tag",{tag:A,addTag:function(){return n.addTag(A,e)}})})}},duplicateFilter:function(A){return this.isDuplicate?!this.isDuplicate(this.tagsCopy,A):!this.tagsCopy.find(function(t){return t.text===A.text})},addTag:function(A){var t=this,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"new-tag-input",n=this.filteredAutocompleteItems.map(function(A){return A.text});this.addOnlyFromAutocomplete&&-1===n.indexOf(A.text)||this.$nextTick(function(){return t.maxTags&&t.maxTags<=t.tagsCopy.length?t.$emit("max-tags-reached",A):t.avoidAddingDuplicates&&!t.duplicateFilter(A)?t.$emit("adding-duplicate",A):void(t.hasForbiddingAddRule(A.tiClasses)||(t.$emit("input",""),t.tagsCopy.push(A),t._events["update:tags"]&&t.$emit("update:tags",t.tagsCopy),"autocomplete"===e&&t.$refs.newTagInput.focus(),t.$emit("tags-changed",t.tagsCopy)))})},performSaveTag:function(A,t){var e=this,n=this.tagsCopy[A];this.disabled||t&&this.noTriggerKey(t,"addOnKey")||0!==n.text.trim().length&&(this._events["before-saving-tag"]||this.saveTag(A,n),this.$emit("before-saving-tag",{index:A,tag:n,saveTag:function(){return e.saveTag(A,n)}}))},saveTag:function(A,t){if(this.avoidAddingDuplicates){var e=r(this.tagsCopy),n=e.splice(A,1)[0];if(this.isDuplicate?this.isDuplicate(e,n):-1!==e.map(function(A){return A.text}).indexOf(n.text))return this.$emit("saving-duplicate",t)}this.hasForbiddingAddRule(t.tiClasses)||(this.$set(this.tagsCopy,A,t),this.toggleEditMode(A),this._events["update:tags"]&&this.$emit("update:tags",this.tagsCopy),this.$emit("tags-changed",this.tagsCopy))},tagsEqual:function(){var A=this;return!this.tagsCopy.some(function(t,e){return!a()(t,A.tags[e])})},updateNewTag:function(A){var t=A.target.value;this.newTag=t,this.$emit("input",t)},initTags:function(){this.tagsCopy=u(this.tags,this.validation,this.isDuplicate),this.tagsEditStatus=r(this.tags).map(function(){return!1}),this._events["update:tags"]&&!this.tagsEqual()&&this.$emit("update:tags",this.tagsCopy)},blurredOnClick:function(A){this.$el.contains(A.target)||this.$el.contains(document.activeElement)||this.performBlur(A)},performBlur:function(){this.addOnBlur&&this.focused&&this.performAddTags(this.newTag),this.focused=!1}},watch:{value:function(A){this.addOnlyFromAutocomplete||(this.selectedItem=null),this.newTag=A},tags:{handler:function(){this.initTags()},deep:!0},autocompleteOpen:"selectDefaultItem"},created:function(){this.newTag=this.value,this.initTags()},mounted:function(){this.selectDefaultItem(),document.addEventListener("click",this.blurredOnClick)},destroyed:function(){document.removeEventListener("click",this.blurredOnClick)}},C=(e(9),l(h,n,[],!1,null,"61d92e31",null));C.options.__file="vue-tags-input/vue-tags-input.vue";var E=C.exports;e.d(t,"VueTagsInput",function(){return E}),e.d(t,"createClasses",function(){return o}),e.d(t,"createTag",function(){return s}),e.d(t,"createTags",function(){return u}),e.d(t,"TagInput",function(){return g}),E.install=function(A){return A.component(E.name,E)},"undefined"!=typeof window&&window.Vue&&window.Vue.use(E);t.default=E}])});

},{}],2:[function(require,module,exports){
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\w?\W?]{8,}$/;

var params = new URLSearchParams(window.location.search);

window.handle_recaptcha = function (token) {
	$('input[name="captchaToken"]').val(token);
	$('.g-recaptcha p.text-danger').remove();
};

window.handle_recaptcha_expired = function () {
	$('input[name="captchaToken"]').val('');
};

function invalid_authorization_code() {
	Swal.fire({
		title: _t['invalid_code'],
		icon: 'question',
		confirmButtonText: _t['try_again'],
		cancelButtonText: _t['request_help'],
		cancelButtonColor: '#3085d6',
		showCancelButton: true
	}).then(function (response) {
		if (!response.isConfirmed) {
			request_help(_t['request_help'], '', 'question', _t['submit'], _t['cancel']);
		}
	});
}

function reset_password(e) {
	Swal.fire({
		title: _t["Forgot your password?"],
		html: '<p>' + _t['Enter your email below and we will send you an email with a link you can use to reset your password.'] + '<input required="required" id="reset-password-email" type="email" class="swal2-input" required>',
		icon: 'question',
		confirmButtonText: _t['Reset Password'],
		cancelButtonText: _t['cancel'],
		showCancelButton: true,
		preConfirm: function preConfirm() {
			if ($('#reset-password-email').val() == '') {
				Swal.showValidationMessage(_t['Please enter your email.']);
				return false;
			} else {
				return {
					'email': $('#reset-password-email').val()
				};
			}
		}
	}).then(function (response) {
		if (response.isConfirmed) {
			$.ajax({
				url: localeUrlPath + '/accounts/send-password-reset',
				type: 'post',
				data: {
					loginName: response.value['email'],
					page: 'payments'
				},
				dataType: 'json'
			});

			Swal.fire({
				title: _t['Password reset link sent. Please check your email.'],
				icon: 'success',
				confirmButtonText: _t['Ok']
			});
		}
	});

	if (e) {
		e.preventDefault();
	}

	return false;
}

$(document).ready(function () {
	if (ENV == 'production') {
		$('head').append('<script type="text/javascript" src="https://js.authorize.net/v1/Accept.js" charset="utf-8"></script>');
	} else {
		$('head').append('<script type="text/javascript" src="https://jstest.authorize.net/v1/Accept.js" charset="utf-8"></script>');
	}

	$('#account-loader').hide();
	$('.forgot-password').on('click', reset_password);

	if ($('#account').length > 0) {
		if (params.get('a') == 'set-password') {
			init_password_reset();
		} else if (params.get('a') == 'verify-email') {
			$('#account-loader').show();
			if (currentUser && currentUser.loggedIn) {
				verify_email();
			} else {
				$('#account-loader').hide();
				$('#verify-email form').on('submit', function (e) {
					var form = $(this);
					form.find('button').attr('disabled', 'disabled');
					$.ajax({
						url: localeUrlPath + '/login',
						type: 'post',
						data: $(this).serializeJSON(),
						dataType: 'json'
					}).done(function (response) {
						if (response.errorCode && response.errorCode == 'invalid_credentials') {
							form.find('button').removeAttr('disabled');
							Swal.fire({
								icon: 'warning',
								title: _t['Invalid email or password.'],
								confirmButtonText: _t['Reset Password'],
								cancelButtonText: _t['Try Again'],
								showCancelButton: true
							}).then(function (response) {
								if (response.isConfirmed) {
									reset_password();
								}
							});
						} else {
							$.getJSON('/current-user.json', function (response) {
								window.currentUser = response;
								verify_email();
							});
						}
					}).fail(function (e) {
						error_occurred(e);
						form.find('button').removeAttr('disabled');
					});

					e.preventDefault();
					return false;
				});

				$('#verify-email').show();
			}
		} else if (currentUser.loggedIn && currentUser.dues) {
			init_account();
		} else if (params.get('bvst')) {
			$('#account-loader').show();
			$.ajax({
				url: localeUrlPath + '/accounts/authorize-verification-bypass',
				type: 'post',
				data: {
					bvst: params.get('bvst')
				},
				dataType: 'json'
			}).done(function (response) {
				if (response['status'] == 'success') {
					$('#create-account input[name="st"]').val(response['st']);
					$('#account-loader').hide();
					init_create_account();
				} else {
					window.location = localeUrlPath + '/payments';
				}
			}).fail(function (e) {
				error_occurred(e);
			});
		} else {
			init_login();
		}
	}
});

function verify_email() {
	$.ajax({
		url: localeUrlPath + '/accounts/verify-email',
		type: 'post',
		data: {
			vc: params.get('vc'),
			uid: params.get('uid')
		},
		dataType: 'json'
	}).done(function (response) {
		if (response['status'] == 'success') {
			$('#account-loader').show();
			Swal.fire({
				title: _t['Thank you for verifying your email address!'],
				icon: 'success',
				confirmButtonText: _t['Ok']
			}).then(function (response) {
				window.location = localeUrlPath + '/payments';
			});
			setTimeout(function () {
				window.location = localeUrlPath + '/payments';
			}, 2000);
		} else if (response['status'] == 'invalid-code') {
			$('#account-loader').hide();
			Swal.fire({
				title: _t['Your email verification link has expired.'],
				html: '<p>' + _t['Just now we sent you a new link to your email address. Please check your email.'] + '</p>',
				icon: 'info',
				confirmButtonText: _t['Ok']
			}).then(function (response) {
				$('#account-loader').show();
				window.location = localeUrlPath + '/payments';
			});
		} else if (response['status'] == 'uid-not-found') {
			$('#account-loader').hide();
			Swal.fire({
				title: _t['Invalid link.'],
				html: '<p>' + _t['Please try again copying and pasting the entire link into your browser.'] + '</p>',
				icon: 'info',
				confirmButtonText: _t['Ok']
			}).then(function (response) {
				$('#account-loader').show();
				window.location = localeUrlPath + '/payments';
			});
		} else {
			$('#account-loader').show();
			window.location = localeUrlPath + '/payments';
		}
	}).fail(function (e) {
		error_occurred(e);
	});
}

function init_password_reset() {
	$('#password-reset').show();

	$('#password-reset form').on('submit', function (e) {
		if (!$('#newPassword').val().match(passwordRegex)) {
			Swal.fire({
				title: _t['Must be at least 8 characters long and include letters and numbers'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
		} else if ($('#newPassword').val() != $('#newPasswordConfirmation').val()) {
			Swal.fire({
				title: _t['New password and Retype new password must match'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
		} else {
			$.ajax({
				url: localeUrlPath + '/accounts/set-password',
				type: 'post',
				data: {
					vc: params.get('vc'),
					uid: params.get('uid'),
					newPassword: $('#newPassword').val()
				},
				dataType: 'json'
			}).done(function (response) {
				$('#account-loader').show();
				$('#password-reset').hide();

				Swal.fire({
					icon: 'success',
					title: _t['Your password was reset.'],
					confirmButtonText: _t['Ok']
				}).then(function (response) {
					window.location = localeUrlPath + '/payments';
				});
			}).fail(function (e) {
				error_occurred(e);
			});
		}

		e.preventDefault();
		return false;
	});
}

function init_create_account() {
	if (params.get('bvst')) {
		$('#create-account #email2').closest('.row').remove();
		$('#create-account input[name="bvst"]').val(params.get('bvst'));
		$('#create-account .wemail').hide();
		$('#create-account .woemail').show();
	} else {
		$('#create-account .wemail').show();
		$('#create-account .woemail').hide();
	}

	$('#create-account').show();

	$('#create-account form').off('submit').on('submit', function (e) {
		if (!params.get('bvst') && $(this).find('#email2').val() != $(this).find('#email2Confirmation').val()) {
			Swal.fire({
				title: _t['Email and Retype email must match'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
		} else if (!$(this).find('#password').val().match(passwordRegex)) {
			Swal.fire({
				title: _t['Must be at least 8 characters long and include letters and numbers'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
		} else if ($(this).find('#password').val() != $(this).find('#passwordConfirmation').val()) {
			Swal.fire({
				title: _t['Password and Retype password must match'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
		} else {
			var form2 = $(this);
			form2.find('button').attr('disabled', 'disabled');
			$.ajax({
				url: localeUrlPath + '/accounts/update-from-authorization',
				type: 'post',
				data: $(this).serializeJSON(),
				dataType: 'json'
			}).done(function (response) {
				if (response['status'] == 'invalid-code') {
					form2.find('button').removeAttr('disabled');
					invalid_authorization_code();
				} else if (response['status'] == 'email-already-in-use') {
					Swal.fire({
						title: _t['You already have an account. Please login using your email and password.'],
						icon: 'info',
						confirmButtonText: _t['Ok']
					});
					form2.find('button').removeAttr('disabled');
					$('#account-login').show();
					$('#create-account').hide();
					$(window).resize();
				} else if (response['status'] == 'account-created') {
					window.location.reload();
				}
			}).fail(function (e) {
				form2.find('button').removeAttr('disabled');
				error_occurred(e);
			});;
		}

		e.preventDefault();
		return false;
	});
}

function init_login() {
	$('#account-login').show();
	$(window).resize();

	window.receive_login_to_make_a_payments_account = function (response) {
		if (response[0]['status'] == 'invalid-code') {
			invalid_authorization_code();
		} else {
			var auth_response = response;
			var verifications = response[0]['data']['verifications'];

			$('#account-login').hide();

			if (response[0]['data']['canCreateAccount'] == 1 && (!verifications || verifications < 2)) {
				$('#verify-identity input[name="st"]').val(response[0]['st']);
				$('#verify-identity').show();

				$('#verify-identity form').off('submit').on('submit', function (e) {
					var _$$find$val$split = $(this).find('[name=dateOfBirth]').val().split('/'),
					    _$$find$val$split2 = _slicedToArray(_$$find$val$split, 3),
					    m = _$$find$val$split2[0],
					    d = _$$find$val$split2[1],
					    y = _$$find$val$split2[2];

					var form = $(this);
					var verificationData = {
						firstName: $(this).find('[name=firstName]').val().trim(),
						lastName: $(this).find('[name=lastName]').val().trim(),
						ssnLast4: $(this).find('[name=ssnLast4]').val().trim(),
						dateOfBirth: y + '-' + m + '-' + d,
						st: $(this).find('[name=st]').val()
					};

					form.find('button').attr('disabled', 'disabled');

					$.ajax({
						url: localeUrlPath + '/accounts/verify-identity-from-authorization',
						type: 'post',
						data: verificationData,
						dataType: 'json'
					}).done(function (response) {
						$('#verify-identity').hide();
						form.find('button').removeAttr('disabled');
						if (response['status'] == 'success') {
							$('#create-account input[name="st"]').val(response['st']);
							init_create_account();
						} else {
							if (verifications) {
								verifications += 1;
							} else {
								verifications = 1;
							}

							$('#verify-identity').show();

							Swal.fire({
								title: _t['We are sorry! Your information does not match what we have on record.'],
								html: verifications > 1 ? '<p style="text-align:left">' + _t['For your protection, we cannot allow you to create an account. However, you can make a one-time payment.'] + '</p>' : null,
								confirmButtonText: _t['Try Again'],
								denyButtonText: _t['Make a one-time payment'],
								cancelButtonText: _t['request_help'],
								denyButtonColor: '#3085d6',
								cancelButtonColor: '#3085d6',
								showConfirmButton: verifications <= 1,
								showDenyButton: verifications > 1,
								showCancelButton: true,
								icon: 'info',
								width: '450px'
							}).then(function (response) {
								if (response.isDismissed) {
									request_help(_t['request_help'], '', 'question', _t['request_help'], _t['cancel'], function () {}, verificationData);

									if (verifications > 1) {
										$('#verify-identity').hide();
										init_guest_payment(auth_response[0]);
									}
								} else if (response.isDenied) {
									$('#verify-identity').hide();
									init_guest_payment(auth_response[0]);
								}
							});
						}
					}).fail(function (e) {
						error_occurred(e);
					});

					e.preventDefault();
					return false;
				});
			} else {
				init_guest_payment(auth_response[0]);
			}
		}
	};

	$('#login-panel form').on('submit', function (e) {
		var form = $(this);
		form.find('button').attr('disabled', 'disabled');
		$.ajax({
			url: localeUrlPath + '/login',
			type: 'post',
			data: $(this).serializeJSON(),
			dataType: 'json'
		}).done(function (response) {
			if (response.errorCode && response.errorCode == 'invalid_credentials') {
				form.find('button').removeAttr('disabled');
				Swal.fire({
					icon: 'warning',
					title: _t['Invalid email or password.'],
					confirmButtonText: _t['Reset Password'],
					cancelButtonText: _t['Try Again'],
					showCancelButton: true
				}).then(function (response) {
					if (response.isConfirmed) {
						reset_password();
					}
				});
			} else {
				$.getJSON('/current-user.json', function (response) {
					window.currentUser = response;
					init_account();
				});
			}
		}).fail(function (e) {
			error_occurred(e);
			form.find('button').removeAttr('disabled');
		});

		e.preventDefault();
		return false;
	});
}

function init_account() {
	$('#account-login').hide();
	$('#create-account').hide();

	window.scrollTo(0, 0);

	init_auto_logout();

	var account = new Vue({
		el: '#account',
		delimiters: ['${', '}'],
		data: function data() {
			return {
				user: currentUser,
				page: 'your-account',
				newCard: {
					fullName: '',
					number: '',
					month: '',
					year: '',
					code: '',
					zip: '',
					type: ''
				},
				errors: [],
				processing: false,
				mobileNavOpen: false,

				oneTimePaymentOptionsDefault: [{ "name": "dues", "label": _t["dues"], "value": "" }, { "name": "defense_fund_fee", "label": _t["defense_fund_fee"], "value": "" }],
				oneTimePaymentMethod: currentUser.dues.paymentMethods.length > 0 ? currentUser.dues.paymentMethods[0].uid : 'new',
				saveOneTimePaymentMethod: false,
				moreAutoPayInfo: false,
				enablingRecurringPayment: false,
				oneTimePaymentProcessed: null,

				recurringPaymentMethod: currentUser.dues.recurringPayment && currentUser.dues.recurringPayment.paymentMethodUid ? currentUser.dues.recurringPayment.paymentMethodUid : currentUser.dues.paymentMethods.length > 0 ? currentUser.dues.paymentMethods[0].uid : 'new',
				changingPaymentMethod: false,
				changingRecurringPaymentMethod: false,
				recurringPaymentProcessed: null,
				manualRecurringPaymentNextOn: 'today',

				addingAPaymentMethod: false,

				deletePaymentMethodAfterUpdatingAutoPay: null
			};
		},
		watch: {
			saveOneTimePaymentMethod: function saveOneTimePaymentMethod(val) {
				var data = this;

				if (this.page == 'one-time-payment' && !val && this.enablingRecurringPayment) {
					Swal.fire({
						title: _t['You must save your payment method to enable auto-pay.'],
						icon: 'info',
						confirmButtonText: _t['Ok, save payment method'],
						cancelButtonText: _t['No thanks'],
						showCancelButton: true
					}).then(function (response) {
						if (response.isConfirmed) {
							data.saveOneTimePaymentMethod = true;
						} else {
							data.enablingRecurringPayment = false;
						}
					});
				}

				if (this.page == 'one-time-payment' && val && this.user.dues.paymentMethods.length >= 10) {
					Swal.fire({
						title: _t['You cannot have more than 10 payment methods on file.'],
						html: '<p>' + _t['Please remove one payment method before adding another.'] + '</p>',
						icon: 'warning'
					});

					setTimeout(function () {
						data.saveOneTimePaymentMethod = false;
					}, 10);
				}
			},
			enablingRecurringPayment: function enablingRecurringPayment(val) {
				var data = this;

				if (this.page == 'one-time-payment' && val && this.oneTimePaymentMethod == 'new' && !this.saveOneTimePaymentMethod) {
					Swal.fire({
						title: _t['You must save your payment method to enable auto-pay.'],
						icon: 'info',
						confirmButtonText: _t['Ok, save payment method'],
						cancelButtonText: _t['No thanks'],
						showCancelButton: true
					}).then(function (response) {
						if (response.isConfirmed) {
							if (data.user.dues.paymentMethods.length >= 10) {
								Swal.fire({
									title: _t['You cannot have more than 10 payment methods on file.'],
									html: '<p>' + _t['Please remove one payment method before adding another.'] + '</p>',
									icon: 'warning'
								});

								data.enablingRecurringPayment = false;
							} else {
								data.saveOneTimePaymentMethod = true;
							}
						} else {
							data.enablingRecurringPayment = false;
						}
					});
				}
			},
			oneTimePaymentMethod: function oneTimePaymentMethod(val) {
				if (val == 'new' && this.user.dues.paymentMethods.length >= 10) {
					this.saveOneTimePaymentMethod = false;

					if (this.enablingRecurringPayment) {
						this.enablingRecurringPayment = false;

						Swal.fire({
							title: _t['You cannot have more than 10 payment methods on file.'],
							html: '<p>' + _t['If you want to turn on auto-pay with this one-time payment, ' + 'please choose a payment method you already have on file or remove one before adding another.'] + '</p>',
							icon: 'warning'
						});
					}
				}
			},
			recurringPaymentMethod: function recurringPaymentMethod(val, old_val) {
				var data = this;

				if (val == 'new' && this.user.dues.paymentMethods.length >= 10) {
					Swal.fire({
						title: _t['You cannot have more than 10 payment methods on file.'],
						html: '<p>' + _t['Please remove one payment method before adding another.'] + '</p>',
						icon: 'warning'
					});

					setTimeout(function () {
						data.recurringPaymentMethod = old_val;
					}, 10);
				}
			},
			addingAPaymentMethod: function addingAPaymentMethod(val) {
				if (this.user.dues.paymentMethods.length >= 10) {
					Swal.fire({
						title: _t['You cannot have more than 10 payment methods on file.'],
						html: '<p>' + _t['Please remove one payment method before adding another.'] + '</p>',
						icon: 'warning'
					});

					this.addingAPaymentMethod = false;
				}
			}
		},
		computed: {
			todayNextMonth: function todayNextMonth() {
				return moment().add(1, 'M').format('YYYY-MM-DD');
			},
			recurringMonthlyTotal: function recurringMonthlyTotal() {
				return currency(this.user.dues.amountMonthlyDues).add(this.user.dues.amountMonthlyDefense).toString();
			},
			recurringPaymentEnabled: function recurringPaymentEnabled() {
				return this.user.dues.recurringPayment && this.user.dues.recurringPayment.status == 'active';
			},
			oneTimePaymentOptions: function oneTimePaymentOptions() {
				return this.user.dues.oneTimePaymentOptions || this.oneTimePaymentOptionsDefault;
			},
			oneTimePaymentTotal: function oneTimePaymentTotal() {
				var total = currency(0);
				for (var i in this.oneTimePaymentOptions) {
					total = total.add(this.oneTimePaymentOptions[i].value);
				}
				return total.toString();
			},
			activePageTitle: function activePageTitle() {
				if (this.page == 'your-account') {
					return _t['Your Account'];
				} else if (this.page == 'one-time-payment') {
					return _t['One-Time Payment'];
				} else if (this.page == 'auto-pay') {
					return _t['Auto-Pay'];
				} else if (this.page == 'payment-methods') {
					return _t['Payment Methods'];
				}
			}
		},
		methods: {
			goToPage: function goToPage(val) {
				window.scrollTo({ top: 0 });
				this.page = val;
				this.mobileNavOpen = false;
			},

			changePassword: function changePassword() {
				Swal.fire({
					title: _t["Change Your Password"],
					html: '<div style="text-align:left">' + '<br/><label>' + _t['New password:'] + '</label>' + '<input required="required" id="newPassword2" type="password" class="swal2-input" required>' + '<small class="help-block">' + _t['Must be at least 8 characters long and include letters and numbers'] + '</small>' + '<label>' + _t['Retype new password:'] + '</label>' + '<input required="required" id="newPasswordConfirmation2" type="password" class="swal2-input" required><br/>' + '</div>',
					icon: 'question',
					confirmButtonText: _t['Save'],
					cancelButtonText: _t['cancel'],
					showCancelButton: true,
					preConfirm: function preConfirm() {
						if (!$('#newPassword2').val().match(passwordRegex)) {
							Swal.showValidationMessage(_t['Must be at least 8 characters long and include letters and numbers']);
							return false;
						} else if ($('#newPassword2').val() != $('#newPasswordConfirmation2').val()) {
							Swal.showValidationMessage(_t['New password and Retype new password must match.']);
							return false;
						} else {
							return {
								'newPassword': $('#newPassword2').val()
							};
						}
					}
				}).then(function (response) {
					if (response.isConfirmed) {
						$.ajax({
							url: localeUrlPath + '/accounts/set-password',
							type: 'post',
							data: {
								newPassword: response.value['newPassword']
							},
							dataType: 'json'
						}).done(function (response) {
							Swal.fire({ title: _t['Your password was changed successfully.'], icon: 'success' });
						}).fail(function (e) {
							error_occurred(e);
							data.processing = false;
						});
					}
				});
			},

			processOneTimePayment: function processOneTimePayment() {
				this.processing = true;

				for (var i in this.oneTimePaymentOptions) {
					if (parseFloat(this.oneTimePaymentOptions[i]['value']) > 2000.0) {
						Swal.fire({ title: _t['A single payment cannot have an amount greater than $2,000. If you want to pay more than $2,000 in total, you can break it up into separate payments of less than $2,000 each.'], icon: 'info' });
						this.processing = false;
						return;
					}
				}

				if (parseFloat(this.oneTimePaymentTotal) <= 0.0) {
					Swal.fire({ title: _t['Total must be more than $0.00'], icon: 'info' });
					this.processing = false;
				} else if (this.oneTimePaymentMethod == '') {
					Swal.fire({ title: _t['Please provide a payment method.'], icon: 'info' });
					this.processing = false;
				} else if (this.oneTimePaymentMethod != 'new') {
					process_one_time_payment(this);
				} else if (this.saveOneTimePaymentMethod) {
					save_payment_method(this, process_one_time_payment);
				} else {
					send_payment_method_to_authnet(this, process_one_time_payment);
				}
			},


			enableRecurringPayment: function enableRecurringPayment() {
				this.processing = true;

				if (this.recurringPaymentMethod == 'new') {
					save_payment_method(this, create_recurring_payment);
				} else {
					create_recurring_payment(this);
				}
			},

			cancelRecurringPayment: function cancelRecurringPayment() {
				var data = this;

				Swal.fire({
					title: _t['Are you sure you want to turn off auto-pay?'],
					icon: 'question',
					confirmButtonText: _t['Turn off auto-pay'],
					cancelButtonText: _t['Keep auto-pay on'],
					showCancelButton: true
				}).then(function (response) {
					if (response.isConfirmed) {
						data.processing = true;
						cancel_recurring_payment(data);
					}
				});
			},

			updateRecuringPayment: function updateRecuringPayment() {
				var data = this;

				this.processing = true;

				if (this.recurringPaymentMethod == 'new') {
					save_payment_method(this, update_recurring_payment);
				} else {
					update_recurring_payment(this);
				}

				if (this.deletePaymentMethodAfterUpdatingAutoPay) {
					/* If the user decided to keep the same payment method for auto-pay,
     	don't delete it and mark it as active */
					if (this.recurringPaymentMethod == this.deletePaymentMethodAfterUpdatingAutoPay.uid) {
						data.deletePaymentMethodAfterUpdatingAutoPay.status = 'active';
					} else {
						this.deletePaymentMethodAfterUpdatingAutoPay.status = 'processing';

						delete_payment_method(data, this.deletePaymentMethodAfterUpdatingAutoPay, function () {
							data.deletePaymentMethodAfterUpdatingAutoPay = null;
						});
					}
				}
			},

			savePaymentMethod: function savePaymentMethod() {
				this.processing = true;

				save_payment_method(this, function (data) {
					window.scrollTo({ top: 0 });
					data.processing = false;
					data.addingAPaymentMethod = false;
					data.newCard = {
						fullName: '',
						number: '',
						month: '',
						year: '',
						code: '',
						zip: '',
						type: ''
					};
				});
			},

			usePaymentMethodForAutoPay: function usePaymentMethodForAutoPay(paymentMethod) {
				paymentMethod.status = 'processing';
				this.recurringPaymentMethod = paymentMethod.uid;
				update_recurring_payment(this, function () {
					paymentMethod.status = 'active';
				});
			},

			deletePaymentMethod: function deletePaymentMethod(paymentMethod) {
				paymentMethod.status = 'processing';

				var data = this;

				Swal.fire({
					title: _t['Are you sure you want remove this payment method?'],
					icon: 'question',
					confirmButtonText: _t['Remove payment method'],
					cancelButtonText: _t['cancel'],
					showCancelButton: true
				}).then(function (response) {
					if (response.isConfirmed) {
						if (data.recurringPaymentEnabled && data.user.dues.recurringPayment.paymentMethodUid == paymentMethod.uid) {
							Swal.fire({
								title: _t['This payment method is used by auto-pay.'],
								html: '<p>' + _t['To delete this payment method you must first choose an alternate payment method for auto-pay, or you can turn off auto-pay.'] + '</p>',
								icon: 'question',
								confirmButtonText: _t['Use another payment method'],
								denyButtonText: _t['Turn off auto-pay'],
								cancelButtonText: _t['cancel'],
								denyButtonColor: '#3085d6',
								showCancelButton: true,
								showDenyButton: true,
								width: '450px'
							}).then(function (response) {
								if (response.isConfirmed) {
									data.changingRecurringPaymentMethod = true;
									data.goToPage('auto-pay');
									data.deletePaymentMethodAfterUpdatingAutoPay = paymentMethod;
									data.recurringPaymentMethod = null;
								} else if (response.isDenied) {
									data.processing = true;
									cancel_recurring_payment(data, function () {
										delete_payment_method(data, paymentMethod);
									});
								} else {
									paymentMethod.status = 'active';
								}
							});
						} else {
							delete_payment_method(data, paymentMethod);
						}
					} else {
						paymentMethod.status = 'active';
					}
				});
			},

			requestHelp: function requestHelp() {
				request_help_with_account();
			},

			isActivePage: function isActivePage(val) {
				return this.page == val;
			},

			cardChanged: function cardChanged(type) {
				this.newCard.type = type;
			},

			isActiveCardType: function isActiveCardType(val) {
				return this.newCard.type == val;
			}
		},
		filters: {
			currency: function (_currency) {
				function currency(_x) {
					return _currency.apply(this, arguments);
				}

				currency.toString = function () {
					return _currency.toString();
				};

				return currency;
			}(function (val) {
				return currency(val).format();
			}),
			date: function date(val) {
				if (val.includes(':')) {
					return moment(val + 'Z').format(_t['date_format_js']);
					/* If it is just a date without a time, don't force UTC */
				} else {
					return moment(val).format(_t['date_format_js']);
				}
			},
			datetime: function datetime(val) {
				return moment(val + 'Z').format(_t['datetime_format_js']);
			},
			time: function time(val) {
				return moment(val + 'Z').format(_t['time_format_js']);
			},
			t: function t(val) {
				return _t[val];
			},
			pmType: function pmType(val) {
				return card_types(val);
			}
		},
		mounted: function mounted() {
			if (params.get('a') == 'update-payment-method') {
				this.goToPage('payment-method');
			} else if (params.get('a') == 'auto-pay') {
				this.goToPage('auto-pay');
			} else if (this.user.dues.oneTimePaymentOptions) {
				this.goToPage('one-time-payment');
			}
		}
	});

	$('#account').show();
}

function init_auto_logout() {
	var timoutWarning = 9 * 60 * 1000; // 9 minutes
	var timeoutNow = 1 * 60 * 1000; // 1 minute

	var warningTimer;
	var timeoutTimer;

	function start_warning_timer() {
		warningTimer = setTimeout(show_warning, timoutWarning);
		$(window).on('mousemove mousedown touchstart click keypress', reset_warning_timer);
	}

	function stop_warning_timer() {
		clearTimeout(warningTimer);
		$(window).off('mousemove mousedown touchstart click keypress', reset_warning_timer);
	}

	function start_timeout_timer() {
		timeoutTimer = setTimeout(logout, timeoutNow);
	}

	function stop_timeout_timer() {
		clearTimeout(timeoutTimer);
	}

	function reset_warning_timer() {
		stop_warning_timer();
		start_warning_timer();
	}

	function show_warning() {
		stop_warning_timer();
		start_timeout_timer();

		Swal.fire({
			title: _t['Are you still there?'],
			html: '<p>' + _t['Your session will expire soon.'] + '</p>',
			icon: 'warning',
			confirmButtonText: _t["I'm still here"],
			cancelButtonText: _t['Logout now'],
			showCancelButton: true
		}).then(function (response) {
			if (response.isConfirmed) {
				stop_timeout_timer();
				$.getJSON('/current-user.json', function () {
					start_warning_timer();
				}).fail(function (e) {
					logout();
				});
			} else {
				logout();
			}
		});
	}

	function logout() {
		window.location = localeUrlPath + '/logout?redirect=' + localeUrlPath + '/payments';
	}

	start_warning_timer();
}

function create_recurring_payment(data) {
	var paymentMethod = null;
	var nextOn = null;

	if (data.page == 'one-time-payment' && data.oneTimePaymentMethod == 'new' || data.page == 'auto-pay' && data.recurringPaymentMethod == 'new') {
		paymentMethod = data.user.dues.paymentMethods[0].uid;
		nextOn = moment().add(1, 'M').format('YYYY-MM-DD');
	} else if (data.page == 'one-time-payment') {
		paymentMethod = data.oneTimePaymentMethod;
		nextOn = moment().add(1, 'M').format('YYYY-MM-DD');
	} else if (data.page == 'auto-pay') {
		paymentMethod = data.recurringPaymentMethod;

		if (data.manualRecurringPaymentNextOn == 'today') {
			nextOn = 'today';
		} else {
			nextOn = moment().add(1, 'M').format('YYYY-MM-DD');
		}
	}

	$.ajax({
		url: localeUrlPath + '/accounts/recurring-payments/create',
		type: 'post',
		data: {
			amount: data.recurringMonthlyTotal,
			paymentMethod: paymentMethod,
			nextOn: nextOn,
			options: [{
				"name": "dues",
				"label": _t['dues'],
				"value": data.user.dues.amountMonthlyDues
			}, {
				"name": "defense_fund_fee",
				"label": _t['defense_fund_fee'],
				"value": data.user.dues.amountMonthlyDefense
			}]
		},
		dataType: 'json'
	}).done(function (response) {
		window.scrollTo({ top: 0 });

		if (response['payment']) {
			if (response['payment']['status'] != 'captured') {
				Swal.fire({
					title: _t['Your payment was declined.'],
					html: '<p>' + _t['Is your payment method valid?'] + '</p>',
					icon: 'warning',
					confirmButtonText: _t['Change Payment Method'],
					cancelButtonText: _t['Try Again'],
					showCancelButton: true
				}).then(function (response) {
					if (response.isConfirmed) {
						data.oneTimePaymentMethod = 'new';
					}
				});
			} else {
				data.recurringPaymentProcessed = response['payment'];
				data.recurringPaymentProcessed['options'] = JSON.parse(response['payment']['options']);
				data.recurringPaymentProcessed['capturedAt'] = data.recurringPaymentProcessed['capturedAt'];
				data.enablingRecurringPayment = false;

				Object.assign(data.newCard, {
					fullName: '',
					number: '',
					month: '',
					year: '',
					code: '',
					zip: '',
					type: ''
				});

				data.user.dues.recurringPayment = response['recurringPayment'];
			}
		} else {
			Object.assign(data.newCard, {
				fullName: '',
				number: '',
				month: '',
				year: '',
				code: '',
				zip: '',
				type: ''
			});

			data.user.dues.recurringPayment = response['recurringPayment'];
			data.enablingRecurringPayment = false;
			data.recurringPaymentProcessed = null;
		}

		data.processing = false;
	}).fail(function (e) {
		error_occurred(e);
		data.processing = false;
	});
}

function update_recurring_payment(data, callback) {
	$.ajax({
		url: localeUrlPath + '/accounts/recurring-payments/update',
		type: 'post',
		data: {
			paymentMethod: data.recurringPaymentMethod == 'new' ? data.user.dues.paymentMethods[0].uid : data.recurringPaymentMethod
		},
		dataType: 'json'
	}).done(function (response) {
		Object.assign(data.newCard, {
			fullName: '',
			number: '',
			month: '',
			year: '',
			code: '',
			zip: '',
			type: ''
		});

		data.changingRecurringPaymentMethod = false;
		data.user.dues.recurringPayment = response['recurringPayment'];
		data.processing = false;

		if (callback) {
			callback();
		}
	}).fail(function (e) {
		error_occurred(e);
		data.processing = false;
	});
}

function cancel_recurring_payment(data, callback) {
	$.ajax({
		url: localeUrlPath + '/accounts/recurring-payments/cancel',
		type: 'post',
		data: {
			uid: data.user.dues.recurringPayment.uid
		},
		dataType: 'json'
	}).done(function (response) {
		Object.assign(data.newCard, {
			fullName: '',
			number: '',
			month: '',
			year: '',
			code: '',
			zip: '',
			type: ''
		});
		data.user.dues.recurringPayment = response['recurringPayment'];
		data.processing = false;

		if (callback) {
			callback();
		}
	}).fail(function (e) {
		error_occurred(e);
		data.processing = false;
	});
}

function save_payment_method(data, callback) {
	if (data.user.dues.paymentMethods.length >= 10) {
		Swal.fire({
			title: _t['You cannot have more than 10 payment methods on file.'],
			html: '<p>' + _t['Please remove one payment method before adding another.'] + '</p>',
			icon: 'warning',
			confirmButtonText: _t['Ok']
		});
	} else {
		send_payment_method_to_authnet(data, function (data, response) {
			$.ajax({
				url: localeUrlPath + '/accounts/payment-methods/create',
				type: 'post',
				data: {
					gatewayData: response,
					paymentMethodType: data.newCard.type,
					paymentMethodDescription: data.newCard.fullName + ', ' + card_types(data.newCard.type) + ' ' + _t['ending in'] + ' ' + data.newCard.number.substring(data.newCard.number.length - 4),
					paymentMethodFullName: data.newCard.fullName,
					paymentMethodExpiresMM: data.newCard.month,
					paymentMethodExpiresYY: data.newCard.year
				},
				dataType: 'json'
			}).done(function (response) {
				data.user.dues.paymentMethods = response['paymentMethods'];
				data.oneTimePaymentMethod = response['paymentMethods'][0].uid;

				if (callback) {
					callback(data);
				}
			}).fail(function (e) {
				error_occurred(e);
				data.processing = false;
			});
		});
	}
}

function send_payment_method_to_authnet(data, callback) {
	var secureData = {
		authData: {
			apiLoginID: ANET_LOGIN_ID,
			clientKey: ANET_CLIENT_KEY
		},
		cardData: {
			cardNumber: data.newCard.number.replace(/ /g, ''),
			month: data.newCard.month,
			year: data.newCard.year,
			cardCode: data.newCard.code,
			fullName: data.newCard.fullName,
			zip: data.newCard.zip
		}
	};

	var c = Accept.dispatchData(secureData, function (response) {
		if (response['messages']['resultCode'] == 'Error') {
			var code = response['messages']['message'][0]['code'];
			if (code == 'E_WC_05') {
				Swal.fire({ title: _t['invalid_card_number'], icon: 'warning' });
			} else if (code == 'E_WC_15') {
				Swal.fire({ title: _t['invalid_ccv'], icon: 'warning' });
			} else if (code == 'E_WC_16') {
				Swal.fire({ title: _t['invalid_zip'], icon: 'warning' });
			} else if (code == 'E_WC_06') {
				Swal.fire({ title: _t['invalid_exp_month'], icon: 'warning' });
			} else if (code == 'E_WC_07' && code == 'E_WC_08') {
				Swal.fire({ title: _t['invalid_exp_year'], icon: 'warning' });
			} else if (code == 'E_WC_17') {
				Swal.fire({ title: _t['invalid_card_holder'], icon: 'warning' });
			} else {
				Swal.fire({ title: _t['payment_failed'], icon: 'warning' });
			}
			data.processing = false;
		} else {
			if (callback) {
				callback(data, response);
			}
		}
	});
}

function delete_payment_method(data, paymentMethod, callback) {
	$.ajax({
		url: localeUrlPath + '/accounts/payment-methods/delete',
		type: 'post',
		data: {
			uid: paymentMethod.uid
		},
		dataType: 'json'
	}).done(function (response) {
		data.user.dues.paymentMethods = response['paymentMethods'];

		if (data.oneTimePaymentMethod == paymentMethod.uid) {
			if (data.user.dues.paymentMethods.length > 0) {
				data.oneTimePaymentMethod = data.user.dues.paymentMethods[0].uid;
			} else {
				data.oneTimePaymentMethod = 'new';
			}
		}

		if (data.recurringPaymentMethod == paymentMethod.uid) {
			if (data.user.dues.paymentMethods.length > 0) {
				data.recurringPaymentMethod = data.user.dues.paymentMethods[0].uid;
			} else {
				data.recurringPaymentMethod = 'new';
			}
		}

		if (callback) {
			callback();
		}
	}).fail(function (e) {
		error_occurred(e);
		paymentMethod.status = 'active';
	});
}

function process_one_time_payment(data, gatewayData) {
	$.ajax({
		url: localeUrlPath + '/accounts/payments/process',
		type: 'post',
		data: {
			amount: data.oneTimePaymentTotal,
			options: data.oneTimePaymentOptions,
			paymentMethod: data.oneTimePaymentMethod,
			newPaymentMethod: {
				gatewayData: gatewayData,
				description: data.newCard.fullName + ', ' + card_types(data.newCard.type) + ' ' + _t['ending in'] + ' ' + data.newCard.number.substring(data.newCard.number.length - 4)
			},
			existingPaymentMethod: {
				uid: data.user.dues.paymentMethodUid
			}
		},
		dataType: 'json'
	}).done(function (response) {
		data.processing = false;

		if (response['status'] == 'declined') {
			Swal.fire({
				title: _t['Your payment was declined.'],
				html: '<p>' + _t['Is your payment method valid?'] + '</p>',
				icon: 'warning',
				confirmButtonText: _t['Change Payment Method'],
				cancelButtonText: _t['Try Again'],
				showCancelButton: true
			}).then(function (response) {
				if (response.isConfirmed) {
					data.oneTimePaymentMethod = 'new';
				}
			});
		} else if (response['status'] == 'invalid-total') {
			Swal.fire({ title: _t['Total must be more than $0.00'], icon: 'info' });
		} else if (response['status'] == 'invalid-amounts') {
			Swal.fire({ title: _t['A single payment cannot have an amount greater than $2,000. If you want to pay more than $2,000 in total, you can break it up into separate payments of less than $2,000 each.'], icon: 'info' });
		} else if (response['status'] == 'amounts-total-mismatch') {
			error_occurred(e);
		} else {
			window.scrollTo({ top: 0 });

			data.oneTimePaymentProcessed = response['payment'];
			data.oneTimePaymentProcessed['capturedAt'] = data.oneTimePaymentProcessed['capturedAt'];
			data.oneTimePaymentProcessed['options'] = JSON.parse(response['payment']['options']);

			if (data.oneTimePaymentMethod == 'new' && data.saveOneTimePaymentMethod) {
				data.oneTimePaymentMethod = data.user.dues.paymentMethods[0].uid;
				data.changingPaymentMethod = false;
			}

			Object.assign(data.newCard, {
				fullName: '',
				number: '',
				month: '',
				year: '',
				code: '',
				zip: '',
				type: ''
			});

			data.user.dues.oneTimePaymentOptions = null;

			if (data.enablingRecurringPayment) {
				create_recurring_payment(data);
			}
		}
	}).fail(function (e) {
		error_occurred(e);
		data.processing = false;
	});
}

function card_types(type) {
	if (type == 'visa') {
		return 'Visa';
	} else if (type == 'amex') {
		return 'American Express';
	} else if (type == 'jcb') {
		return 'JCB';
	} else if (type == 'mastercard') {
		return 'Mastercard';
	} else if (type == 'discover') {
		return 'Discover';
	}

	return '';
};

function error_occurred(response) {
	if (response.status == '403') {
		$('#account').hide();
		Swal.fire({
			title: _t['session_timeout'],
			icon: 'info'
		}).then(function () {
			$('#account-loader').show();
			window.location.reload();
		});
	} else {
		Swal.fire({ title: _t['error_occurred'], icon: 'error' });
	}
}

function init_guest_payment(response) {
	var amounts = response['data']['amounts'];
	var name, label, value;

	var credit_card_type = '';
	var cleave_card = new Cleave('#cardNumber', {
		creditCard: true,
		onCreditCardTypeChanged: function onCreditCardTypeChanged(type) {
			credit_card_type = type;

			$('.input-group-addon.cc-icons span').removeClass('selected');
			$('.input-group-addon.cc-icons .fa-cc-' + type).addClass('selected');

			if (type == 'amex') {
				$('#cardCode').attr('minlength', 4);
				$('#cardCode').attr('maxlength', 4);
				$('#cardCode').attr('placeholder', '••••');
			} else {
				$('#cardCode').attr('minlength', 3);
				$('#cardCode').attr('maxlength', 3);
				$('#cardCode').attr('placeholder', '•••');
			}
		}
	});

	$('#st').val(response['st']);

	$('.firstName').html(response['data']['firstName']);

	for (var i in amounts) {
		name = amounts[i]['name'];
		label = amounts[i]['label'];
		value = amounts[i]['value'];
		$('#amounts').append('\n            <div class="form-group">\n                <input type="hidden" name="options[' + i + '][name]" value="' + name + '" />\n                <input type="hidden" name="options[' + i + '][label]" value="' + _t[name] + '" />\n                <label for="amount_' + name + '">' + _t[name] + '</label>\n                <div class="input-group">\n                    <div class="input-group-addon">$</div>\n                    <input type="number" step="0.01" class="form-control"\n                        name="options[' + i + '][value]" id="amount_' + name + '"\n                        value="' + currency(value).toString() + '" data-init-val="' + currency(value).toString() + '">\n                    <div class="input-group-addon reset" style="display:none">\n                        <a href="#"  data-id="amount_' + name + '" class="btn btn-primary">\n                        ' + _t['reset_to'] + ' ' + currency(value).format() + '</a>\n                    </div>\n                </div>\n            </div>\n        ');
	}

	$('.input-group-addon.reset a').on('click', function (e) {
		var input = $('#' + $(this).data('id'));
		input.val(input.data('init-val'));
		calc_total();
		e.preventDefault();
		return false;
	});

	function calc_total() {
		var total = currency(0);

		$('#amounts input').each(function (i, e) {
			total = total.add(currency($(e).val()));

			if (currency($(this).val()).toString() == currency($(this).data('init-val')).toString()) {
				$(this).siblings('.reset').hide();
			} else {
				$(this).siblings('.reset').show();
			}
		});

		$('.amount').html(currency(total).format());
		$('#amount').val(total.toString());
	}

	$('body').on('keyup change', '#amounts input', function () {
		setTimeout(calc_total, 10);
	});
	$('#amounts input').first().change();

	var errorShowing = false;
	$('#fullName, #cardNumber, #cardMonth, #cardYear, #cardCode, #zip, #email').on('invalid', function (e) {
		errorShowing = true;
	}).on("keydown", function (e) {
		var $input = $(this);

		// If not the ENTER key
		if (e.which != 13) {
			if (!errorShowing) {
				return;
			}

			setTimeout(function () {
				$input.blur();
				$input.focus();
			});

			errorShowing = false;
		}
	});

	$('#guest-payment-login').hide();
	$('#guest-payment').show();

	var processed = false;

	$('#guest-payment form').on('submit', function (e) {
		e.preventDefault();

		/* Don't allow the payment to be successfuly processed more than one time. */
		if (processed) {
			return false;
		}

		processed = true;

		var authData = {};
		authData.apiLoginID = ANET_LOGIN_ID;
		authData.clientKey = ANET_CLIENT_KEY;
		var cardData = {};
		cardData.cardNumber = $('#cardNumber').val().replace(/ /g, '');
		cardData.month = $('#cardMonth').val();
		cardData.year = $('#cardYear').val();
		cardData.cardCode = $('#cardCode').val();
		cardData.fullName = $('#fullName').val();
		cardData.zip = $('#zip').val();
		var secureData = {};
		secureData.authData = authData;
		secureData.cardData = cardData;

		$('#submit-payment').html('Processing...').attr('disabled', 'disabled');

		if (currency($('#amount').val()) <= 0.0) {
			processed = false;
			return validation_error(_t['invalid_amount']);
		}

		var form_serialized = $('#guest-payment form').serializeJSON();
		for (var i in form_serialized['options']) {
			if (parseFloat(form_serialized['options'][i]['value']) > 2000.0) {
				processed = false;
				return validation_error(_t['A single payment cannot have an amount greater than $2,000. If you want to pay more than $2,000 in total, you can break it up into separate payments of less than $2,000 each.']);
			}
		}

		if ($('#cardMonth').val().length != 2) {
			processed = false;
			return validation_error(_t['invalid_exp_month']);
		}

		if ($('#cardYear').val().length != 2) {
			processed = false;
			return validation_error(_t['invalid_exp_year']);
		}

		if ($('#email').val().trim() == '') {
			processed = false;
			return validation_error(_t['email_required']);
		}

		(function () {
			Accept.dispatchData(secureData, function (response) {
				if (response['messages']['resultCode'] == 'Ok') {
					var paymentMethodDescription = cardData.fullName + ', ' + cardData.cardNumber.substr(12);

					$('#paymentMethodDescription').val(paymentMethodDescription);
					$('#paymentMethodExpiresMM').val($('#cardMonth').val());
					$('#paymentMethodExpiresYY').val($('#cardYear').val());
					$('#gatewayResponse').val(JSON.stringify(response));

					$.ajax({
						url: localeUrlPath + '/guest-payments/process',
						type: 'post',
						data: $('#guest-payment form').serializeJSON(),
						dataType: 'json'
					}).done(function (response) {
						var i;

						if (response['status'] == 'invalid-amounts') {
							processed = false;
							Swal.fire({ title: _t['A single payment cannot have an amount greater than $2,000. If you want to pay more than $2,000 in total, you can break it up into separate payments of less than $2,000 each.'], icon: 'info' });
						} else if (response['status'] == 'amounts-total-mismatch') {
							processed = false;
							Swal.fire({
								title: _t['error_occurred'],
								icon: 'error'
							});
						} else if (response['status'] == 'invalid-code') {
							processed = false;
							invalid_code();
						} else if (response['status'] == 'captured') {
							var payment = response['payment'];
							var options = JSON.parse(payment['options']);

							$('#gatewayResponse').val('');
							$('#guest-payment').hide();
							$('#payment-processed').show();
							$('#payment-processed #payment-reference').html(payment['reference']);
							$('#payment-processed .email').html(payment['email']);
							$('#payment-processed .datePaid').html(utc2local(payment['capturedAt']).format('LL'));
							$('#payment-processed .timePaid').html(utc2local(payment['capturedAt']).format('h:mm a'));
							$('#payment-processed .memberName').html(payment['firstName'] + ' ' + payment['lastName']);
							$('#payment-processed .payment-method-used').html(payment['paymentMethodDescription']);

							for (i in options) {
								$('#payment-processed #amounts').append('\n                                    <div class="col-md-8 col-xs-8"><strong>' + options[i]['label'] + ':</strong></div>\n                                    <div class="col-md-4 col-xs-4 text-right">' + currency(options[i]['value']).format() + '</div>\n                                ');
							}

							$('#payment-processed .amountPaid').html(currency(payment['amount']).format());

							window.scrollTo(0, 0);
						} else {
							processed = false;
							payment_method_failed();
						}

						$('#submit-payment').removeAttr('disabled').html(_t['submit_payment']);
					}).fail(function () {
						processed = false;
						Swal.fire({
							title: _t['error_occurred'],
							icon: 'error'
						});
						$('#submit-payment').removeAttr('disabled').html(_t['submit_payment']);
					});
				} else {
					processed = false;
					payment_method_failed(response['messages']['message'][0]['code']);
				}
			});
		})();

		e.preventDefault();
		return false;
	});
}

function payment_method_failed(code) {
	if (code == 'E_WC_05') {
		Swal.fire({ title: _t['invalid_card_number'], icon: 'warning' });
	} else if (code == 'E_WC_15') {
		Swal.fire({ title: _t['invalid_ccv'], icon: 'warning' });
	} else if (code == 'E_WC_16') {
		Swal.fire({ title: _t['invalid_zip'], icon: 'warning' });
	} else if (code == 'E_WC_06') {
		Swal.fire({ title: _t['invalid_exp_month'], icon: 'warning' });
	} else if (code == 'E_WC_07') {
		Swal.fire({ title: _t['invalid_exp_year'], icon: 'warning' });
	} else if (code == 'E_WC_17') {
		Swal.fire({ title: _t['invalid_card_holder'], icon: 'warning' });
	} else {
		Swal.fire({ title: _t['payment_failed'], icon: 'warning' });
	}

	$('#submit-payment').removeAttr('disabled').html(_t['submit_payment']);
}

function validation_error(message) {
	Swal.fire({ title: message, icon: 'warning' });
	$('#submit-payment').removeAttr('disabled').html(_t['submit_payment']);
	return false;
}

},{}],3:[function(require,module,exports){
'use strict';

require('./timezones');

require('./request-help');

require('./request-help-hire');

require('./request-help-nu-workers');

require('./request-help-with-account');

require('./scroll-to-anchor');

require('./autoexpand-textarea');

require('./share');

require('./carousel');

require('./equal-heights');

require('./header');

require('./media-grid');

require('./tableofcontents');

require('./tiles');

require('./top-story-omission');

require('./book-union');

require('./authorization-codes');

require('./guest-payment');

require('./union-comparison-survey');

require('./form-entry-files');

require('./account-payments');

require('./hire');

require('./dashboard');

require('./login');

require('./login-nu-workers');

require('./login-htc-staff');

require('./mildred-grossman-gallery');

require('./gallery');

require('./viewport-height-fix');

require('./crsf-token');

require('./bootstrap-toc');

require('./cleave');

require('./next-up');

},{"./account-payments":2,"./authorization-codes":4,"./autoexpand-textarea":5,"./book-union":6,"./bootstrap-toc":7,"./carousel":8,"./cleave":9,"./crsf-token":10,"./dashboard":11,"./equal-heights":12,"./form-entry-files":13,"./gallery":14,"./guest-payment":15,"./header":16,"./hire":17,"./login":20,"./login-htc-staff":18,"./login-nu-workers":19,"./media-grid":21,"./mildred-grossman-gallery":22,"./next-up":23,"./request-help":27,"./request-help-hire":24,"./request-help-nu-workers":25,"./request-help-with-account":26,"./scroll-to-anchor":28,"./share":29,"./tableofcontents":30,"./tiles":31,"./timezones":32,"./top-story-omission":33,"./union-comparison-survey":34,"./viewport-height-fix":35}],4:[function(require,module,exports){
'use strict';

$(document).ready(function () {
	$('form.code-authorization').on('submit', function (e) {
		var form = $(this);
		var captchaToken = form.find('input[name="captchaToken"]');

		if (captchaToken.length > 0 && captchaToken.val() == '') {
			form.find('.g-recaptcha p.text-danger').remove();
			form.find('.g-recaptcha').append('<p class="text-danger">' + _t['Please verify that you are not a robot.'] + '</p>');
		} else {
			form.find('button[type="submit"]').attr('disabled', 'disabled');

			$.ajax({
				url: '/authorize',
				type: 'post',
				data: {
					captchaToken: form.find('input[name="captchaToken"]').val(),
					code: form.find('input[name="code"]').val(),
					scope: form.data('scope')
				}
			}).done(function (response) {
				window[form.data('callback')](arguments);
				form.find('button[type="submit"]').removeAttr('disabled');
			}).fail(function (response, responseText) {
				Swal.fire({
					title: 'An error occurred. Please refresh this page and try again.',
					icon: 'error'
				});
				form.find('button[type="submit"]').removeAttr('disabled');
			});
		}

		e.preventDefault;
		return false;
	});
});

window.authorize_code_and_then = function (code, scope, callback) {
	$.ajax({
		url: localeUrlPath + '/authorize',
		type: 'post',
		data: {
			code: code,
			scope: scope
		},
		dataType: 'json'
	}).done(function (response) {
		callback(response);
	});
};

},{}],5:[function(require,module,exports){
'use strict';

function autosize() {
  var el = this;
  setTimeout(function () {
    el.style.cssText = 'height:auto; padding:0';
    el.style.cssText = 'height:' + (el.scrollHeight + 15) + 'px';
  }, 0);
}

$(document).ready(function () {
  $('textarea').on('keydown', autosize);
});

},{}],6:[function(require,module,exports){
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

Handlebars.registerHelper('shopstatus', function (covid19Status, shopType, quarantineHotel) {
	if (quarantineHotel == 'DHS' || quarantineHotel == 'Homeless' || quarantineHotel == 'Migrants') {
		return '<span style="color:#8197da">Open, not to public</span>';
	} else if (covid19Status.toLowerCase() == 'open' || covid19Status.toLowerCase() == 'open-limited') {
		return '<span style="color:#2d52c2">Open</span>';
	} else {
		return '<span style="color:#aaa">Temporarily closed</span>';
	}
});

Handlebars.registerHelper('t', function (s) {
	return _t[s];
});

Handlebars.registerHelper('moment', function (datetime, format) {
	return moment(datetime).format(format);
});

Handlebars.registerHelper('ifEquals', function (arg1, arg2, options) {
	return arg1 == arg2 ? options.fn(this) : options.inverse(this);
});

$(document).ready(function () {
	var hotels = [];
	var book_union = $('#book-union');
	var book_union_map_element = $('#book-union #map');
	var book_union_map_object;
	var orig_url = { "title": document.title, "href": location.href.replace(/\#find-union-hotels.*/, "") };
	var map;
	var hotel_list_item_template;
	var hotel_detail_template;
	var current_filter_template;
	var book_union_markers = [];

	if (book_union.length == 0) {
		return;
	}

	var regions = {
		'NYC': [],
		'1 Manhattan': ['1_A Below Canal', '1_B Between Canal and 14th', '1_C Between 14th and 34th', '1_D Midtown East - Between 34th and 59th on East Side', '1_E Midtown West - Between 34th and 59th on the West Side', '1_F Upper East Side - Above 59th on East Side', '1_G Upper West Side - Above 59th on West Side', '1_H Times Square', '1_I Central Park'],
		'2 Bronx': [],
		'3 Brooklyn': [],
		'4 Queens': ['4_A JFK Airport', '4_B LaGuardia Airport'],
		'6 Westchester': [],
		'7 Upstate New York': ['7_A Albany', '7_B Saratoga', '7_C Catskills', '7_D Finger Lakes'],
		'8 New Jersey': ['8_A Central New Jersey', '8_B Northern New Jersey'],
		'9 Long Island': []
	};

	var nyc = ['1_A Below Canal', '1_B Between Canal and 14th', '1_C Between 14th and 34th', '1_D Midtown East - Between 34th and 59th on East Side', '1_E Midtown West - Between 34th and 59th on the West Side', '1_F Upper East Side - Above 59th on East Side', '1_G Upper West Side - Above 59th on West Side', '1_H Times Square', '1_I Central Park', '2 Bronx', '3 Brooklyn', '4 Queens', '4_A JFK Airport', '4_B LaGuardia Airport'];

	var regions_html = '<option value="">Region</option>';
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = Object.entries(regions)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _step$value = _slicedToArray(_step.value, 2),
			    region = _step$value[0],
			    sub_regions = _step$value[1];

			regions_html += '<option value="' + region + '">' + _t[region] + '</option>';

			for (var i in sub_regions) {
				regions_html += '<option value="' + sub_regions[i] + '">&nbsp;&nbsp&nbsp;&nbsp' + _t[sub_regions[i]] + '</option>';
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	$('#bu-location').html(regions_html);

	hotel_list_item_template = Handlebars.compile(document.getElementById("hotel-list-item-template").innerHTML);
	hotel_detail_template = Handlebars.compile(document.getElementById("hotel-detail-template").innerHTML);
	current_filter_template = Handlebars.compile(document.getElementById("current-filter-template").innerHTML);

	$(window).on('popstate', function (e) {
		var hash = window.location.hash.split('/');

		if (hash[0] == '#find-union-hotels') {
			maximize();
		} else {
			minimize();
		}
	});

	$('.fullscreen-toggle.open, [href~="#find-union-hotels"]').off('click').on('click', function (e) {
		e.preventDefault();
		maximize();
		history.pushState(null, "Find union Hotels | Hotel Trands Council, AFL-CIO", location.pathname + "#find-union-hotels");
		return false;
	});

	$('.fullscreen-toggle.close2').off('click').on('click', function (e) {
		e.preventDefault();
		minimize();
		history.pushState(null, orig_url['title'], orig_url['href']);
		return false;
	});

	$('#bu-name').on('change paste keyup', function () {
		load_map_and_listing(true);
		record_state();
	});

	$('#bu-location').on('change', function () {
		load_map_and_listing(true);
		record_state();
	});

	$('#book-union-controls').on('submit', function (e) {
		load_map_and_listing(true);
		record_state();
		e.preventDefault();
		return false;
	});

	book_union.find('.hotel-listing-map-toggle a').off('click').on('click', function (e) {
		if ($(this).hasClass('show-hotel-listing')) {
			list_mode();
		} else {
			map_mode();
		}
		e.preventDefault();
		return false;
	});

	function load_map_and_listing(fit_to_bounds) {
		var params2 = params();
		var results = filter_hotels(hotels, params2);
		var i, marker;

		while (marker = book_union_markers.shift()) {
			marker.setMap(null);
		}

		var icons = {
			"open": {
				path: "M0 -50c-8.284 0-15 6.656-15 14.866 0 8.211 15 35.135 15 35.135s15-26.924 15-35.135c0-8.21-6.716-14.866-15-14.866zm-.049 19.312c-2.557 0-4.629-2.055-4.629-4.588 0-2.535 2.072-4.589 4.629-4.589 2.559 0 4.631 2.054 4.631 4.589 0 2.533-2.072 4.588-4.631 4.588z",
				fillColor: "#2d52c2",
				fillOpacity: 1,
				strokeWeight: 1,
				strokeColor: "white",
				rotation: 0,
				scale: 0.75
			},
			"open-limited": {
				path: "M0 -50c-8.284 0-15 6.656-15 14.866 0 8.211 15 35.135 15 35.135s15-26.924 15-35.135c0-8.21-6.716-14.866-15-14.866zm-.049 19.312c-2.557 0-4.629-2.055-4.629-4.588 0-2.535 2.072-4.589 4.629-4.589 2.559 0 4.631 2.054 4.631 4.589 0 2.533-2.072 4.588-4.631 4.588z",
				fillColor: "#2d52c2",
				fillOpacity: 1,
				strokeWeight: 1,
				strokeColor: "white",
				rotation: 0,
				scale: 0.75
			},
			"closed": {
				path: "M0 -50c-8.284 0-15 6.656-15 14.866 0 8.211 15 35.135 15 35.135s15-26.924 15-35.135c0-8.21-6.716-14.866-15-14.866zm-.049 19.312c-2.557 0-4.629-2.055-4.629-4.588 0-2.535 2.072-4.589 4.629-4.589 2.559 0 4.631 2.054 4.631 4.589 0 2.533-2.072 4.588-4.631 4.588z",
				fillColor: "#aaa",
				fillOpacity: 1,
				strokeWeight: 1,
				strokeColor: "white",
				rotation: 0,
				scale: 0.75
			}
		};

		if (typeof google === 'undefined') {
			book_union_in_view(null, true);
			return;
		}

		var info_window = new google.maps.InfoWindow();
		var bounds = new google.maps.LatLngBounds();
		for (i in results) {
			var position = new google.maps.LatLng(results[i].latitude, results[i].longitude);
			var marker = new google.maps.Marker({
				position: position,
				map: book_union_map_object,
				html: results[i].detail_html,
				id: results[i].id,
				icon: icons[results[i].covid19Status]
			});
			marker.addListener('click', function () {
				info_window.setContent(this.html);
				info_window.open(map, this);
			});
			bounds.extend(marker.position);
			book_union_markers.push(marker);
		}

		if (fit_to_bounds && results[0]) {
			book_union_map_object.fitBounds(bounds);
		}

		$('#hotel-listing .hotel-listing-inner').html('<ul>' + $.map(results, function (h) {
			return '<li data-hotel-id="' + h.id + '">' + h.list_item_html + '</li>';
		}).join('') + '</ul>');

		$('#hotel-listing .hotel-listing-inner ul li').off('click').on('click', function () {
			for (var i = 0; i < book_union_markers.length; i++) {
				if ($(this).data('hotel-id') == book_union_markers[i].id) {
					map_mode();
					book_union_map_object.panTo(book_union_markers[i].internalPosition);
					book_union_map_object.setZoom(14);
					new google.maps.event.trigger(book_union_markers[i], 'click');
				}
			}
		});

		params2['total'] = results.length;
		book_union.find('.current-filter').html(current_filter_template(params2));
		book_union.find('.filter').off('click').on('click', function (e) {
			if ($(this).hasClass('name-filter')) {
				$('#bu-name').val('');
			}

			if ($(this).hasClass('location-filter')) {
				$('#bu-location').val('');
			}

			load_map_and_listing(true);
			record_state();

			e.preventDefault();
			return false;
		});

		$('#region-filter button').off('click').on('click', function (e) {
			$('#bu-location').val($(this).data('region')).change();

			e.preventDefault();
			return false;
		});
	}

	function list_mode() {
		book_union.removeClass('map-mode');
		book_union.find('.hotel-listing-map-toggle a.show-hotel-listing').addClass('active');
		book_union.find('.hotel-listing-map-toggle a.show-hotel-map').removeClass('active');
	}

	function map_mode() {
		book_union.addClass('map-mode');
		book_union.find('.hotel-listing-map-toggle a.show-hotel-listing').removeClass('active');
		book_union.find('.hotel-listing-map-toggle a.show-hotel-map').addClass('active');
	}

	function filter_hotels(hotels, params) {
		var results = Array.from(hotels);
		var i;

		if (params.name != '') {
			var options = {
				shouldSort: true,
				threshold: 0.4,
				location: 0,
				distance: 2,
				maxPatternLength: 32,
				minMatchCharLength: 1,
				keys: ["name"]
			};
			results = new Fuse(results, options).search(params.name);
		}

		return $.grep(results, function (r) {
			if (params.location != '') {
				if (params.location == 'NYC') {
					return nyc.indexOf(r.location) > -1;
				} else if (Array.isArray(regions[params['location']]) && regions[params['location']].length > 0) {
					return regions[params['location']].indexOf(r.location) > -1;
				} else {
					return r.location == params.location;
				}
			}

			return true;
		});
	}

	function params() {
		var name = $('#bu-name').val();
		var location = $('#bu-location').val();
		var filtering = name != '' || location != '';

		return { name: name, location: location, filtering: filtering };
	}

	function set_form_params_from_url() {
		// The params are in the url formatted as
		// https://hotelworkers.org/#find-union-hotels/[name]/[location]/
		var hash = window.location.hash.split('/');

		if (hash.length > 1) {
			$('#bu-name').val(decodeURI(hash[1]));
		}

		if (hash.length > 2) {
			$('#bu-location').val(decodeURI(hash[2]));
		}
	}

	function record_state() {
		var params2 = params();

		history.replaceState(null, "Find Union Hotels " + params2.name + ' ' + params2.location + " | Hotel Trands Council, AFL-CIO", '#find-union-hotels/' + encodeURI(params2.name) + '/' + encodeURI(params2.location));
	}

	function maximize() {
		book_union.addClass('fullscreen');
		$('.fullscreen-toggle.open').hide();
		$('.fullscreen-toggle.close2').show();
		$('body').addClass('no-scroll');

		/* close if the escape key is pressed */
		$(document).off('keyup').on('keyup', function (e) {
			if (e.keyCode === 27) {
				minimize();
				history.pushState(null, orig_url['title'], orig_url['href']);
			}
		});
	}

	function minimize() {
		book_union.removeClass('fullscreen');
		$('.fullscreen-toggle.open').show();
		$('.fullscreen-toggle.close2').hide();
		$(document).off('keyup');
		$('body').removeClass('no-scroll');
	}

	function book_union_in_view(event) {
		var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		var s;

		if (force || maps.length > 1 || book_union_map_element.offset().top + 100 <= $(window).scrollTop() + $(window).height()) {
			$(window).off('scroll', book_union_in_view);

			s = document.createElement("script");
			s.type = "text/javascript";
			s.src = "//maps.googleapis.com/maps/api/js?key=AIzaSyAYjUNR8aHnF3zom4SUGrZB6LUHUItrGvk&callback=init_maps";
			$("head").append(s);
		}
	}

	$.getJSON('/book-union.json', function (data) {
		hotels = data;

		maps.push(function () {
			var hash = window.location.hash.split('/');

			for (var i in hotels) {
				hotels[i].list_item_html = hotel_list_item_template(hotels[i]);
				hotels[i].detail_html = hotel_detail_template(hotels[i]);
			}

			book_union_map_object = new google.maps.Map(document.getElementById('map'), {
				zoom: 11,
				center: { lat: 40.759184, lng: -74.004873 },
				scrollwheel: false,
				fullscreenControl: false,
				mapTypeControl: false,
				streetViewControl: false
			});

			set_form_params_from_url();

			load_map_and_listing(false);
		});

		// if(ENV != 'dev') {
		$(window).on('scroll', book_union_in_view).scroll();
		// }

		$(window).resize();
	});
});

},{}],7:[function(require,module,exports){
'use strict';

/*!
 * Bootstrap Table of Contents v0.4.1 (http://afeld.github.io/bootstrap-toc/)
 * Copyright 2015 Aidan Feldman
 * Licensed under MIT (https://github.com/afeld/bootstrap-toc/blob/gh-pages/LICENSE.md) */
(function () {
  'use strict';

  window.Toc = {
    helpers: {
      // return all matching elements in the set, or their descendants
      findOrFilter: function findOrFilter($el, selector) {
        // http://danielnouri.org/notes/2011/03/14/a-jquery-find-that-also-finds-the-root-element/
        // http://stackoverflow.com/a/12731439/358804
        var $descendants = $el.find(selector);
        return $el.filter(selector).add($descendants).filter(':not([data-toc-skip])');
      },

      generateUniqueIdBase: function generateUniqueIdBase(el) {
        var text = $(el).text();
        var anchor = text.trim().toLowerCase().replace(/[^A-Za-z0-9]+/g, '-');
        return anchor || el.tagName.toLowerCase();
      },

      generateUniqueId: function generateUniqueId(el) {
        var anchorBase = this.generateUniqueIdBase(el);
        for (var i = 0;; i++) {
          var anchor = anchorBase;
          if (i > 0) {
            // add suffix
            anchor += '-' + i;
          }
          // check if ID already exists
          if (!document.getElementById(anchor)) {
            return anchor;
          }
        }
      },

      generateAnchor: function generateAnchor(el) {
        if (el.id) {
          return el.id;
        } else {
          var anchor = this.generateUniqueId(el);
          el.id = anchor;
          return anchor;
        }
      },

      createNavList: function createNavList() {
        return $('<ul class="nav"></ul>');
      },

      createChildNavList: function createChildNavList($parent) {
        var $childList = this.createNavList();
        $parent.append($childList);
        return $childList;
      },

      generateNavEl: function generateNavEl(anchor, text) {
        var $a = $('<a class="nav-link"></a>');
        $a.attr('href', '#' + anchor);
        $a.text(text);
        var $li = $('<li class="nav-item"></li>');
        $li.append($a);
        return $li;
      },

      generateNavItem: function generateNavItem(headingEl) {
        var anchor = this.generateAnchor(headingEl);
        var $heading = $(headingEl);
        var text = $heading.data('toc-text') || $heading.text();
        return this.generateNavEl(anchor, text);
      },

      // Find the first heading level (`<h1>`, then `<h2>`, etc.) that has more than one element. Defaults to 1 (for `<h1>`).
      getTopLevel: function getTopLevel($scope) {
        for (var i = 1; i <= 6; i++) {
          var $headings = this.findOrFilter($scope, 'h' + i);
          if ($headings.length > 1) {
            return i;
          }
        }

        return 1;
      },

      // returns the elements for the top level, and the next below it
      getHeadings: function getHeadings($scope, topLevel) {
        var topSelector = 'h' + topLevel;

        var secondaryLevel = topLevel + 1;
        var secondarySelector = 'h' + secondaryLevel;

        return this.findOrFilter($scope, topSelector + ',' + secondarySelector);
      },

      getNavLevel: function getNavLevel(el) {
        return parseInt(el.tagName.charAt(1), 10);
      },

      populateNav: function populateNav($topContext, topLevel, $headings) {
        var $context = $topContext;
        var $prevNav;

        var helpers = this;
        $headings.each(function (i, el) {
          var $newNav = helpers.generateNavItem(el);
          var navLevel = helpers.getNavLevel(el);

          // determine the proper $context
          if (navLevel === topLevel) {
            // use top level
            $context = $topContext;
          } else if ($prevNav && $context === $topContext) {
            // create a new level of the tree and switch to it
            $context = helpers.createChildNavList($prevNav);
          } // else use the current $context

          $context.append($newNav);

          $prevNav = $newNav;
        });
      },

      parseOps: function parseOps(arg) {
        var opts;
        if (arg.jquery) {
          opts = {
            $nav: arg
          };
        } else {
          opts = arg;
        }
        opts.$scope = opts.$scope || $(document.body);
        return opts;
      }
    },

    // accepts a jQuery object, or an options object
    init: function init(opts) {
      opts = this.helpers.parseOps(opts);

      // ensure that the data attribute is in place for styling
      opts.$nav.attr('data-toggle', 'toc');

      var $topContext = this.helpers.createChildNavList(opts.$nav);
      var topLevel = this.helpers.getTopLevel(opts.$scope);
      var $headings = this.helpers.getHeadings(opts.$scope, topLevel);
      this.helpers.populateNav($topContext, topLevel, $headings);
    }
  };

  // $(function() {
  //   $('nav[data-toggle="toc"]').each(function(i, el) {
  //     var $nav = $(el);
  //     Toc.init($nav);
  //   });
  // });
})();

},{}],8:[function(require,module,exports){
'use strict';

$(document).ready(function () {
	if ($('.carousel').find('.slide').length > 1) {
		$('.carousel').imagesLoaded().done(function () {
			$('.carousel').slick({
				infinite: true,
				slidesToShow: 1,
				arrows: false,
				dots: true,
				autoplay: true,
				autoplaySpeed: 6000,
				adaptiveHeight: false,
				pauseOnHover: true,
				focusOnSelect: false
			});

			// Force repainting of carousel. Quick fix for strage issue where a white box appears over carousel
			setTimeout(function () {
				$('.carousel').css('transform', 'translateZ(0)');
			}, 10);
			setTimeout(function () {
				$('.carousel').css('transform', 'translateZ(0)');
			}, 100);
			setTimeout(function () {
				$('.carousel').css('transform', 'translateZ(0)');
			}, 1000);
		});
	}
});

},{}],9:[function(require,module,exports){
'use strict';

$(document).ready(function () {
  if ($('.cleave-input-date').length > 0) {
    var cleave = new Cleave('.cleave-input-date', {
      date: true,
      delimter: '/',
      datePattern: ['m', 'd', 'Y']
    });
  }
});

},{}],10:[function(require,module,exports){
"use strict";

$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
	if (options.type.toLowerCase() == "post") {
		options.data = options.data || "";
		options.data += options.data ? "&" : "";
		options.data += currentUser['csrfTokenName'] + "=" + encodeURIComponent(currentUser['csrfTokenValue']);
	}
});

$(document).on('current-user-loaded', function () {
	$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
		if (options.type.toLowerCase() == "post") {
			options.data = options.data || "";
			options.data += options.data ? "&" : "";
			options.data += currentUser['csrfTokenName'] + "=" + encodeURIComponent(currentUser['csrfTokenValue']);
		}
	});
});

},{}],11:[function(require,module,exports){
'use strict';

var _vueTagsInput = require('@johmun/vue-tags-input');

var _vueTagsInput2 = _interopRequireDefault(_vueTagsInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\w?\W?]{8,}$/;

var params = new URLSearchParams(window.location.search);

var pluck = function pluck(arr, key) {
  return arr.map(function (i) {
    return i[key];
  });
};

$(document).on('current-user-loaded', function () {
  if ($('.dashboard').length > 0) {
    $('html').css('scroll-behavior', 'auto');
    init_auto_logout();

    $.ajax({
      dataType: "json",
      url: localeUrlPath + '/accounts/dashboard/get-' + firstSegment + '-data.json?i=1',
      success: init_dashboard,
      error: function error() {
        /*
          If an error is thrown it will be that the session has expired but the
          vcachetoken cookie has not.
        */
        // logout();
      }
    });
  }
});

function init_dashboard(response) {
  if (response['error'] == 'Forbidden') {
    logout();
  }

  FilePond.registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImageTransform, FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilePondPluginImageCrop, FilePondPluginImageResize, FilePondPluginImagePreview, FilePondPluginMediaPreview);

  Vue.use(VueMarkdown);
  Vue.use(VuePlyr, {
    preload: false
  });
  Vue.component("v-chart", VueECharts);

  var dashboard = new Vue({
    el: '.dashboard',
    delimiters: ['${', '}'],
    components: {
      FilePond: vueFilePond.default(FilePondPluginFileValidateType, FilePondPluginFileValidateSize)
    },
    data: function data() {
      return {
        shops: [],
        shopTypes: [],
        classifications: [],
        user: currentUser,
        person: {},
        editingName: false,
        editingEmployer: false,
        editingContact: false,
        replacingProfilePicture: false,
        to: "",
        toPersons: [],
        toPersonIds: [],
        team: [],
        personsById: {},
        comments: [],
        commentsById: [],
        commentsMode: 'thread-listing',
        newComment: "",
        newCommentAttachments: [],
        newThread: false,
        currentThreadId: null,
        currentPage: 'your-profile',
        hireStats: [],
        openMenus: [],
        processingProfile: false,
        processingMessage: false,
        mobileNavOpen: false,
        filesUploading: 0,
        recorder: null,
        recorderStream: null,
        forms: response.forms,
        currentFormId: response.forms && response.forms.length > 0 ? response.forms[0].id : null,
        formReportTotals: {},
        filterShop: '',
        filterShopType: '',
        filterClassification: '',
        filterFromDate: '01/11/2023',
        filterToDate: moment().format('MM/DD/YYYY'),
        applyingFilter: false
      };
    },

    watch: {
      filterShopType: function filterShopType(oldVal, newVal) {
        var data = this;
        setTimeout(function () {
          data.applyingFilter = true;
          load_dashboard_data(data, function () {
            data.applyingFilter = false;
          });
        }, 100);
      },

      filterShop: function filterShop(oldVal, newVal) {
        var data = this;
        setTimeout(function () {
          data.applyingFilter = true;
          load_dashboard_data(data, function () {
            data.applyingFilter = false;
          });
        }, 100);
      },

      filterClassification: function filterClassification(oldVal, newVal) {
        var data = this;
        setTimeout(function () {
          data.applyingFilter = true;
          load_dashboard_data(data, function () {
            data.applyingFilter = false;
          });
        }, 100);
      }
    },

    computed: {
      currentUrlEncoded: function currentUrlEncoded() {
        return encodeURIComponent(window.location);
      },

      activePageTitle: function activePageTitle() {
        if (this.currentPage == 'your-account') {
          return _t['Your Account'];
        } else if (this.currentPage == 'job-openings') {
          return _t['Job Openings'];
        } else if (this.currentPage == 'your-resume-and-cover-letter') {
          return _t['Your Resume and Cover Letter'];
        }
      },

      commentsModeThreadListing: function commentsModeThreadListing() {
        return this.commentsMode == 'thread-listing';
      },

      commentsModeThreadDetail: function commentsModeThreadDetail() {
        return this.commentsMode == 'thread-detail';
      },

      currentThread: function currentThread() {
        return this.commentsById[this.currentThreadId];
      },

      teamAutoComplete: function teamAutoComplete() {
        return this.team.map(function (e) {
          return {
            'text': e.firstName + ' ' + e.lastName,
            'value': e.id
          };
        });
      },

      currentThreadPersons: function currentThreadPersons() {
        var data = this;

        return this.currentThread.groupPersonIds.map(function (id) {
          return data.personsById[id];
        });
      },

      firstComment: function firstComment() {
        return this.comments.length == 0;
      },

      currentForm: function currentForm() {
        if (this.forms) {
          for (var i = 0; i < this.forms.length; i++) {
            if (this.currentFormId == this.forms[i].id) {
              return this.forms[i];
            }
          }
          return this.forms[0];
        }
      }
    },

    methods: {
      applyFilter: function applyFilter(oldVal, newVal) {
        var data = this;
        setTimeout(function () {
          data.applyingFilter = true;
          load_dashboard_data(data, function () {
            data.applyingFilter = false;
          });
        }, 100);
      },

      chartOptionsForField: function chartOptionsForField(field) {
        var name = field.name.replaceAll(' ', '_').replaceAll('/', '\\/');
        if (field.name == 'Childcare expenses') {
          return {
            "backgroundColor": "#f6f6f6",
            "title": {
              "text": field.name
            },
            "tooltip": { "trigger": "item", "axisPointer": { "type": "shadow" } },
            "grid": {
              "left": "3%",
              "right": "4%",
              "bottom": "3%",
              "containLabel": true
            },
            "series": [{
              "type": "pie",
              "data": [{
                value: this.currentForm.totalsForCharts[name]['values'][0],
                name: Math.round(this.currentForm.totalsForCharts[name]['values'][0] / this.currentForm.totalsForCharts['Overview']['values'][0] * 100) + '% ' + this.currentForm.totalsForCharts[name]['labels'][0] + ' (' + this.currentForm.totalsForCharts[name]['values'][0] + ' / ' + this.currentForm.totalsForCharts['Overview']['values'][0] + ')'
              }, {
                value: this.currentForm.totalsForCharts[name]['values'][1],
                name: Math.round(this.currentForm.totalsForCharts[name]['values'][1] / this.currentForm.totalsForCharts['Overview']['values'][0] * 100) + '% ' + this.currentForm.totalsForCharts[name]['labels'][1] + ' (' + this.currentForm.totalsForCharts[name]['values'][1] + ' / ' + this.currentForm.totalsForCharts['Overview']['values'][0] + ')'
              }, {
                value: this.currentForm.totalsForCharts[name]['values'][2],
                name: Math.round(this.currentForm.totalsForCharts[name]['values'][2] / this.currentForm.totalsForCharts['Overview']['values'][0] * 100) + '% ' + this.currentForm.totalsForCharts[name]['labels'][2] + ' (' + this.currentForm.totalsForCharts[name]['values'][2] + ' / ' + this.currentForm.totalsForCharts['Overview']['values'][0] + ')'
              }]
            }],
            "color": ["#2fb9f8", "#7956ec", "#91c7ae"]
          };
        } else {
          return {
            "backgroundColor": "#f6f6f6",
            "title": {
              "text": field.name
            },
            "tooltip": { "trigger": "axis", "axisPointer": { "type": "shadow" } },
            "grid": {
              "left": "3%",
              "right": "4%",
              "bottom": "3%",
              "containLabel": true
            },
            "xAxis": [{
              "type": "category",
              "data": name in this.currentForm.totalsForCharts ? this.currentForm.totalsForCharts[name]['labels'] : [],
              "axisTick": { "alignWithLabel": true }
            }],
            "yAxis": [{ "type": "value" }],
            "series": [{
              "type": "bar",
              "barWidth": "60%",
              "data": name in this.currentForm.totalsForCharts ? this.currentForm.totalsForCharts[name]['values'] : []
            }],
            "color": ["#2fb9f8", "#7956ec"]
          };
        }
      },

      scrollerForField: function scrollerForField(field) {
        var name = field.name.replaceAll(' ', '_');
        var entries = this.currentForm.formEntries;
        var html = '';
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].fields_json) {
            (function () {
              var fields = JSON.parse(entries[i].fields_json);
              if (name in fields) {
                if (field.type == 'multipletext') {
                  html += '<strong>' + fields['First_name'] + ' ' + fields['Last_name'] + '</strong>: <ul>';
                  Object.keys(fields[name]).forEach(function (key) {
                    html += '<li>' + key + ': ' + fields[name][key] + '</li>';
                  });
                  html += '</ul>';
                } else {
                  html += '<strong>' + fields['First_name'] + ' ' + fields['Last_name'] + '</strong>: ' + fields[name] + '<br/><br/>';
                }
              }
            })();
          }
        }
        return html;
      },

      otherResponsesForField: function otherResponsesForField(field) {
        var entries = this.currentForm.formEntries;
        var html = '';
        var name = '';
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].fields_json) {
            var fields = JSON.parse(entries[i].fields_json);
            if (this.currentForm.id == 47) {
              if (field.name == 'Current Childcare Arrangement') {
                name = 'currentChildcareOther';
              } else if (field.name == 'Work a Second Job') {
                name = 'secondJobWhere';
              }
              if (name in fields && fields[name].trim() != '') {
                html += '<strong>' + fields['firstName'] + ' ' + fields['lastName'] + '</strong>: ' + fields[name] + '<br/><br/>';
              }
            } else {
              name = field.name.replaceAll(' ', '_') + '-Comment';
              if (name in fields && fields[name].trim() != '') {
                html += '<strong>' + fields['First_name'] + ' ' + fields['Last_name'] + '</strong>: ' + fields[name] + '<br/><br/>';
              }
            }
          }
        }
        return html;
      },

      goToPage: function goToPage(slug, hash) {
        var recordHistory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        this.currentPage = slug;
        this.mobileNavOpen = false;

        var data = this;
        var link = $('.nav-link[data-slug="' + this.currentPage + '"]');

        if (recordHistory) {
          if (hash) {
            history.pushState({ page: slug, title: link.html() }, link.html(), link.attr('href') + '#' + hash);
          } else {
            history.pushState({ page: slug, title: link.html() }, link.html(), link.attr('href'));
          }
        }

        document.title = link.html();

        $('a[data-slug="' + this.currentPage + '"]').parents('.nav-item').each(function () {
          if (data.openMenus.indexOf($(this).data('slug')) < 0) {
            data.openMenus.push($(this).data('slug'));
          }
        });

        setTimeout(function () {
          if (hash) {
            var element = $('[id="' + hash + '"], a[name="' + hash + '"]').first();
            var y = 0;

            if (window.outerWidth >= 850) {
              y = element.offset()['top'] - 191 - 15;
            } else {
              y = element.offset()['top'] - 42 - 15;
            }

            if (element.length >= 1) {
              window.scrollTo({ top: y, behavior: 'auto' });
            } else {
              window.scrollTo(0, 0);
            }
          } else {
            window.scrollTo(0, 0);
          }
        }, 10);
      },

      toggleMenu: function toggleMenu(slug) {
        var index = this.openMenus.indexOf(slug);

        if (index > -1) {
          this.openMenus.splice(index, 1);
        } else {
          this.openMenus.push(slug);
        }
      },

      editProfile: function editProfile() {
        this.editingProfile = true;
      },

      cancelProfileEdit: function cancelProfileEdit() {
        this.editingProfile = false;
      },

      saveProfile: function saveProfile(source) {
        var data = this;

        data.processingProfile = true;

        $.ajax({
          url: localeUrlPath + '/accounts/profile/save-profile',
          type: 'post',
          data: {
            person: this.person,
            user: this.user
          },
          dataType: 'json'
        }).done(function (response) {
          if (response['status'] == 'email-already-in-use') {
            request_help_hire(_t['Email already in use.'], '<p>' + _t['Please try again with a different username, or use the form below to request help from a Union representative.'] + '</p>', 'question', _t['request_help'], _t['try_again']);
          } else if (response['status'] == 'invalid-email-work-domain') {
            Swal.fire({
              title: _t['Please use your personal email address, not work your email address.'],
              icon: 'info',
              confirmButtonText: _t['Ok']
            });
          } else if (response['status'] == 'invalid-email-formatting') {
            Swal.fire({
              title: _t['Please provide a valid email address.'],
              icon: 'info',
              confirmButtonText: _t['Ok']
            });
          } else if (response['status'] == 'username-already-in-use') {
            request_help_hire(_t['Username already taken.'], '<p>' + _t['Please try again with a different email, or use the form below to request help from a Union representative.'] + '</p>', 'question', _t['request_help'], _t['try_again']);
          } else {
            if (source == 'name') data.editingName = false;
            if (source == 'employer') data.editingEmployer = false;
            if (source == 'contact') data.editingContact = false;
          }
        }).fail(function (e) {
          error_occurred(e);
        });

        data.processingProfile = false;
      },

      replaceProfilePicture: function replaceProfilePicture() {
        var data = this;

        this.replacingProfilePicture = true;
        Vue.nextTick(function () {
          data.$refs.newProfilePicture.browse();
        });
      },

      saveProfilePicture: function saveProfilePicture(error, file) {
        if (!error) {
          var data = this;

          $.ajax({
            url: localeUrlPath + '/accounts/profile/save-profile-picture',
            type: 'post',
            data: {
              profilePicture: JSON.parse(file.serverId)
            },
            dataType: 'json'
          }).done(function (response) {
            if (response['status'] == 'success') {
              data.person.profilePictureUid = response['profilePicture'].uid;
              data.replacingProfilePicture = false;
              data.$refs.newProfilePicture.removeFiles();
            }
          }).fail(function (e) {
            error_occurred(e);
          });
        }
      },

      deleteProfilePicture: function deleteProfilePicture() {
        var data = this;

        Swal.fire({
          title: _t['Are you sure?'],
          icon: 'warning',
          confirmButtonText: _t["Yes, delete my picture."],
          showCancelButton: true,
          allowOutsideClick: true
        }).then(function (response) {
          if (response.isConfirmed) {
            if (data.person.profilePictureUid) {
              $.ajax({
                url: localeUrlPath + '/accounts/profile/delete-profile-picture',
                type: 'post',
                data: {
                  uid: data.person.profilePictureUid
                },
                dataType: 'json'
              }).done(function (response) {
                data.person.profilePictureUid = null;
                data.replacingProfilePicture = false;
              }).fail(function (e) {
                error_occurred(e);
              });
            } else {
              data.person.profilePictureUid = null;
              data.replacingProfilePicture = false;
            }
          }
        });
      },

      changePassword: function changePassword() {
        Swal.fire({
          title: _t["Change Your Password"],
          html: '<div style="text-align:left">' + '<br/><label>' + _t['New password:'] + '</label>' + '<input required="required" id="newPassword2" type="password" class="swal2-input" required>' + '<small class="help-block">' + _t['Must be at least 8 characters long and include letters and numbers'] + '</small>' + '<label>' + _t['Retype new password:'] + '</label>' + '<input required="required" id="newPasswordConfirmation2" type="password" class="swal2-input" required><br/>' + '</div>',
          icon: 'question',
          confirmButtonText: _t['Save'],
          cancelButtonText: _t['cancel'],
          showCancelButton: true,
          preConfirm: function preConfirm() {
            if (!$('#newPassword2').val().match(passwordRegex)) {
              Swal.showValidationMessage(_t['Must be at least 8 characters long and include letters and numbers']);
              return false;
            } else if ($('#newPassword2').val() != $('#newPasswordConfirmation2').val()) {
              Swal.showValidationMessage(_t['New password and Retype new password must match.']);
              return false;
            } else {
              return {
                'newPassword': $('#newPassword2').val()
              };
            }
          }
        }).then(function (response) {
          if (response.isConfirmed) {
            $.ajax({
              url: localeUrlPath + '/accounts/set-password',
              type: 'post',
              data: {
                newPassword: response.value['newPassword']
              },
              dataType: 'json'
            }).done(function (response) {
              Swal.fire({ title: _t['Your password was changed successfully.'], icon: 'success' });
            }).fail(function (e) {
              error_occurred(e);
            });
          }
        });
      },

      requestHelp: function requestHelp() {
        request_help_nu_workers();
      },

      isActivePage: function isActivePage(val) {
        return this.currentPage == val;
      },

      isMenuOpen: function isMenuOpen(val) {
        return this.openMenus.includes(val);
      },

      showThreadListing: function showThreadListing() {
        this.currentThreadId = null;
        this.commentsMode = 'thread-listing';
        window.scrollTo(0, 0);
      },

      createNewThread: function createNewThread() {
        this.newThread = true;
        $('#background').show();
      },

      closeNewThread: function closeNewThread() {
        this.newComment = '';
        this.newThread = false;
        $('.textarea-w-button textarea').css({ 'height': 34 });
        $('#background').hide();
      },

      createComment: function createComment() {
        var data = this;

        if (this.newComment.trim() == '' && this.newCommentAttachments.length == 0) {
          return;
        }

        if (!data.processingMessage) {
          data.processingMessage = true;

          $.ajax({
            url: localeUrlPath + '/accounts/comments/create-comment',
            type: 'post',
            data: {
              body: this.newComment.trim(),
              attachments: this.newCommentAttachments,
              threadId: this.newThread ? null : this.currentThreadId,
              toPersonIds: this.toPersonIds
            },
            dataType: 'json'
          }).done(function (response) {
            data.$refs.newCommentPond.removeFiles();
            data.newComment = '';
            data.newCommentAttachments = [];
            $('#new-response').css({ 'height': '35px' });
            data.toPersonIds = [];
            data.to = "";

            data.commentsById[response['comment'].id] = response['comment'];

            if (response.thread) {
              data.currentThreadId = response.thread.id;
              data.commentsById[data.currentThreadId].responses.push(response['comment']);
            } else {
              data.comments.unshift(response['comment']);
              data.currentThreadId = response.comment.id;
            }

            data.commentsMode = 'thread-detail';
            data.closeNewThread();
            data.processingMessage = false;
            data.scrollToRecentComments();

            Swal.fire({
              title: _t['Your message was received. We will notify you via email when we respond.'],
              icon: 'success'
            });
          }).fail(function (e) {
            error_occurred(e);
            data.processingMessage = false;
          });
        }
      },

      showThreadDetail: function showThreadDetail(threadId) {
        var data = this;

        this.currentThreadId = threadId;

        this.currentThread.unreadResponses = 0;
        this.commentsMode = 'thread-detail';

        this.scrollToRecentComments();

        var ids = pluck(data.currentThread.responses, 'id');
        ids.push(threadId);

        $.ajax({
          url: localeUrlPath + '/accounts/comments/mark-thread-as-read',
          type: 'post',
          data: {
            ids: ids
          },
          dataType: 'json'
        }).done(function (response) {
          data.currentThread.dateSeenByUser = new Date();
        });
      },

      newCommentAttachmentLoaded: function newCommentAttachmentLoaded(error, file) {
        if (!error) {
          this.newCommentAttachments.push(JSON.parse(file.serverId));
        }

        this.filesUploading -= 1;

        if (this.filesUploading == 0) {
          this.processingMessage = false;
        }
      },

      commentAttachmentRemoved: function commentAttachmentRemoved(error, file) {
        var uid = JSON.parse(file.serverId).uid;

        for (var i = 0; i < this.newCommentAttachments.length; i++) {
          if (uid == this.newCommentAttachments[i].uid) {
            this.newCommentAttachments.splice(i, 1);
          }
        }
      },

      autosize: function autosize(e) {
        setTimeout(function () {
          e.target.style.cssText = 'height:auto; padding:0';

          var height = e.target.scrollHeight;

          if (height > window.innerHeight * 0.50) {
            height = window.innerHeight * 0.50;
          }

          e.target.style.cssText = 'height:' + (height + 15) + 'px';
        }, 0);
      },

      showFileBrowser: function showFileBrowser() {
        if (!this.processingMessage) {
          this.$refs.newCommentPond.browse();
        }
      },

      showFilePond: function showFilePond() {
        $('.dashboard #comments .filepond--root').show();
      },

      recordVideo: function recordVideo() {
        if (window.MediaRecorder && MediaRecorder.isTypeSupported) {
          var data = this;

          if (data.recorder && data.recorder.state == "recording") {
            $('#video-recording-preview').hide();
            data.processingMessage = false;
            data.recorder.stop();
            for (var i = 0; i < data.recorderStream.getTracks().length; i++) {
              data.recorderStream.getTracks()[i].stop();
            }
          } else if (!data.processingMessage) {
            data.processingMessage = true;
            navigator.mediaDevices.getUserMedia({
              audio: true,
              video: true
            }).then(function (stream) {
              data.recorderStream = stream;
              data.recorder = new MediaRecorder(stream);
              data.recorder.ondataavailable = function (e) {
                data.$refs.newCommentPond.addFile(e.data);
              };
              data.recorder.start();
              $('#video-recording-preview video')[0].srcObject = stream;
              $('#video-recording-preview').show();
            });
          }
        } else {
          this.showFileBrowser();
        }
      },

      recordAudio: function recordAudio() {
        if (window.MediaRecorder && MediaRecorder.isTypeSupported) {
          var data = this;

          if (data.recorder && data.recorder.state == "recording") {
            $('#audio-recording-preview').hide();
            data.processingMessage = false;
            data.recorder.stop();
            for (var i = 0; i < data.recorderStream.getTracks().length; i++) {
              data.recorderStream.getTracks()[i].stop();
            }
          } else if (!data.processingMessage) {
            data.processingMessage = true;
            navigator.mediaDevices.getUserMedia({
              audio: true
            }).then(function (stream) {
              data.recorderStream = stream;
              data.recorder = new MediaRecorder(stream);
              data.recorder.ondataavailable = function (e) {
                data.$refs.newCommentPond.addFile(e.data);
              };
              data.recorder.start();
              $('#audio-recording-preview').show();
            });
          }
        } else {
          this.showFileBrowser();
        }
      },

      toPersonsChanged: function toPersonsChanged(toPersons) {
        this.toPersonIds = toPersons.map(function (e) {
          return e.value;
        });
      },

      groupPersonListFor: function groupPersonListFor(comment) {
        var html = '';

        for (var i = 0; i < comment.groupPersonIds.length; i++) {
          if (i + 1 >= comment.groupPersonIds.length) {
            html += ' &amp; ';
          } else if (i != 0) {
            html += ', ';
          }

          if (this.personsById[comment.groupPersonIds[i]].profilePictureUid) {
            html += ' <img class="profile-picture small" src="/accounts/attachments/get?uid=' + this.personsById[comment.groupPersonIds[i]].profilePictureUid + '&version=thumb" /> ' + this.personsById[comment.groupPersonIds[i]].fullName;
          } else {
            html += ' <i class="fas fa-user-circle"></i> ' + this.personsById[comment.groupPersonIds[i]].fullName;
          }
        }

        return html;
      },

      commentTo: function commentTo(to) {
        if (to.id != this.person.id && this.comments.length > 0) {
          this.toPersonIds = [to.id];
          this.toPersons = [{ text: to.fullName, value: to.id }];
          this.createNewThread();
        }
      },

      scrollToRecentComments: function scrollToRecentComments() {
        var recentComment = $('.responses .unread, #new-comment-anchor').first();
        var top = function top() {
          return recentComment.position().top - window.innerHeight + 75 + 194;
        };

        window.scrollTo({ top: top(), left: 0 });

        setTimeout(function () {
          window.scrollTo({ top: top(), left: 0 });
        }, 250);
      }
    },

    filters: {
      mimeFix: function mimeFix(mimeType) {
        if (mimeType == 'video/x-matroska') {
          return 'video/webm';
        } else {
          return mimeType;
        }
      },

      currency: function (_currency) {
        function currency(_x2) {
          return _currency.apply(this, arguments);
        }

        currency.toString = function () {
          return _currency.toString();
        };

        return currency;
      }(function (val) {
        return currency(val).format();
      }),
      date: function date(val) {
        if (val) {
          if (val.includes(':')) {
            return moment(val + 'Z').format(_t['date_format_js']);
            /* If it is just a date without a time, don't force UTC */
          } else {
            return moment(val).format(_t['date_format_js']);
          }
        }
      },
      datetime: function datetime(val) {
        if (val) {
          return moment(val + 'Z').format(_t['datetime_format_js']);
        }
      },
      time: function time(val) {
        if (val) {
          return moment(val + 'Z').format(_t['time_format_js']);
        }
      },
      t: function t(val) {
        if (_t[val]) {
          return _t[val];
        } else {
          return val;
        }
      },
      pmType: function pmType(val) {
        return card_types(val);
      },
      nl2br: function nl2br(string) {
        return string.replace(/[\r\n\x0B\x0C\u0085\u2028\u2029]/g, '<br/>');
      },
      fromNow: function fromNow(val) {
        if (val) {
          return dayjs(moment(val + 'Z').format(_t['datetime_format_js'])).fromNow();
        } else {
          return '';
        }
      }
    },

    mounted: function mounted() {
      var data = this;

      data.shops = _.uniq(_.map(valueLists.shops, 'name').sort());
      data.shopTypes = _.uniq(_.map(valueLists.shops, 'shopType').sort()).filter(function (a) {
        return a.length > 0;
      });
      data.classifications = _.sortBy(valueLists['classifications']);

      var pages = $('.dashboard-nav a').map(function () {
        return $(this).data('slug');
      }).toArray();
      var hash = window.location.hash.slice(1);

      var location = window.location.pathname.substring(1);
      if (location.substring(0, 2) == 'es' || location.substring(0, 2) == 'zh') {
        location = location.substring(2);
      }
      var pathParts = location.split('/').slice(1);
      if (pathParts.length >= 1 && pathParts[pathParts.length - 1] != '') {
        this.currentPage = pathParts[pathParts.length - 1];
      } else if (currentUser.sections.indexOf('executive-staff') > -1) {
        this.currentPage = 'forms';
      } else if ($($('.nav-link')[1]).data('slug')) {
        this.currentPage = $($('.nav-link')[1]).data('slug');
      } else {
        this.currentPage = 'your-profile';
      }

      this.goToPage(this.currentPage, hash);

      $('.dashboard #comments .filepond--root').hide();

      window.addEventListener('popstate', function (e) {
        if (e.state && e.state.page) {
          data.goToPage(e.state.page, false, false);
        }
      });

      $('.cleave-input-date').each(function () {
        var cleave = new Cleave(this, {
          date: true,
          delimter: '/',
          datePattern: ['m', 'd', 'Y']
        });
      });

      if (firstSegment == 'htc-staff') {
        var nuContactSurveyTemplate = document.getElementById('nu-contact-survey');
        $('.dashboard #nu-contact-survey-container').html(nuContactSurveyTemplate.content);
      }

      setTimeout(function () {
        window.scrollTo({ top: 0, left: 0 });

        if (data.currentFormId) {
          data.applyingFilter = true;
        }

        load_dashboard_data(data, function (data) {
          if (params.get('tid')) {
            data.showThreadDetail(params.get('tid'));
          }

          var between_5_and_15_seconds = Math.ceil(5 + Math.random() * 10) * 1000;
          setTimeout(function () {
            load_dashboard_data(data);
          }, between_5_and_15_seconds);
        });

        $('.dashboard-loader').hide();
        $('.dashboard').show();
      }, 250);
    }
  });
}

function load_dashboard_data(data, callback) {
  var filters = {
    currentFormId: data.currentFormId,
    filterShopType: data.filterShopType,
    filterShop: data.filterShop,
    filterClassification: data.filterClassification,
    filterFromDate: data.filterFromDate ? moment(data.filterFromDate).format('YYYY-MM-DD') : null,
    filterToDate: data.filterToDate ? moment(data.filterToDate).format('YYYY-MM-DD') : null
  };

  $.getJSON(localeUrlPath + '/accounts/dashboard/get-' + firstSegment + '-data.json', filters, function (response) {
    data.hireStats = response['hireStats'];
    data.comments = response['comments'];
    data.team = response['team'];
    data.forms = response['forms'];
    data.applyingFilter = false;

    if (data.forms && parseInt(data.currentFormId) > 0) {
      var _loop = function _loop(h) {
        data.forms[h].totalsForCharts = {};

        if (data.forms[h].structure) {
          for (var _i = 0; _i < data.forms[h].structure.pages.length; _i++) {
            var _loop2 = function _loop2(j) {
              var field = data.forms[h].structure.pages[_i].elements[j];
              var name = field.name.replaceAll(' ', '_').replaceAll('/', '\\/');

              data.forms[h].totalsForCharts[name] = {
                'labels': [],
                'values': []
              };

              if (field.type == 'sortablelist') {
                if (name in data.forms[h].totals) {
                  Object.keys(data.forms[h].totals[name]).sort(function (a, b) {
                    if (parseInt(data.forms[h].totals[name][a]) < parseInt(data.forms[h].totals[name][b])) {
                      return 1;
                    } else if (parseInt(data.forms[h].totals[name][a]) > parseInt(data.forms[h].totals[name][b])) {
                      return -1;
                    } else {
                      return 0;
                    }
                  }).forEach(function (key) {
                    data.forms[h].totalsForCharts[name]['labels'].push(key);
                    data.forms[h].totalsForCharts[name]['values'].push(data.forms[h].totals[name][key]);
                  });
                }
              } else if ('choices' in field) {
                for (var k = 0; k < field.choices.length; k++) {
                  var choiceText = void 0;
                  if (typeof field.choices[k] == 'string') {
                    choiceText = field.choices[k];
                  } else {
                    choiceText = field.choices[k].value;
                  }
                  if (data.forms[h].totals[name]) {
                    choiceText = choiceText.replace("’", '\\u2019');
                    data.forms[h].totalsForCharts[name]['labels'].push(choiceText.replace("’", "'"));
                    data.forms[h].totalsForCharts[name]['values'].push(data.forms[h].totals[name][choiceText]);
                  }
                }
              } else if ('choicesByUrl' in field && (field.name == 'Job classification' || field.name == 'Languages spoken')) {
                var choices = void 0;
                if (field.name == 'Job classification') {
                  field.choices = classifications;
                }
                if (field.name == 'Languages spoken') {
                  field.choices = languages;
                }
                for (var _k = 0; _k < field.choices.length; _k++) {
                  var _choiceText = void 0;
                  if (typeof field.choices[_k] == 'string') {
                    _choiceText = field.choices[_k];
                  } else {
                    _choiceText = field.choices[_k].value;
                  }
                  if (data.forms[h].totals[name]) {
                    _choiceText = _choiceText.replace("’", '\\u2019');
                    data.forms[h].totalsForCharts[name]['labels'].push(_choiceText.replace("’", "'"));
                    data.forms[h].totalsForCharts[name]['values'].push(data.forms[h].totals[name][_choiceText]);
                  }
                }
              } else if (field.type == 'boolean') {
                if (name in data.forms[h].totals) {
                  data.forms[h].totalsForCharts[name]['labels'].push('Yes');
                  data.forms[h].totalsForCharts[name]['values'].push(data.forms[h].totals[name][true]);
                  data.forms[h].totalsForCharts[name]['labels'].push('No');
                  data.forms[h].totalsForCharts[name]['values'].push(data.forms[h].totals[name][false]);
                }
              } else {
                if (name in data.forms[h].totals) {
                  Object.keys(data.forms[h].totals[name]).forEach(function (key) {
                    data.forms[h].totalsForCharts[name]['labels'].push(key);
                    data.forms[h].totalsForCharts[name]['values'].push(data.forms[h].totals[name][key]);
                  });
                }
              }
            };

            for (var j = 0; j < data.forms[h].structure.pages[_i].elements.length; j++) {
              _loop2(j);
            }
          }
        }
      };

      for (var h = 0; h < data.forms.length; h++) {
        _loop(h);
      }
    }

    /* Don't load person a second time, since the user could be in the middle of editing their profile */
    if (Object.keys(data.person).length == 0) {
      data.person = response['person'];
    }

    for (var i = 0; i < response['allPersons'].length; i++) {
      data.personsById[response['allPersons'][i].id] = response['allPersons'][i];
    }

    data.commentsById = [];
    for (var i = 0; i < data.comments.length; i++) {
      data.commentsById[data.comments[i].id] = data.comments[i];
    }

    $('.dashboard-loader').hide();
    $('.dashboard').show();

    if (callback) {
      callback(data);
    }
  });
}

function init_auto_logout() {
  var startTs = moment();
  var minutesTillWarning = 59;
  var minutesTillLogout = 60;
  var warningUp = false;

  function show_warning() {
    if (!warningUp) {
      warningUp = true;

      Swal.fire({
        title: _t['Are you still there?'],
        html: '<p>' + _t['Your session will expire soon.'] + '</p>',
        icon: 'warning',
        confirmButtonText: _t["I'm still here"],
        cancelButtonText: _t['Logout now'],
        showCancelButton: true,
        allowOutsideClick: false
      }).then(function (response) {
        if (response.isConfirmed) {
          warningUp = false;
          startTs = moment();

          $.getJSON('/current-user.json', function (response) {
            if (!response['loggedIn']) {
              window.location = localeUrlPath + '/accounts/nu-workers?redirect=' + window.location;
            }
          }).fail(function (e) {
            logout();
          });
        } else {
          logout();
        }
      });
    }
  }

  function countdown() {
    if (moment.duration(moment().diff(startTs)).asMinutes() > minutesTillWarning) {
      show_warning();
    }

    if (moment.duration(moment().diff(startTs)).asMinutes() > minutesTillLogout) {
      logout();
    }
  }

  setInterval(countdown, 1000);
}

function logout() {
  /*
    If the session has timed out, sending the user to /logout?redirect= will
    enter into a redirect loop. Instead, send the user to /nu-workers?redirect= if
    the user isn't logged in, but if they are logged in send the user
    to /logout?redirect=.
  */
  $.getJSON('/current-user.json', function (response) {
    if (response['loggedIn']) {
      window.location = localeUrlPath + '/logout?redirect=' + window.location;
    } else {
      window.location = localeUrlPath + '/nu-workers?redirect=' + window.location;
    }
  }).fail(function (e) {
    window.location = localeUrlPath + '/nu-workers?redirect=' + window.location;
  });
}

function error_occurred(response) {
  if (response.status == '403') {
    $('.dashboard').hide();
    Swal.fire({
      title: _t['session_timeout'],
      icon: 'info'
    }).then(function () {
      $('.dashboard-loader').show();
      window.location.reload();
    });
  } else {
    Swal.fire({ title: _t['error_occurred'], icon: 'error' });
  }
}

},{"@johmun/vue-tags-input":1}],12:[function(require,module,exports){
'use strict';

$(document).ready(function () {
	var items = $('[data-equal-height-source]');

	$(window).on('resize', function () {
		items.each(function () {
			var source_height = $('#' + $(this).data('equal-height-source')).css('height');

			if ($(this).data('equal-height-media').length == 0 || $(this).data('equal-height-media') == 'desktop' && $(window).width() >= 800 || $(this).data('equal-height-media') == 'mobile' && $(window).width() < 800) {
				$(this).css({ 'height': source_height });
			} else {
				$(this).css({ 'height': 'auto' });
			}
		});
	}).resize();

	setTimeout(function () {
		$(window).resize();
	}, 10);
	setTimeout(function () {
		$(window).resize();
	}, 100);
	setTimeout(function () {
		$(window).resize();
	}, 500);
	setTimeout(function () {
		$(window).resize();
	}, 1000);
});

},{}],13:[function(require,module,exports){
'use strict';

window.fps = [];

$(document).ready(function () {
	FilePond.registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImageTransform, FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilePondPluginImageCrop, FilePondPluginImageResize, FilePondPluginImagePreview);

	$('form').each(function () {
		var form = $(this);
		var files_uploading = 0;

		form.find('input[type="file"]').each(function () {
			var fid = $(this).closest('form').find('input[name="fid"]');

			var headers = {};
			headers[currentUser['csrfTokenName']] = encodeURIComponent(currentUser['csrfTokenValue']);

			var fp = FilePond.create($(this)[0], {
				maxTotalFileSize: '17mb',
				acceptedFileTypes: ['image/gif', 'image/png', 'image/jpeg', 'image/gif', 'image/apng', 'image/webp', 'image/avif', 'application/pdf'],
				imageResizeTargetWidth: 2000,
				imageResizeTargetHeight: 2000,
				imageResizeMode: 'contain',
				allowImageCrop: false,
				server: {
					url: '/form-entries/store-files/?fid=' + fid.val() + '&field=' + $(this).attr('name'),
					process: {
						ondata: function ondata(formData) {
							formData.append(currentUser['csrfTokenName'], currentUser['csrfTokenValue']);
							return formData;
						}
					}
				}
			});

			fp.on('addfilestart', function (a, b, c) {
				if (files_uploading == 0) {
					form.find('button.btn').each(function () {
						if (!$(this).prop('disabled')) {
							$(this).data('init-html', $(this).html());
							$(this).html('Please wait for files to upload...');
							$(this).attr('disabled', 'disabled');
						}
					});

					form.find('input[type="submit"].btn').each(function () {
						if (!$(this).prop('disabled')) {
							$(this).data('init-value', $(this).val());
							$(this).val(_t['Please wait for files to upload...']);
							$(this).attr('disabled', 'disabled');
						}
					});
				}

				files_uploading += 1;
			});

			fp.on('processfile', function () {
				files_uploading -= 1;

				if (files_uploading <= 0) {
					form.find('button.btn').each(function () {
						$(this).removeAttr('disabled');
						$(this).html($(this).data('init-html'));
					});

					form.find('input[type="submit"].btn').each(function () {
						$(this).removeAttr('disabled');
						$(this).val($(this).data('init-value'));
					});
				}
			});

			fps.push(fp);
		});
	});
});

window.clear_all_file_loads = function () {
	for (var i in fps) {
		fps[i].removeFiles();
	}
};

},{}],14:[function(require,module,exports){
'use strict';

Vue.component('gallery', {
    delimiters: ['${', '}'],
    props: ['initialItems'],
    data: function data() {
        return {
            items: [],
            current_item_index: -1,
            full_screen: false
        };
    },
    methods: {
        goto: function goto(index) {
            if (index < 0) {
                this.current_item_index = this.items.length - 1;
            } else if (this.current_item_index + 1 > this.items.length) {
                this.current_item_index = 0;
            } else {
                this.current_item_index = index;
            }
        },
        previous: function previous() {
            this.goto(this.current_item_index - 1);
        },
        next: function next() {
            this.goto(this.current_item_index + 1);
        },
        down: function down() {
            $('.gallery .view-caption-container')[0].scrollTop += 100;
        },
        maximize: function maximize() {
            $(this.$el).addClass('full-screen');
            this.full_screen = true;
            $('body').addClass('no-scroll');
        },
        minimize: function minimize() {
            $(this.$el).removeClass('full-screen');
            this.full_screen = false;
            $('body').removeClass('no-scroll');
        }
    },
    filters: {
        slugify: function slugify(text) {
            return text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
        }
    },
    mounted: function mounted() {
        var self = this;

        this.items = JSON.parse(this.initialItems);
        this.current_item_index = 0;

        window.addEventListener('keydown', function (e) {
            if (e.keyCode == 37) {
                self.goto(self.current_item_index - 1);
            } else if (e.keyCode == 39) {
                self.goto(self.current_item_index + 1);
            } else if (e.keyCode == 27) {
                self.minimize();
            }
        });
    },
    template: '\n        <div v-if="current_item_index != -1" class="gallery" :class="{\n            \'with-caption\': items[current_item_index].caption && items[current_item_index].caption != \'\',\n            \'full-screen\': full_screen\n        }">\n          <div class="gallery-inner">\n            <div class="gallery-inner-inner">\n              <div v-touch:swipe.left="previous" v-touch:swipe.right="next" class="view-caption-container">\n                <div class="view" :style="{ backgroundImage: \'url(\' + items[current_item_index].url + \')\' }"></div>\n                <div class="caption" v-if="items[current_item_index].caption && items[current_item_index].caption != \'\'">\n                  <i class="fas fa-arrow-down" v-on:click="down"></i>\n                  <div v-html="items[current_item_index].caption"></div>\n                </div>\n              </div>\n              <i class="fas fa-expand-arrows-alt" v-on:click="maximize" v-if="!full_screen"></i>\n              <i class="fas fa-times" v-on:click="minimize" v-if="full_screen"></i>\n              <i class="fas fa-chevron-left" v-on:click="previous"></i>\n              <i class="fas fa-chevron-right" v-on:click="next"></i>\n              <nav>\n                <ol>\n                  <li v-for="(item, index) in items" :key="item.url" :class="{ active: current_item_index == index }">\n                    <a :href="item.url | slugify" v-if="item.type == \'image\'" v-on:click.prevent.stop="goto(index);">\n                      <img :src="item.url" />\n                    </a>\n                  </li>\n                </ol>\n              </nav>\n            </div>\n          </div>\n        </div>\n    '
});

$(document).ready(function () {
    $('.gallery-container').each(function () {
        if (!$(this).attr('id')) {
            $(this).attr('id', 'gallery-' + Date.now());
        }

        var gallery_items = eval($(this).attr('items'));

        new Vue({ el: '#' + $(this).attr('id') });
    });
});

},{}],15:[function(require,module,exports){
"use strict";

},{}],16:[function(require,module,exports){
'use strict';

// Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;

	return function executedFunction() {
		var context = this;
		var args = arguments;

		var later = function later() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};

		var callNow = immediate && !timeout;

		clearTimeout(timeout);

		timeout = setTimeout(later, wait);

		if (callNow) func.apply(context, args);
	};
};

function show_search() {
	Swal.fire({
		html: '<form action="' + localeUrlPath + '/search/results" class="inline-search">' + '<input type="text" name="q" autocomplete="off" class="swal2-input" placeholder="' + t2('Search') + '..." />' + '<input type="submit" style="display:none" /><span class="fa fa-search"></span></form>',
		showConfirmButton: false,
		showCancelButton: false,
		customClass: {
			popup: 'swal-wide-450'
		}
	}).then(function (response) {
		if (response.isConfirmed) {
			window.location = localeUrlPath + '/search/results?q=' + $('#diaglog-search').val();
		}
	});
}

$(document).ready(function () {
	var logo = $('#banner .logo vimg').first();
	var header = $('header').first();

	$('.search-btn').click(function (e) {
		show_search();
		e.preventDefault();
		return false;
	});

	$('#header input[type=text]').on('focusout', function () {
		$('li.icon.search').removeClass('open');
		$('li.icon.social').removeClass('closed');
	});

	$('#header .nav-toggle').on('click tap', function () {
		$('#header .nav').toggleClass('open');
	});

	$('.search-btn-mobile').on('click tap', function (e) {
		show_search();
		e.preventDefault();
		return false;
	});

	var mobile_search = $('#header .search-btn-mobile-container form');
	var q = mobile_search.find('input[type="text"]');
	var ol = mobile_search.find('ol');
	var loader = mobile_search.find('.loader-container');

	mobile_search.on('submit', function () {
		return false;
	});

	var last_query = '';
	var load_search_results = debounce(function (e) {
		if (q.val().length == 0) {
			ol.html('');
			return;
		}

		if (last_query != q.val()) {
			ol.html('');
			loader.show();

			$.getJSON('/search/results.json?q=' + q.val(), function (data) {
				ol.html('');
				loader.hide();
				for (var i = 0; i < data.length; i++) {
					ol.append('<li><a href="' + data[i].url + '">' + data[i].title + '</a></li>');
				}
			});

			last_query = q.val();
		}
	}, 250);

	q.keyup(load_search_results);

	$('#header li.section a').on('click tap', function (e) {
		var sub = $(this).next('ul.sub').first();
		var sub_sub = $(this).children('ul.sub').first();

		if (sub.length > 0) {
			if (sub.hasClass('open2')) {
				sub.removeClass('open2');
			} else {
				sub.addClass('open2');
			}
			e.preventDefault();
			e.stopPropagation();
			return false;
		} else if (sub_sub.length > 0) {
			if (sub_sub.hasClass('open2')) {
				sub_sub.removeClass('open2');
			} else {
				sub_sub.addClass('open2');
			}
			e.preventDefault();
			return false;
		}

		if ($(window).width() <= 850) {
			var dropdown = $(this).siblings('.dropdown');
			if (dropdown.length >= 1) {
				var has_class = dropdown.hasClass('open');
				$(this).closest('ul').find('.dropdown').removeClass('open');
				if (!has_class) {
					dropdown.addClass('open');
				}
				e.preventDefault();
			} else {
				$(this).closest('.nav').removeClass('open');
			}
		}
	});

	$(window).on('resize', function () {
		$('#header .nav').removeClass('open');
	});
});

},{}],17:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\w?\W?]{8,}$/;

var params = new URLSearchParams(window.location.search);

var heoTemplates = {
    jobTitles: {
        title: t2('Please check all that apply for each job title:'),
        dialogClass: 'swal-wide-750',
        body: '\n            <form>\n                <input name="fid" type="hidden" value="42">\n                <input name="language" type="hidden">\n                <br/>\n                <div class="col-md-12 form-group inner text-left" v-for="department in heoJobTitlesSorted">\n                    <h3 class="mobile-only">{{ department.display | t }}:</h3>\n                    <h4 class="desktop-only">{{ department.display | t }}:</h4>\n                    <div class="form-group text-left odd-shaded" v-for="(jobTitle, index) in department.subJobTitles" v-if="approvedHEOIntakeForm[\'title\' + jobTitle.value]">\n                        <div class="col-md-1 col-xs-1"></div>\n                        <div class="col-md-5 col-xs-5">\n                            <label>{{ jobTitle.display | t }}</label>\n                        </div>\n                        <div class="col-md-5 col-xs-5">\n                            <label class="checkbox-inline">\n                                <input type="checkbox" v-model="approvedHEOIntakeForm[\'title\' + jobTitle.value][\'willing\']" value="Yes" true-value="Yes" false-value="No"\n                                    :name="\'title\' + jobTitle.value + \'[willing]\'"\n                                    :id="\'jobTitles-Willing-\' + jobTitle.value + index">\n                                {{ "Willing" | t }}\n                            </label>\n                            <label class="checkbox-inline">\n                                <input type="checkbox" v-model="approvedHEOIntakeForm[\'title\'  + jobTitle.value][\'experience\']" value="Yes" true-value="Yes" false-value="No"\n                                    :name="\'title\' + jobTitle.value + \'[experience]\'"\n                                    :id="\'jobTitles-Experience-\' + jobTitle.value + index">\n                                {{ "Experience" | t }}\n                            </label>\n                        </div>\n                        <div class="col-md-1 desktop-only"></div>\n                    </div>\n                    </div>\n                </div>\n            </form>\n            '
    },
    shifts: {
        title: t2('Please check the shifts you are available for:'),
        dialogClass: '',
        body: '\n            <form>\n                <input name="fid" type="hidden" value="42">\n                <input name="language" type="hidden">\n                <div class="row text-left" v-for="(shift, index) in heoValueLists.shifts">\n                    <label class="col-md-6" v-html="t(shift.display) + \': \'"></label>\n                    <label class="col-md-3" style="padding:0">\n                        <input type="radio" v-model="approvedHEOIntakeForm[\'availFor\'  + shift.value]" value="Yes"\n                            :name="\'availFor\' + shift.value"\n                            :id="\'shifts-\' + shift.value + index">\n                        {{ "Yes" | t }}\n                    </label>\n                    <label class="col-md-3" style="padding:0">\n                        <input type="radio" v-model="approvedHEOIntakeForm[\'availFor\'  + shift.value]" value="No"\n                            :name="\'availFor\' + shift.value"\n                            :id="\'shifts-\' + shift.value + index">\n                        {{ "No" | t }}\n                    </label>\n                </div>\n            </form>\n            '
    }
};

$(document).on('current-user-loaded', function () {
    if ($('#hire').length > 0) {
        window.scrollTo(0, 0);
        init_auto_logout();

        $.ajax({
            dataType: "json",
            url: localeUrlPath + '/hire/index.json',
            success: init_hire,
            error: function error(response) {
                /*
                	If an error is thrown it will be that the session has expired but the
                	vcachetoken cookie has not.
                */
                if (response['error'] == 'Forbidden') {
                    logout();
                }
            }
        });
    }
});

function matchingValues(arr1, arr2) {
    var ret = [];
    arr1.sort();
    arr1.sort();
    for (var i = 0; i < arr1.length; i += 1) {
        if (arr2.indexOf(arr1[i]) > -1) {
            ret.push(arr1[i]);
        }
    }
    return ret;
};

function init_hire(response) {
    if (response['error'] == 'Forbidden') {
        logout();
    }
    if (currentUser.verificationLevel === 'noMfa') {
        window.location = localeUrlPath + '/login';
        return;
    }

    var jobsById = {};
    for (var i in response['jobOpenings']) {
        jobsById[response['jobOpenings'][i]['id']] = response['jobOpenings'][i];
    }

    var hireJobsListing = new Vue({
        el: '#hire',
        delimiters: ['${', '}'],
        components: {
            FilePond: vueFilePond.default(FilePondPluginFileValidateType, FilePondPluginFileValidateSize)
        },
        data: function data() {
            return {
                user: currentUser,
                ubnPhone: '',
                ubnEmail: '',
                jobs: response['jobOpenings'],
                jobsById: jobsById,
                events: response['events'],
                eventTypes: response['eventTypes'],
                eventTypesForMenu: response['eventTypesForMenu'],
                registrationEventIds: response['registrationEventIds'],
                resume: response['resume'],
                replaceResume: false,
                replaceCoverLetter: false,
                coverLetter: response['coverLetter'],
                referrals: {},
                heoIntakeForm: {
                    fid: 32,
                    language: localeName,
                    psnNameFirst: '',
                    psnNameLast: '',
                    psnAddressStreet: '',
                    psnAddressCity: '',
                    psnAddressState: '',
                    psnAddressZip: '',
                    psnPhCell: '',
                    psnPhHome: '',
                    psnEmail: '',
                    psnSsn4: '',
                    psnUnionID: '',
                    reasonsForApplying: '',
                    reasonShopClosed_ShopName: '',
                    reasonPermanentLayoff_DepartmentName: '',
                    lastJobEmployer: '',
                    lastJobTitle: '',
                    currentlyWorking: '',
                    currentlyWorkingWhere: '',
                    currentlyWorkingJobTitle: '',
                    currentlyWorkingIsUnion: '',
                    currentlyWorkingJobType: '',
                    professionalCertifications: [''],
                    accessToComputer: '',
                    accessToInternet: '',
                    accessToSmartphone: '',
                    languagesSpoken: [''],
                    titleRoomAttendant: { willing: 'No', experience: 'No' },
                    titleHousePerson: { willing: 'No', experience: 'No' },
                    titleBanquetHouseman: { willing: 'No', experience: 'No' },
                    titleHousekeepingSupervisor: { willing: 'No', experience: 'No' },
                    titleHousekeepingDispatch: { willing: 'No', experience: 'No' },
                    titleBathroomAttendant: { willing: 'No', experience: 'No' },
                    titleLaundryAttendant: { willing: 'No', experience: 'No' },
                    titleGreeterHost: { willing: 'No', experience: 'No' },
                    titleBusAttendantBusser: { willing: 'No', experience: 'No' },
                    titleFoodServer: { willing: 'No', experience: 'No' },
                    titleBanquetCaptain: { willing: 'No', experience: 'No' },
                    titleBanquetServer: { willing: 'No', experience: 'No' },
                    titleCaptainMaitreD: { willing: 'No', experience: 'No' },
                    titleCafeteriaBreakfastAtt: { willing: 'No', experience: 'No' },
                    titleSommelier: { willing: 'No', experience: 'No' },
                    titleCoffeeCafeAttdBarista: { willing: 'No', experience: 'No' },
                    titleBartender: { willing: 'No', experience: 'No' },
                    titleCocktailServer: { willing: 'No', experience: 'No' },
                    titleBarAssistBarback: { willing: 'No', experience: 'No' },
                    titleTournantAllStations: { willing: 'No', experience: 'No' },
                    titleSousChef: { willing: 'No', experience: 'No' },
                    titleGardeManger: { willing: 'No', experience: 'No' },
                    titleSaucier: { willing: 'No', experience: 'No' },
                    titleLineCook: { willing: 'No', experience: 'No' },
                    titlePrepCook: { willing: 'No', experience: 'No' },
                    titleFoodRunnerExpeditor: { willing: 'No', experience: 'No' },
                    titleStewardDishPotwasher: { willing: 'No', experience: 'No' },
                    titleCashierOrderTaker: { willing: 'No', experience: 'No' },
                    titleRoomServiceServer: { willing: 'No', experience: 'No' },
                    titlePastryCookBaker: { willing: 'No', experience: 'No' },
                    titleButcher: { willing: 'No', experience: 'No' },
                    titlePantryPerson: { willing: 'No', experience: 'No' },
                    titleKitchenOther1: { willing: 'No', experience: 'No' },
                    titleBellPerson: { willing: 'No', experience: 'No' },
                    titleDoorPerson: { willing: 'No', experience: 'No' },
                    titleConcierge: { willing: 'No', experience: 'No' },
                    titleFrontDesk: { willing: 'No', experience: 'No' },
                    titleElevatorAttendant: { willing: 'No', experience: 'No' },
                    titleCoatcheck: { willing: 'No', experience: 'No' },
                    titleLobbyPorter: { willing: 'No', experience: 'No' },
                    titleFrontOfficeAdmin: { willing: 'No', experience: 'No' },
                    titleNightAuditor: { willing: 'No', experience: 'No' },
                    titleReservationClerk: { willing: 'No', experience: 'No' },
                    titleAccountingClerk: { willing: 'No', experience: 'No' },
                    titlePBXOperator: { willing: 'No', experience: 'No' },
                    titleSecurityGuard: { willing: 'No', experience: 'No' },
                    titleConstructionCarpenter: { willing: 'No', experience: 'No' },
                    titleElectrician: { willing: 'No', experience: 'No' },
                    titleEngineer: { willing: 'No', experience: 'No' },
                    titleWatchEngineer: { willing: 'No', experience: 'No' },
                    titleMaintenance: { willing: 'No', experience: 'No' },
                    titleHVACMechanic: { willing: 'No', experience: 'No' },
                    titlePainter: { willing: 'No', experience: 'No' },
                    titlePlumber: { willing: 'No', experience: 'No' },
                    titleLocksmith: { willing: 'No', experience: 'No' },
                    titleUpholstery: { willing: 'No', experience: 'No' },
                    titleAudiovisualTechnician: { willing: 'No', experience: 'No' },
                    titleDriver: { willing: 'No', experience: 'No' },
                    titleRetailCashierSales: { willing: 'No', experience: 'No' },
                    titleSeamstressTailor: { willing: 'No', experience: 'No' },
                    titleSpaFitnessPoolAttd: { willing: 'No', experience: 'No' },
                    titleMasseurMasseuse: { willing: 'No', experience: 'No' },
                    titleReceivingStoreMailroom: { willing: 'No', experience: 'No' },
                    titleMinibarAttendant: { willing: 'No', experience: 'No' },
                    titleHeavyDutyCleaner: { willing: 'No', experience: 'No' },
                    titleWindowWasher: { willing: 'No', experience: 'No' },
                    titleAquaticsAttendant: { willing: 'No', experience: 'No' },
                    titleCageCashier: { willing: 'No', experience: 'No' },
                    titleCountTeamAttendant: { willing: 'No', experience: 'No' },
                    titleEntertainmentAssociate: { willing: 'No', experience: 'No' },
                    titleEVSAttendants: { willing: 'No', experience: 'No' },
                    titleFountainBeverageAttendants: { willing: 'No', experience: 'No' },
                    titleMainBankerCashier: { willing: 'No', experience: 'No' },
                    titleMarketingAmbassador: { willing: 'No', experience: 'No' },
                    titlePokerDealer: { willing: 'No', experience: 'No' },
                    titlePokerHost: { willing: 'No', experience: 'No' },
                    titleRetailAssociate: { willing: 'No', experience: 'No' },
                    titleSlotAttendant: { willing: 'No', experience: 'No' },
                    titleSlotSupervisor: { willing: 'No', experience: 'No' },
                    titleSlotTechnicians: { willing: 'No', experience: 'No' },
                    titleSurveillance: { willing: 'No', experience: 'No' },
                    titleTableGameDealer: { willing: 'No', experience: 'No' },
                    titleWarehouseAttendantClerk: { willing: 'No', experience: 'No' },
                    titleRowBoatHandler: { willing: 'No', experience: 'No' },
                    titleOther: { willing: 'No', experience: 'No' },
                    titleOther2: { willing: 'No', experience: 'No' },
                    availForPermanentJobs: null,
                    availForSubstituteJobs: null,
                    availForAMShift: null,
                    availForPMShift: null,
                    availForOvernightShift: null,
                    availForVariedShift: null,
                    availForFullTimeJobs: null,
                    availForPartTimeJobs: null,
                    availForOnCallExtraJobs: null,
                    availForBrooklyn: null,
                    availForBronx: null,
                    availForManhattan: null,
                    availForQueens: null,
                    availForNewJersey: null,
                    availForUpstateNewYork: null,
                    availForLongIsland: null,
                    availForWestchester: null,
                    outsideIndustryOK: null,
                    okToSmsOrEmail: 'Yes',
                    signed: 'No',
                    signedName: '',
                    signedDate: ''
                },
                heoIntakeFormSubmitted: false,
                approvedHEOIntakeForm: {},
                heoTermDateStarted: null,
                heoTermDateEnded: null,
                interviewRestriction: false,
                shops: response['shops'],
                page: 'union-job-openings',
                openMenus: [],
                processing: false,
                mobileNavOpen: false,
                filterOpen: false,
                searchKeywords: '',
                searchBargainingUnitOnly: '',
                searchJobTitles: [],
                searchJobTitlesViewMore: false,
                searchRegions: [],
                searchRegionsViewMore: false,
                searchShifts: [],
                searchCapacities: [],
                shifts: [{
                    value: 'AM',
                    display: t2('AM')
                }, {
                    value: 'PM',
                    display: t2('PM')
                }, {
                    value: 'GY',
                    display: t2('Overnight')
                }, {
                    value: 'VAR',
                    display: t2('Varied')
                }],
                capacities: [{
                    value: 'Full',
                    display: t2('Full-time')
                }, {
                    value: 'Part',
                    display: t2('Part-time')
                }, {
                    value: 'Extra',
                    display: t2('On-Call (Extra)')
                }],
                jobTitles: [{
                    value: 'Housekeeping',
                    display: t2('Housekeeping'),
                    subJobTitles: [{
                        value: 'HousePerson',
                        display: t2('House Person')
                    }, {
                        value: 'Laundry Attendant',
                        display: t2('Laundry Attendant')
                    }, {
                        value: 'Room Attendant',
                        display: t2('Room Attendant')
                    }, {
                        value: 'Room Inspector/Housekeeping Supervisor',
                        display: t2('Room Inspector/Housekeeping Supervisor')
                    }, {
                        value: 'Page',
                        display: t2('Page')
                    }, {
                        value: 'Valet/Uniform Attendant',
                        display: t2('Valet/Uniform Attendant')
                    }]
                }, {
                    value: 'Front Office',
                    display: t2('Front Office'),
                    subJobTitles: [{
                        value: 'Bellperson',
                        display: t2('Bellperson')
                    }, {
                        value: 'Coatcheck Attendant',
                        display: t2('Coatcheck Attendant')
                    }, {
                        value: 'Concierge',
                        display: t2('Concierge')
                    }, {
                        value: 'Doorperson',
                        display: t2('Doorperson')
                    }, {
                        value: 'Driver',
                        display: t2('Driver')
                    }, {
                        value: 'Elevator Attendant',
                        display: t2('Elevator Attendant')
                    }, {
                        value: 'Front Desk Agent',
                        display: t2('Front Desk Agent')
                    }, {
                        value: 'Lobby Attendant',
                        display: t2('Lobby Attendant')
                    }, {
                        value: 'Night Auditor',
                        display: t2('Night Auditor')
                    }]
                }, {
                    value: 'Food Service',
                    display: t2('Food Service'),
                    subJobTitles: [{
                        value: 'Barback',
                        display: t2('Barback')
                    }, {
                        value: 'Barista',
                        display: t2('Barista')
                    }, {
                        value: 'Bartender',
                        display: t2('Bartender')
                    }, {
                        value: 'Captain',
                        display: t2('Captain')
                    }, {
                        value: 'Cashier',
                        display: t2('Cashier')
                    }, {
                        value: 'Food & Beverage Attendant',
                        display: t2('Food & Beverage Attendant')
                    }, {
                        value: 'Host',
                        display: t2('Host')
                    }, {
                        value: 'Minibar Attendant',
                        display: t2('Minibar Attendant')
                    }, {
                        value: 'Runner/Busser',
                        display: t2('Runner/Busser')
                    }, {
                        value: 'Server',
                        display: t2('Server')
                    }, {
                        value: 'Sommelier',
                        display: t2('Sommelier')
                    }]
                }, {
                    value: 'Kitchen',
                    display: t2('Kitchen'),
                    subJobTitles: [{
                        value: 'Cafe Attendant',
                        display: t2('Cafe Attendant')
                    }, {
                        value: 'Cook',
                        display: t2('Cook')
                    }, {
                        value: 'Dishwasher',
                        display: t2('Dishwasher')
                    }, {
                        value: 'Sous Chef',
                        display: t2('Sous Chef')
                    }]
                }, {
                    value: 'Engineering',
                    display: t2('Engineering'),
                    subJobTitles: [{
                        value: 'Electrician',
                        display: t2('Electrician')
                    }, {
                        value: 'Engineer',
                        display: t2('Engineer')
                    }, {
                        value: 'HVAC Specialist',
                        display: t2('HVAC Specialist')
                    }, {
                        value: 'Maintenance',
                        display: t2('Maintenance')
                    }, {
                        value: 'Painter',
                        display: t2('Painter')
                    }]
                }, {
                    value: 'Security',
                    display: t2('Security'),
                    subJobTitles: []
                }, {
                    value: 'Gaming',
                    display: t2('Gaming'),
                    subJobTitles: [{
                        value: 'Cage Cashier',
                        display: t2('Cage Cashier')
                    }, {
                        value: 'Count/Drop Team Attendant',
                        display: t2('Count/Drop Team Attendant')
                    }, {
                        value: 'Dealer',
                        display: t2('Dealer')
                    }, {
                        value: 'Main Banker',
                        display: t2('Main Banker')
                    }, {
                        value: 'Slot Attendant',
                        display: t2('Slot Attendant')
                    }, {
                        value: 'Slot Technician',
                        display: t2('Slot Technician')
                    }]
                }, {
                    value: 'Administrative',
                    display: t2('Administrative'),
                    subJobTitles: []
                }, {
                    value: 'Entertainment',
                    display: t2('Entertainment'),
                    subJobTitles: [{
                        value: 'AV Technician',
                        display: t2('AV Technician')
                    }, {
                        value: 'Entertainment Associate',
                        display: t2('Entertainment Associate')
                    }, {
                        value: 'Row Boat Handler',
                        display: t2('Row Boat Handler'),
                        hidden: true
                    }, {
                        value: 'Sales Associate',
                        display: t2('Sales Associate')
                    }]
                }, {
                    value: 'Shipping & Receiving',
                    display: t2('Shipping & Receiving'),
                    subJobTitles: [{
                        value: 'Purchaser',
                        display: t2('Purchaser')
                    }, {
                        value: 'Receiver',
                        display: t2('Receiver')
                    }, {
                        value: 'Warehouse/Storeroom Attendant',
                        display: t2('Warehouse/Storeroom Attendant')
                    }]
                }, {
                    value: 'Spa/Fitness Center',
                    display: t2('Spa/Fitness Center'),
                    subJobTitles: [{
                        value: 'Fitness Attendant',
                        display: t2('Fitness Attendant')
                    }, {
                        value: 'Lifeguard',
                        display: t2('Lifeguard')
                    }, {
                        value: 'Massage Therapist',
                        display: t2('Massage Therapist')
                    }, {
                        value: 'Spa Attendant',
                        display: t2('Spa Attendant')
                    }]
                }],
                regions: [{
                    value: 'NYC',
                    display: t2('NYC'),
                    subRegions: [{
                        value: 'Manhattan',
                        display: t2('Manhattan')
                    }, {
                        value: 'Bronx',
                        display: t2('Bronx')
                    }, {
                        value: 'Brooklyn',
                        display: t2('Brooklyn')
                    }, {
                        value: 'Queens',
                        display: t2('Queens')
                    }, {
                        value: 'Staten Island',
                        display: t2('Staten Island')
                    }]
                }, {
                    value: 'Westchester',
                    display: t2('Westchester'),
                    subRegions: []
                }, {
                    value: 'Upstate New York',
                    display: t2('Upstate New York'),
                    subRegions: [{
                        value: 'Albany',
                        display: t2('Albany')
                    }, {
                        value: 'Saratoga',
                        display: t2('Saratoga')
                    }, {
                        value: 'Catskills',
                        display: t2('Catskills')
                    }, {
                        value: 'Finger Lakes',
                        display: t2('Finger Lakes')
                    }]
                }, {
                    value: 'Long Island',
                    display: t2('Long Island'),
                    subRegions: []
                }, {
                    value: 'New Jersey',
                    display: t2('New Jersey'),
                    subRegions: [{
                        value: 'Central New Jersey',
                        display: t2('Central New Jersey')
                    }, {
                        value: 'Northern New Jersey',
                        display: t2('Northern New Jersey')
                    }]
                }],
                statuses: {
                    'Viewed': _t['Viewed'],
                    'I want to apply': _t['I want to apply'],
                    'I did apply': _t['I did apply'],
                    'I got the job!': _t['I got the job!']
                },
                heoValueLists: {
                    reasonsForApplying: [{
                        value: 'ShopClosed',
                        display: t2('Shop Closed')
                    }, {
                        value: 'PermanentLayoffClosedDepartment',
                        display: t2('Permanent Layoff/Closed Department')
                    }, {
                        value: 'TemporaryLayoff',
                        display: t2('Temporary Layoff')
                    }, {
                        value: 'ResignedTerminated',
                        display: t2('Resigned/Terminated')
                    }, {
                        value: 'LookingforSecondJob',
                        display: t2('Looking for Second Job')
                    }],
                    jobTitles: [{
                        value: "Housekeeping/Laundry",
                        display: "Housekeeping/Laundry",
                        subJobTitles: [{
                            value: 'RoomAttendant',
                            display: t2('Room Attendant')
                        }, {
                            value: 'HousePerson',
                            display: t2('House Person')
                        }, {
                            value: 'BanquetHouseman',
                            display: t2('Banquet Houseman')
                        }, {
                            value: 'HousekeepingSupervisor',
                            display: t2('Housekeeping Supervisor')
                        }, {
                            value: 'HousekeepingDispatch',
                            display: t2('Housekeeping Dispatch')
                        }, {
                            value: 'BathroomAttendant',
                            display: t2('Bathroom Attendant')
                        }, {
                            value: 'LaundryAttendant',
                            display: t2('Laundry Attendant')
                        }]
                    }, {
                        value: "Dining Room",
                        display: "Dining Room",
                        subJobTitles: [{
                            value: 'GreeterHost',
                            display: t2('Greeter/Host')
                        }, {
                            value: 'BusAttendantBusser',
                            display: t2('Bus Attendant/Busser')
                        }, {
                            value: 'FoodServer',
                            display: t2('Food Server')
                        }, {
                            value: 'BanquetCaptain',
                            display: t2('Banquet Captain')
                        }, {
                            value: 'BanquetServer',
                            display: t2('Banquet Server')
                        }, {
                            value: 'CaptainMaitreD',
                            display: t2('Captain/Maitre D’')
                        }, {
                            value: 'CafeteriaBreakfastAtt',
                            display: t2('Cafeteria/Breakfast Att.')
                        }, {
                            value: 'Sommelier',
                            display: t2('Sommelier')
                        }, {
                            value: 'CoffeeCafeAttdBarista',
                            display: t2('Coffee/Cafe Attd/Barista')
                        }]
                    }, {
                        value: "Bar",
                        display: "Bar",
                        subJobTitles: [{
                            value: 'Bartender',
                            display: t2('Bartender')
                        }, {
                            value: 'CocktailServer',
                            display: t2('Cocktail Server')
                        }, {
                            value: 'BarAssistBarback',
                            display: t2('Bar Assist/Barback')
                        }]
                    }, {
                        value: "Kitchen and Steward",
                        display: "Kitchen and Steward",
                        subJobTitles: [{
                            value: 'TournantAllStations',
                            display: t2('Tournant (All Stations)')
                        }, {
                            value: 'SousChef',
                            display: t2('Sous Chef')
                        }, {
                            value: 'GardeManger',
                            display: t2('Garde Manger')
                        }, {
                            value: 'Saucier',
                            display: t2('Saucier')
                        }, {
                            value: 'LineCook',
                            display: t2('Line Cook')
                        }, {
                            value: 'PrepCook',
                            display: t2('Prep Cook')
                        }, {
                            value: 'FoodRunnerExpeditor',
                            display: t2('Food Runner/Expeditor')
                        }, {
                            value: 'StewardDishPotwasher',
                            display: t2('Steward, Dish/Potwasher')
                        }, {
                            value: 'CashierOrderTaker',
                            display: t2('Cashier/Order Taker')
                        }, {
                            value: 'RoomServiceServer',
                            display: t2('Room Service Server')
                        }, {
                            value: 'PastryCookBaker',
                            display: t2('Pastry Cook/Baker')
                        }, {
                            value: 'Butcher',
                            display: t2('Butcher')
                        }, {
                            value: 'PantryPerson',
                            display: t2('Pantry Person')
                        }]
                    }, {
                        value: "Front Service",
                        display: "Front Service",
                        subJobTitles: [{
                            value: 'BellPerson',
                            display: t2('Bell Person')
                        }, {
                            value: 'DoorPerson',
                            display: t2('Door Person')
                        }, {
                            value: 'Concierge',
                            display: t2('Concierge')
                        }, {
                            value: 'Front Desk',
                            display: t2('Front Desk')
                        }, {
                            value: 'ElevatorAttendant',
                            display: t2('Elevator Attendant')
                        }, {
                            value: 'Coatcheck',
                            display: t2('Coatcheck')
                        }, {
                            value: 'LobbyPorter',
                            display: t2('Lobby Porter')
                        }]
                    }, {
                        value: "White Collar-Administrative",
                        display: "White Collar-Administrative",
                        subJobTitles: [{
                            value: 'FrontOfficeAdmin',
                            display: t2('Front Office/Admin')
                        }, {
                            value: 'NightAuditor',
                            display: t2('Night Auditor')
                        }, {
                            value: 'ReservationClerk',
                            display: t2('Reservation Clerk')
                        }, {
                            value: 'AccountingClerk',
                            display: t2('Accounting Clerk')
                        }, {
                            value: 'PBXOperator',
                            display: t2('PBX Operator')
                        }, {
                            value: 'SecurityGuard',
                            display: t2('Security Guard')
                        }]
                    }, {
                        value: "Engineering",
                        display: "Engineering",
                        subJobTitles: [{
                            value: 'ConstructionCarpenter',
                            display: t2('Construction/Carpenter')
                        }, {
                            value: 'Electrician',
                            display: t2('Electrician')
                        }, {
                            value: 'Engineer',
                            display: t2('Engineer')
                        }, {
                            value: 'WatchEngineer',
                            display: t2('Watch Engineer')
                        }, {
                            value: 'Maintenance',
                            display: t2('Maintenance')
                        }, {
                            value: 'HVACMechanic',
                            display: t2('HVAC Mechanic')
                        }, {
                            value: 'Painter',
                            display: t2('Painter')
                        }, {
                            value: 'Plumber',
                            display: t2('Plumber')
                        }, {
                            value: 'Locksmith',
                            display: t2('Locksmith')
                        }, {
                            value: 'Upholstery',
                            display: t2('Upholstery')
                        }]
                    }, {
                        value: "Gaming/Entertainment",
                        display: "Gaming/Entertainment",
                        subJobTitles: [{
                            value: 'AquaticsAttendant',
                            display: t2('Aquatics Attendant')
                        }, {
                            value: 'CageCashier',
                            display: t2('Cage Cashier')
                        }, {
                            value: 'CountTeamAttendant',
                            display: t2('Count Team Attendant')
                        }, {
                            value: 'EntertainmentAssociate',
                            display: t2('Entertainment Associate')
                        }, {
                            value: 'EVSAttendant',
                            display: t2('EVS Attendant')
                        }, {
                            value: 'FountainBeverageAttendant',
                            display: t2('Fountain/Beverage Attendant')
                        }, {
                            value: 'MainBankerCashier',
                            display: t2('Main Banker Cashier')
                        }, {
                            value: 'MarketingAmbassador',
                            display: t2('Marketing Ambassador')
                        }, {
                            value: 'PokerDealer',
                            display: t2('Poker Dealer')
                        }, {
                            value: 'PokerHost',
                            display: t2('Poker Host')
                        }, {
                            value: 'RetailAssociate',
                            display: t2('Retail Associate')
                        }, {
                            value: 'SlotAttendant',
                            display: t2('Slot Attendant')
                        }, {
                            value: 'SlotSupervisor',
                            display: t2('Slot Supervisor')
                        }, {
                            value: 'SlotTechnicians',
                            display: t2('Slot Technicians')
                        }, {
                            value: 'Surveillance',
                            display: t2('Surveillance')
                        }, {
                            value: 'TableGameDealer',
                            display: t2('Table Game Dealer')
                        }, {
                            value: 'WarehouseAttendantClerk',
                            display: t2('Warehouse Attendant/Clerk')
                        }]
                    }, {
                        value: "Miscellaneous",
                        display: "Miscellaneous",
                        subJobTitles: [{
                            value: 'AudiovisualTechnician',
                            display: t2('Audiovisual Technician')
                        }, {
                            value: 'Driver',
                            display: t2('Driver')
                        }, {
                            value: 'RetailCashierSales',
                            display: t2('Retail Cashier/Sales')
                        }, {
                            value: 'SeamstressTailor',
                            display: t2('Seamstress/Tailor')
                        }, {
                            value: 'SpaFitnessPoolAttd',
                            display: t2('Spa/Fitness/Pool Attd.')
                        }, {
                            value: 'MasseurMasseuse',
                            display: t2('Masseur/Masseuse')
                        }, {
                            value: 'ReceivingStoreMailroom',
                            display: t2('Receiving, Store/Mailroom')
                        }, {
                            value: 'MinibarAttendant',
                            display: t2('Minibar Attendant')
                        }, {
                            value: 'HeavyDutyCleaner',
                            display: t2('Heavy-Duty Cleaner')
                        }, {
                            value: 'RowBoatHandler',
                            display: t2('Row Boat Handler')
                        }, {
                            value: 'WindowWasher',
                            display: t2('Window Washer')
                        }]
                    }],
                    types: [{
                        value: 'PermanentJobs',
                        display: t2('Permanent Jobs')
                    }, {
                        value: 'SubstituteJobs',
                        display: t2('Substitute Jobs')
                    }],
                    shifts: [{
                        value: 'AMShift',
                        display: t2('AM')
                    }, {
                        value: 'PMShift',
                        display: t2('PM')
                    }, {
                        value: 'OvernightShift',
                        display: t2('Overnight')
                    }, {
                        value: 'VariedShift',
                        display: t2('Varied')
                    }],
                    capacities: [{
                        value: 'FullTimeJobs',
                        display: t2('Full-time Jobs')
                    }, {
                        value: 'PartTimeJobs',
                        display: t2('Part-time Jobs')
                    }, {
                        value: 'OnCallExtraJobs',
                        display: t2('On-Call (Extra) Jobs')
                    }],
                    regions: [{
                        value: 'Bronx',
                        display: t2('Bronx')
                    }, {
                        value: 'Brooklyn',
                        display: t2('Brooklyn')
                    }, {
                        value: 'LongIsland',
                        display: t2('Long Island')
                    }, {
                        value: 'Manhattan',
                        display: t2('Manhattan')
                    }, {
                        value: 'NewJersey',
                        display: t2('New Jersey')
                    }, {
                        value: 'Queens',
                        display: t2('Queens')
                    }, {
                        value: 'UpstateNewYork',
                        display: t2('Upstate New York')
                    }, {
                        value: 'Westchester',
                        display: t2('Westchester')
                    }]
                }
            };
        },

        watch: {},

        computed: {
            currentPageTitle: function currentPageTitle() {
                var link = $('.nav-link[data-slug="' + this.page + '"]');
                return link.html();
            },

            currentUrlEncoded: function currentUrlEncoded() {
                return encodeURIComponent(window.location);
            },

            jobsFilteredAndSorted: function jobsFilteredAndSorted() {
                var jobs = this.jobs;
                var data = this;

                jobs = jobs.sort(function (a, b) {
                    if (data.isElligibleForJobClassification(a) && !data.isElligibleForJobClassification(b)) {
                        return -1;
                    } else if (data.isElligibleForJobClassification(a) == data.isElligibleForJobClassification(b)) {
                        return 0;
                    } else {
                        return 1;
                    }
                });

                jobs = jobs.filter(function (job) {
                    return job.status == 'Open' && (job.isBargainingUnit || job.isL6Club) > 0 && job.interviewSlots.length > 0 && data.isElligibleForJobClassification(job);
                });

                if (data.searchJobTitles.length > 0) {
                    jobs = jobs.filter(function (job) {
                        return job.isBargainingUnit && (job.jobTitleFilters && job.jobTitleFilters != '' && matchingValues(job.jobTitleFilters.split(','), data.searchJobTitles).length > 0 || job.jobTitleUnion != '' && matchingValues(job.jobTitleUnion.split(','), data.searchJobTitles).length > 0 || job.jobTitleEmployer != '' && data.searchJobTitles.indexOf(job.jobTitleEmployer) > -1 || data.searchJobTitles.indexOf('Houseman') > -1 && matchingValues(job.jobTitleUnion.split(','), 'Room Attendant').length > 0);
                    });
                }

                if (data.searchRegions.length > 0) {
                    jobs = jobs.filter(function (job) {
                        return job.region != '' && data.searchRegions.indexOf(job.region) > -1 || job.location != '' && data.searchRegions.indexOf(job.location) > -1;
                    });
                }

                if (data.searchShifts.length > 0) {
                    jobs = jobs.filter(function (job) {
                        return job.shift != '' && data.searchShifts.indexOf(job.shift) > -1;
                    });
                }

                if (data.searchCapacities.length > 0) {
                    if (data.searchCapacities.indexOf('Extra') > -1) {
                        jobs = jobs.filter(function (job) {
                            return job.capacity != '' && data.searchCapacities.indexOf(job.capacity) > -1 || job.type == 'Extra';
                        });
                    } else {
                        jobs = jobs.filter(function (job) {
                            return job.capacity != '' && data.searchCapacities.indexOf(job.capacity) > -1;
                        });
                    }
                }

                if (this.searchKeywords != '') {
                    jobs = new Fuse(jobs, {
                        shouldSort: true,
                        threshold: 0.4,
                        maxPatternLength: 32,
                        minMatchCharLength: 1,
                        includeScore: false,
                        ignoreLocation: true,
                        keys: ["jobTitleUnion", "jobTitleEmployer", "description", "employer", "location", "region", "dateAdded", "memberAction", "memberActionDate"]
                    }).search(this.searchKeywords);
                }

                if (this.searchBargainingUnitOnly) {
                    jobs = jobs.filter(function (job) {
                        return job.isBargainingUnit;
                    });
                }

                return jobs;
            },

            filtersAreApplied: function filtersAreApplied() {
                return this.searchKeywords != '' || this.searchJobTitles.length > 0 || this.searchRegions.length > 0 || this.searchShifts.length > 0 || this.searchCapacities.length > 0;
            },

            eventsRegisteredFor: function eventsRegisteredFor() {
                var data = this;

                return this.events.filter(function (event) {
                    return data.registrationEventIds.indexOf(event.id.toString()) > -1;
                });
            },

            yourJobOpenings: function yourJobOpenings() {
                var data = this;

                var jobs = this.jobs.filter(function (job) {
                    return job.memberAction && (job.memberAction == 'I want to apply' || job.memberAction == 'I did apply' || job.memberAction == 'I got the job!');
                });

                jobs.sort(function (a, b) {
                    var a2, b2;

                    switch (a.memberAction) {
                        case 'I got the job!':
                            a2 = 3;break;
                        case 'I did apply':
                            a2 = 2;break;
                        case 'I want to apply':
                            a2 = 1;break;
                        default:
                            a2 = 0;
                    }

                    switch (b.memberAction) {
                        case 'I got the job!':
                            b2 = 3;break;
                        case 'I did apply':
                            b2 = 2;break;
                        case 'I want to apply':
                            b2 = 1;break;
                        default:
                            b2 = 0;
                    }

                    if (a2 == b2) {
                        if (b.dateAdded < a.dateAdded) {
                            return -1;
                        } else if (b.dateAdded == a.dateAdded) {
                            return 0;
                        } else {
                            return 1;
                        }
                    } else {
                        if (b2 < a2) {
                            return -1;
                        } else if (b2 == a2) {
                            return 0;
                        } else {
                            return 1;
                        }
                    }
                });

                return jobs;
            },

            upcomingInterviews: function upcomingInterviews() {
                var data = this;

                var jobs = this.jobs.filter(function (job) {
                    if (job.s2uJobOrderId) {
                        var referral = data.referrals[job.s2uJobOrderId.toString()];
                        if (referral) {
                            return moment(referral.date + ' ' + referral.time_start).isAfter(moment());
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                });

                return jobs;
            },

            pastInterviews: function pastInterviews() {
                var data = this;

                var referrals = _.values(this.referrals).filter(function (referral) {
                    return moment(referral.date + ' ' + referral.time_start).isBefore(moment());
                });

                return referrals;
            },

            isHEOTermActive: function isHEOTermActive() {
                return this.approvedHEOIntakeForm && (!this.heoTermDateEnded || moment(this.heoTermDateEnded).diff(moment(), 'days') >= 0);
            },

            heoJobTitlesSorted: function heoJobTitlesSorted() {
                var jobTitles = this.heoValueLists.jobTitles;
                var keys = Object.keys(this.heoValueLists.jobTitles);
                return keys.map(function (k) {
                    jobTitles[k].subJobTitles = jobTitles[k].subJobTitles.sort(function (a, b) {
                        if (a.display > b.display) {
                            return 1;
                        } else if (a.display < b.display) {
                            return -1;
                        } else {
                            return 0;
                        }
                    });
                    return jobTitles[k];
                });
            },

            filterJobTitlesSorted: function filterJobTitlesSorted() {
                return this.jobTitles.map(function (department) {
                    department.subJobTitles = department.subJobTitles.sort(function (a, b) {
                        if (a.display > b.display) {
                            return 1;
                        } else if (a.display < b.display) {
                            return -1;
                        } else {
                            return 0;
                        }
                    });
                    return department;
                });
            },

            approvedJobTitles: function approvedJobTitles() {
                var titles = [];
                for (var _i = 0; _i < this.heoValueLists.jobTitles.length; _i += 1) {
                    for (var j = 0; j < this.heoValueLists.jobTitles[_i].subJobTitles.length; j += 1) {
                        var jobTitle = this.heoValueLists.jobTitles[_i].subJobTitles[j];
                        if (this.approvedHEOIntakeForm['title' + jobTitle.value] && this.approvedHEOIntakeForm['title' + jobTitle.value].experience == 'Yes' && this.approvedHEOIntakeForm['title' + jobTitle.value].willing == 'Yes') {
                            titles.push(jobTitle.display);
                        }
                    }
                }
                return titles;
            },

            resumeFDServer: function resumeFDServer() {
                return {
                    url: '/form-entries/store-files/?fid=29&field=resume_Files[]',
                    method: 'POST',
                    process: {
                        headers: {
                            'X-CSRF-TOKEN': currentUser.csrfTokenValue
                        }
                    }
                };
            },

            coverLetterFDServer: function coverLetterFDServer() {
                return {
                    url: '/form-entries/store-files/?fid=30&field=coverLetter_Files[]',
                    method: 'POST',
                    process: {
                        headers: {
                            'X-CSRF-TOKEN': currentUser.csrfTokenValue
                        }
                    }
                };
            }
        },

        methods: {
            t2: t2,

            nl2br: function nl2br(string) {
                return string.replace(/[\r\n\x0B\x0C\u0085\u2028\u2029]+/g, '<div class="stylable-br"></div>');
            },

            goToPage: function goToPage(slug, hash) {
                var recordHistory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

                this.page = slug;
                this.mobileNavOpen = false;

                var data = this;
                var link = $('.nav-link[data-slug="' + this.page + '"]');

                Swal.close();

                if (recordHistory) {
                    if (hash) {
                        history.pushState({ page: slug, title: link.html() }, link.html(), link.attr('href') + '#' + hash);
                    } else {
                        history.pushState({ page: slug, title: link.html() }, link.html(), link.attr('href'));
                    }
                }

                document.title = this.currentPageTitle;

                $('a[data-slug="' + this.page + '"]').parents('.nav-item').each(function () {
                    if (data.openMenus.indexOf($(this).data('slug')) < 0) {
                        data.openMenus.push($(this).data('slug'));
                    }
                });

                setTimeout(function () {
                    if (hash) {
                        var element = $('[id="' + hash + '"], a[name="' + hash + '"]').first();
                        var y = 0;

                        if (window.outerWidth >= 850) {
                            y = element.offset()['top'] - 191 - 15;
                        } else {
                            y = element.offset()['top'] - 42 - 15;
                        }

                        if (element.length >= 1) {
                            window.scrollTo({ top: y, behavior: 'smooth' });
                        } else {
                            window.scrollTo(0, 0);
                        }
                    } else {
                        window.scrollTo(0, 0);
                    }
                }, 10);
            },

            toggleMenu: function toggleMenu(slug) {
                var index = this.openMenus.indexOf(slug);

                if (index > -1) {
                    this.openMenus.splice(index, 1);
                } else {
                    this.openMenus.push(slug);
                }
            },

            changePassword: function changePassword() {
                Swal.fire({
                    title: _t["Change Your Password"],
                    html: '<div style="text-align:left">' + '<br/><label>' + _t['New password:'] + '</label>' + '<input required="required" id="newPassword2" type="password" class="swal2-input" required>' + '<small class="help-block">' + _t['Must be at least 8 characters long and include letters and numbers'] + '</small>' + '<label>' + _t['Retype new password:'] + '</label>' + '<input required="required" id="newPasswordConfirmation2" type="password" class="swal2-input" required><br/>' + '</div>',
                    icon: 'question',
                    confirmButtonText: _t['Save'],
                    cancelButtonText: _t['cancel'],
                    showCancelButton: true,
                    preConfirm: function preConfirm() {
                        if (!$('#newPassword2').val().match(passwordRegex)) {
                            Swal.showValidationMessage(_t['Must be at least 8 characters long and include letters and numbers']);
                            return false;
                        } else if ($('#newPassword2').val() != $('#newPasswordConfirmation2').val()) {
                            Swal.showValidationMessage(_t['New password and Retype new password must match.']);
                            return false;
                        } else {
                            return {
                                'newPassword': $('#newPassword2').val()
                            };
                        }
                    }
                }).then(function (response) {
                    if (response.isConfirmed) {
                        $.ajax({
                            url: localeUrlPath + '/accounts/set-password',
                            type: 'post',
                            data: {
                                newPassword: response.value['newPassword']
                            },
                            dataType: 'json'
                        }).done(function (response) {
                            Swal.fire({ title: _t['Your password was changed successfully.'], icon: 'success' });
                        }).fail(function (e) {
                            error_occurred(e);
                            data.processing = false;
                        });
                    }
                });
            },

            requestHelp: function requestHelp() {
                request_help_hire();
            },

            isActivePage: function isActivePage(val) {
                return this.page == val;
            },

            isMenuOpen: function isMenuOpen(val) {
                return this.openMenus.includes(val);
            },

            confirmResumeIsComplete: function confirmResumeIsComplete() {
                return Swal.fire({
                    title: _t['Is your resume complete?'],
                    confirmButtonText: _t['Yes'],
                    cancelButtonText: _t['No'],
                    showCancelButton: true,
                    icon: 'question'
                }).then(function (response) {
                    if (response.isConfirmed) {
                        return true;
                    } else {
                        Swal.fire({
                            title: _t['You can only upload a complete resume.'],
                            icon: 'info'
                        });

                        return false;
                    }
                });
            },

            saveResume: function saveResume(error, file) {
                var data = this;

                /*
                	If a resume already exists, create an additional form entry that
                	marks it as deleted before we upload the new resume.
                */
                if (data.resume) {
                    $.ajax({
                        url: localeUrlPath + '/form-entries/store',
                        type: 'post',
                        data: {
                            fid: 29,
                            deleted: true,
                            formEntryFileId: data.resume.id,
                            p: currentUser.p
                        },
                        dataType: 'json'
                    }).done(function (response) {
                        data.resume = null;
                        saveResumeHelper(data);
                    }).fail(function (e) {
                        error_occurred(e);
                        deletionFailed = true;
                    });
                } else {
                    saveResumeHelper(data);
                }

                function saveResumeHelper(data) {
                    $.ajax({
                        url: localeUrlPath + '/form-entries/store',
                        type: 'post',
                        data: {
                            fid: 29,
                            'resume_Files[]': $('input[name="resume_Files[]"').val(),
                            p: currentUser.p
                        },
                        dataType: 'json'
                    }).done(function (response) {
                        load_member_data(data);
                        data.replaceResume = false;
                    }).fail(function (e) {
                        error_occurred(e);
                        data.processing = false;
                    });
                }

                return file;
            },

            deleteResume: function deleteResume(error, file) {
                var data = this;

                Swal.fire({
                    title: _t['Are you sure you want to delete your resume?'],
                    confirmButtonText: _t['Yes'],
                    cancelButtonText: _t['No'],
                    showCancelButton: true,
                    icon: 'question'
                }).then(function (response) {
                    if (response.isConfirmed) {
                        $.ajax({
                            url: localeUrlPath + '/form-entries/store',
                            type: 'post',
                            data: {
                                fid: 29,
                                deleted: true,
                                formEntryFileId: data.resume.id,
                                p: currentUser.p
                            },
                            dataType: 'json'
                        }).done(function (response) {
                            data.resume = null;
                            data.processing = false;
                        }).fail(function (e) {
                            error_occurred(e);
                            data.processing = false;
                        });
                    }
                });

                return file;
            },

            confirmCoverLetterIsComplete: function confirmCoverLetterIsComplete() {
                return Swal.fire({
                    title: _t['Is your cover letter complete?'],
                    confirmButtonText: _t['Yes'],
                    cancelButtonText: _t['No'],
                    showCancelButton: true,
                    icon: 'question'
                }).then(function (response) {
                    if (response.isConfirmed) {
                        return true;
                    } else {
                        Swal.fire({
                            title: _t['You can only upload a complete cover letter.'],
                            icon: 'info'
                        });

                        return false;
                    }
                });
            },

            saveCoverLetter: function saveCoverLetter(error, file) {
                var data = this;

                /*
                	If a cover letter already exists, create an additional form entry that
                	marks it as deleted before we upload the new cover letter.
                */
                if (data.coverLetter) {
                    $.ajax({
                        url: localeUrlPath + '/form-entries/store',
                        type: 'post',
                        data: {
                            fid: 30,
                            deleted: true,
                            formEntryFileId: data.coverLetter.id,
                            p: currentUser.p
                        },
                        dataType: 'json'
                    }).done(function (response) {
                        data.coverLetter = null;
                        saveCoverLetter(data);
                    }).fail(function (e) {
                        error_occurred(e);
                        deletionFailed = true;
                    });
                } else {
                    saveCoverLetter(data);
                }

                function saveCoverLetter(data) {
                    $.ajax({
                        url: localeUrlPath + '/form-entries/store',
                        type: 'post',
                        data: {
                            fid: 30,
                            'coverLetter_Files[]': $('input[name="coverLetter_Files[]"').val(),
                            p: currentUser.p
                        },
                        dataType: 'json'
                    }).done(function (response) {
                        load_member_data(data);
                        data.replaceCoverLetter = false;
                    }).fail(function (e) {
                        error_occurred(e);
                        data.processing = false;
                    });
                }

                return file;
            },

            deleteCoverLetter: function deleteCoverLetter(error, file) {
                var data = this;

                Swal.fire({
                    title: _t['Are you sure you want to delete your cover letter?'],
                    confirmButtonText: _t['Yes'],
                    cancelButtonText: _t['No'],
                    showCancelButton: true,
                    icon: 'question'
                }).then(function (response) {
                    if (response.isConfirmed) {
                        $.ajax({
                            url: localeUrlPath + '/form-entries/store',
                            type: 'post',
                            data: {
                                fid: 30,
                                deleted: true,
                                formEntryFileId: data.coverLetter.id,
                                p: currentUser.p
                            },
                            dataType: 'json'
                        }).done(function (response) {
                            data.coverLetter = null;
                            data.processing = false;
                        }).fail(function (e) {
                            error_occurred(e);
                            data.processing = false;
                        });
                    }
                });

                return file;
            },

            applyFilters: function applyFilters() {
                this.filterOpen = false;
                window.scrollTo(0, 0);
            },

            removeJobTitleFilter: function removeJobTitleFilter(jobTitle) {
                if (this.searchJobTitles.indexOf(jobTitle) > -1) {
                    this.searchJobTitles.splice(this.searchJobTitles.indexOf(jobTitle), 1);
                }
            },

            removeRegionFilter: function removeRegionFilter(region) {
                if (this.searchRegions.indexOf(region) > -1) {
                    this.searchRegions.splice(this.searchRegions.indexOf(region), 1);
                }
            },

            removeShiftFilter: function removeShiftFilter(shift) {
                if (this.searchShifts.indexOf(shift) > -1) {
                    this.searchShifts.splice(this.searchShifts.indexOf(shift), 1);
                }
            },

            removeCapacityFilter: function removeCapacityFilter(capacity) {
                if (this.searchCapacities.indexOf(capacity) > -1) {
                    this.searchCapacities.splice(this.searchCapacities.indexOf(capacity), 1);
                }
            },

            createAction: function createAction(job, action) {
                var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                var data = this;

                if (action == 'Viewed') {
                    window.open(job.link);
                }

                job.processing = '1';

                if (action == 'I got the job!' && job.memberAction != 'I got the job!') {
                    Swal.fire({
                        title: _t['Were you hired for'] + ' ' + job.jobTitleEmployer + ' - ' + job.employer + '?',
                        confirmButtonText: _t['Yes'],
                        cancelButtonText: _t['No'],
                        showCancelButton: true,
                        icon: 'question'
                    }).then(function (response) {
                        if (response.isConfirmed) {
                            data.createActionHelper(job, action, extra);
                        } else {
                            job.processing = '0';
                        }
                    });
                } else {
                    data.createActionHelper(job, action, extra);
                }
            },

            createActionHelper: function createActionHelper(job, action, extra) {
                var data = this;

                /* Clicking the same button twice should cancel the first click,
                                unless they are viewing interview slots */
                var canceled = job.memberAction && job.memberAction != '' && job.memberAction.indexOf(action) > -1 && job.memberAction.indexOf('(Canceled)') <= -1 && job.memberAction != 'Looked at interview slots';

                job.memberActionDate = moment().format('YYYY-MM-DD');

                if (action != 'Viewed') {
                    if (canceled) {
                        job.memberAction = action + ' (Canceled)';
                    } else {
                        job.memberAction = action;
                    }

                    if (action == 'ApplyThruHEO') {
                        if (canceled) {
                            job.memberAppliedThruHEO = false;
                            job.memberDateApplied = null;
                        } else {
                            job.memberAppliedThruHEO = true;
                            job.memberDateApplied = moment().format('YYYY-MM-DD');
                        }
                    } else if (action == 'I did apply') {
                        if (canceled) {
                            job.memberDateApplied = null;
                        } else {
                            job.memberDateApplied = moment().format('YYYY-MM-DD');
                        }
                    }
                }

                $.ajax({
                    url: localeUrlPath + '/hire/job-openings/actions/create',
                    type: 'post',
                    data: {
                        jobOpeningId: job.id,
                        action2: action,
                        canceled: canceled
                    },
                    dataType: 'json'
                }).done(function (response) {
                    job.processing = '0';
                }).fail(function (e) {
                    error_occurred(e);
                    job.processing = '0';
                });

                if (action == 'Looked at interview slots') {
                    data.showInterviewSlots(job, extra);
                }
            },

            addOrRemoveSubJobTitles: function addOrRemoveSubJobTitles(jobTitle) {
                if (this.searchJobTitles.indexOf(jobTitle.value) > -1) {
                    for (var i in jobTitle.subJobTitles) {
                        if (this.searchJobTitles.indexOf(jobTitle.subJobTitles[i].value) == -1) {
                            this.searchJobTitles.push(jobTitle.subJobTitles[i].value);
                        }
                    }
                } else {
                    for (var i in jobTitle.subJobTitles) {
                        this.removeJobTitleFilter(jobTitle.subJobTitles[i].value);
                    }
                }
            },

            addOrRemoveJobTitle: function addOrRemoveJobTitle(jobTitle) {
                var data = this;

                for (var i in jobTitle.subJobTitles) {
                    if (this.searchJobTitles.indexOf(jobTitle.subJobTitles[i].value) == -1) {
                        this.removeJobTitleFilter(jobTitle.value);
                        return;
                    }
                }

                this.searchJobTitles.push(jobTitle.value);
            },

            addOrRemoveSubRegions: function addOrRemoveSubRegions(region) {
                if (this.searchRegions.indexOf(region.value) > -1) {
                    for (var i in region.subRegions) {
                        if (this.searchRegions.indexOf(region.subRegions[i].value) == -1) {
                            this.searchRegions.push(region.subRegions[i].value);
                        }
                    }
                } else {
                    for (var i in region.subRegions) {
                        this.removeRegionFilter(region.subRegions[i].value);
                    }
                }
            },

            addOrRemoveRegion: function addOrRemoveRegion(region) {
                var data = this;

                for (var i in region.subRegions) {
                    if (this.searchRegions.indexOf(region.subRegions[i].value) == -1) {
                        this.removeRegionFilter(region.value);
                        return;
                    }
                }

                this.searchRegions.push(region.value);
            },

            removeAllSearchFilters: function removeAllSearchFilters() {
                this.searchKeywords = '';
                this.searchJobTitles = [];
                this.searchRegions = [];
                this.searchShifts = [];
                this.searchCapacities = [];
            },

            eventsForEventType: function eventsForEventType(eventType) {
                return this.events.filter(function (event) {
                    return event.eventTypeId == eventType.id;
                });
            },

            registerForEvent: function registerForEvent(event, eventType) {
                var data = this;

                $.ajax({
                    url: localeUrlPath + '/form-entries/store',
                    type: 'post',
                    data: {
                        fid: 28,
                        eventTypeUniqueCode: eventType.uniqueCode,
                        eventFmId: event.fmId,
                        eventName: event.name,
                        eventId: event.id,
                        activitySessionId: event.activitySessionId,
                        status: 'registered',
                        p: currentUser.p
                    },
                    dataType: 'json'
                }).done(function (response) {
                    if (response['message'] == 'entry-received') {
                        data.registrationEventIds.push(event.id.toString());
                        data.processing = false;

                        if (event.zoomUrl) {
                            window.open(event.zoomUrl);
                        } else if (event.url) {
                            window.open(event.url);
                        }
                    } else {
                        error_occurred(e);
                        data.processing = false;
                    }
                }).fail(function (e) {
                    error_occurred(e);
                    data.processing = false;
                });
            },

            cancelEventRegistration: function cancelEventRegistration(event, eventType) {
                var data = this;

                $.ajax({
                    url: localeUrlPath + '/form-entries/store',
                    type: 'post',
                    data: {
                        fid: 28,
                        eventTypeUniqueCode: eventType.uniqueCode,
                        eventFmId: event.fmId,
                        eventName: event.name,
                        eventId: event.id,
                        activitySessionId: event.activitySessionId,
                        status: 'canceled',
                        p: currentUser.p
                    },
                    dataType: 'json'
                }).done(function (response) {
                    if (response['message'] == 'entry-received') {
                        data.registrationEventIds.splice(data.registrationEventIds.indexOf(event.id.toString()), 1);
                        data.processing = false;
                    } else {
                        error_occurred(e);
                        data.processing = false;
                    }
                }).fail(function (e) {
                    error_occurred(e);
                    data.processing = false;
                });
            },

            registeredForEvent: function registeredForEvent(event) {
                return this.registrationEventIds.indexOf(event.id.toString()) > -1;
            },

            registredEventsForEventType: function registredEventsForEventType(eventType) {
                var data = this;

                var events = this.events.filter(function (event) {
                    return event.eventTypeId == eventType.id;
                });

                return events.filter(function (event) {
                    return data.registrationEventIds.indexOf(event.id.toString()) > -1;
                });
            },

            signUpForUBNs: function signUpForUBNs() {
                var data = this;

                $.ajax({
                    url: localeUrlPath + '/form-entries/store',
                    type: 'post',
                    data: {
                        fid: 5,
                        lastName: this.user.lastName,
                        firstName: this.user.firstName,
                        personalPhoneNumber: this.ubnPhone,
                        email: this.ubnEmail,
                        p: currentUser.p
                    },
                    dataType: 'json'
                }).done(function (response) {
                    if (response['message'] == 'entry-received') {
                        Swal.fire({
                            title: t2('Thank you! Your request has been submitted.'),
                            icon: 'success'
                        });
                        data.processing = false;
                        data.ubnPhone = '';
                        data.ubnEmail = '';
                    } else {
                        error_occurred(e);
                        data.processing = false;
                    }
                }).fail(function (e) {
                    error_occurred(e);
                    data.processing = false;
                });
            },

            editHEOInTakeForm: function editHEOInTakeForm(section) {
                var data = this;
                var data2;
                Swal.fire({
                    title: heoTemplates[section].title,
                    icon: 'question',
                    confirmButtonText: t2('Update'),
                    cancelButtonText: t2('Cancel'),
                    showCancelButton: true,
                    showCloseButton: true,
                    customClass: {
                        popup: heoTemplates[section].dialogClass
                    },
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp'
                    },
                    html: heoTemplates[section].body,
                    didRender: function didRender() {
                        data2 = new Vue({
                            el: '.swal2-content',
                            data: function (_data) {
                                function data() {
                                    return _data.apply(this, arguments);
                                }

                                data.toString = function () {
                                    return _data.toString();
                                };

                                return data;
                            }(function () {
                                return {
                                    approvedHEOIntakeForm: data.approvedHEOIntakeForm,
                                    heoJobTitlesSorted: data.heoJobTitlesSorted,
                                    heoValueLists: $.extend(true, {}, data.heoValueLists)
                                };
                            }),
                            filters: {
                                t: function t(val) {
                                    if (_t[val]) {
                                        return _t[val];
                                    } else {
                                        return val;
                                    }
                                }
                            },
                            methods: {
                                t: function t(val) {
                                    if (_t[val]) {
                                        return _t[val];
                                    } else {
                                        return val;
                                    }
                                }
                            }
                        });
                    }
                }).then(function (response) {
                    var form = $('.swal2-container form');
                    if (response.isConfirmed) {
                        $('.swal2-container button').attr('disabled', 'disabled');
                        $.ajax({
                            url: '/form-entries/store',
                            type: 'post',
                            data: form.serializeJSON({
                                // checkboxUncheckedValue: 'No'
                            }),
                            p: currentUser.p
                        }).done(function (response) {
                            Swal.fire({
                                icon: 'success',
                                title: t2('Your record was updated.'),
                                html: '<p>' + t2('Thank you! Your edits will be reviewed and updated within 1-2 business days.') + '</p>'
                            });
                        }).fail(function (response, responseText) {
                            Swal.fire({
                                title: _t['An error occurred. Please refresh this page and try again.'],
                                icon: 'error'
                            });
                            $('.swal2-container button').removeAttr('disabled');
                        });
                    }
                });
            },

            submitHEOIntakeForm: function submitHEOIntakeForm() {
                var data = this;
                var form = $('#registerWithHEOForm');

                if ($('#unionID').val() == '' && $('#ssn4').val() == '') {
                    $('#unionID').focus();
                    Swal.fire({ title: 'Please enter your Union ID or the last 4 digits of your SSN.' });
                } else if ($('#psnPhHome').val() == '' && $('#psnPhCell').val() == '') {
                    $('#psnPhHome').focus();
                    Swal.fire({ title: 'Please enter your either your home phone or your cell phone.' });
                } else if (!($('input[name="availForPermanentJobs"]').prop('checked') || $('input[name="availForSubstituteJobs"]').prop('checked'))) {
                    Swal.fire({ title: 'Please check an option for whether you willing to work permanent or substitute jobs' });
                } else if (!($('input[name="availForAMShift"]').prop('checked') || $('input[name="availForPMShift"]').prop('checked') || $('input[name="availForOvernightShift"]').prop('checked') || $('input[name="availForVariedShift"]').prop('checked'))) {
                    Swal.fire({ title: 'Please check an option for the AM, PM, overnight, or varied shifts you are willing to work.' });
                } else if (!($('input[name="availForFullTimeJobs"]').prop('checked') || $('input[name="availForPartTimeJobs"]').prop('checked') || $('input[name="availForOnCallExtraJobs"]').prop('checked'))) {
                    Swal.fire({ title: 'Please check an option for whether you are willing to work full-time jobs, part-time jobs, or on-call (extra) jobs.' });
                } else if (!($('input[name="availForBrooklyn"]').prop('checked') || $('input[name="availForBronx"]').prop('checked') || $('input[name="availForManhattan"]').prop('checked') || $('input[name="availForQueens"]').prop('checked') || $('input[name="availForNewJersey"]').prop('checked') || $('input[name="availForUpstateNewYork"]').prop('checked') || $('input[name="availForLongIsland"]').prop('checked'))) {
                    Swal.fire({ title: 'Please check an option for the regions you are willing to work in.' });
                } else {
                    form.find('button, input[type="submit"]').attr('disabled', 'disabled');

                    $.ajax({
                        url: '/hire/save-heo-intake-form',
                        type: 'post',
                        data: data.heoIntakeForm
                    }).done(function (response) {
                        data.heoIntakeFormSubmitted = true;
                        form.find('button, input[type="submit"]').removeAttr('disabled');
                        window.scrollTo(0, 0);
                    }).fail(function (response, responseText) {
                        Swal.fire({
                            title: _t['An error occurred. Please refresh this page and try again.'],
                            icon: 'error'
                        });
                        form.find('button, input[type="submit"]').removeAttr('disabled');
                    });
                }
            },

            addHEOCertification: function addHEOCertification() {
                this.heoIntakeForm.professionalCertifications.push('');
            },

            addHEOLanguageSpoken: function addHEOLanguageSpoken() {
                this.heoIntakeForm.languagesSpoken.push('');
            },

            removeHEOCertification: function removeHEOCertification(index) {
                this.heoIntakeForm.professionalCertifications.splice(index, 1);
            },

            removeHEOLanguageSpoken: function removeHEOLanguageSpoken(index) {
                this.heoIntakeForm.languagesSpoken.splice(index, 1);
            },

            referralDateAndTime: function referralDateAndTime(job, referral) {
                for (var _i2 = 0; _i2 < job.interviewSlots.length; _i2 += 1) {
                    if (job.interviewSlots[_i2].id == referral.interview_slot_id) {
                        return job.interviewSlots[_i2].date + ' ' + job.interviewSlots[_i2].time_start;
                    }
                }
            },

            referralForJob: function referralForJob(job) {
                if (job.s2uJobOrderId) {
                    return this.referrals[job.s2uJobOrderId.toString()];
                } else {
                    return null;
                }
            },

            showInterviewSlots: function showInterviewSlots(job, extra) {
                var data = this;
                var html = '<div id="interview-slots-body">\n                        <p>\n                            <label>' + t2('Job opening:') + '</label>\n                            <div class="radio">\n                                <label>' + job.jobTitleEmployer + ' - ' + job.employer + '</label>\n                            </div>\n                        </p>\n                        <p>\n                            <label>' + t2('Choose an interview:') + '</label>\n                        </p>\n                        <div style="padding: 0 0 1em 2em; width: 100%">\n                            <label>' + t2('Interview date:') + '</label>\n                            <select v-model="selectedDate" class="form-control">\n                                <option value=""></option>\n                                <option v-for="date in upcomingInterviewSlotDates" :value="date">\n                                    ${ date | date }\n                                </option>\n                            </select>\n                        </div>\n                        <div style="padding: 0 0 1em 2em; width: 100%" v-if="selectedDate">\n                            <label>' + t2('Interview time:') + '</label>\n                            <select v-model="selectedTime" class="form-control">\n                                <option value=""></option>\n                                <option v-for="time2 in upcomingInterviewSlotTimes" :value="time2">\n                                    ${ time2 }\n                                </option>\n                            </select>\n                        </div>\n                        <div style="padding: 0 0 1em 2em; width: 100%" v-if="selectedTime">\n                            <label>' + t2('Interview location:') + '</label>\n                            <select v-model="selectedInterviewSlotId" class="form-control" id="interview-slot-id">\n                                <option value=""></option>\n                                <option v-for="interviewSlot in upcomingInterviewSlotLocations" :value="interviewSlot.id">\n                                    ${ interviewSlot.address }, ${ interviewSlot.city }, ${ interviewSlot.state } ${ interviewSlot.zip }\n                                </option>\n                            </select>\n                        </div>\n                        <div class="checkbox agreement">\n                            <label>\n                                <input type="checkbox" name="interview-slot-agreement" id="interview-slot-agreement" />\n                                ' + t2('By scheduling this interview, I agree to attend or if I am no longer able to interview, to notify the Hiring Enforcement Office (HEO) prior to my scheduled interview time. I understand that failure to notify HEO may affect my ability to schedule future interviews through HEO.') + '\n                            </label>\n                        </div>\n                    </div>\n                ';
                Swal.fire({
                    title: t2('Book an interview date/time below:'),
                    html: html,
                    icon: 'question',
                    confirmButtonText: t2('Submit'),
                    cancelButtonText: t2('Cancel'),
                    showCancelButton: true,
                    customClass: {
                        popup: 'swal-wide-450'
                    },
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp'
                    },
                    preConfirm: function preConfirm(response) {
                        if (!$('.swal2-content #interview-slot-id').val()) {
                            Swal.showValidationMessage(t2('You must choose a date, time, and location above.'));
                        } else if (!$('#interview-slot-agreement').prop('checked')) {
                            Swal.showValidationMessage(t2('You must agree to the terms above.'));
                        } else if (data.isHEOTermActive) {
                            if (data.isElligibleForJobClassification(job)) {
                                job.processing = '1';
                                setTimeout(function () {
                                    $('.swal2-actions button').attr('disabled', 'disabled');
                                }, 1);
                                var interviewSlotId = $('.swal2-content #interview-slot-id').val();
                                $.ajax({
                                    url: localeUrlPath + '/hire/referrals/apply',
                                    type: 'post',
                                    data: {
                                        jobOpeningId: job.id,
                                        interviewSlotId: interviewSlotId
                                    },
                                    dataType: 'json'
                                }).done(function (response) {
                                    $('.swal2-actions button').removeAttr('disabled');
                                    job.processing = '0';
                                    if (response.status == 'success') {
                                        for (var _i3 = 0; _i3 < job.interviewSlots.length; _i3 += 1) {
                                            if (job.interviewSlots[_i3].id == interviewSlotId) {
                                                job.interviewSlots[_i3].booked = 1;
                                                response.referral['address'] = job.interviewSlots[_i3].address;
                                                response.referral['city'] = job.interviewSlots[_i3].city;
                                                response.referral['state'] = job.interviewSlots[_i3].state;
                                                response.referral['zip'] = job.interviewSlots[_i3].zip;
                                                response.referral['date'] = job.interviewSlots[_i3].date;
                                                response.referral['time_start'] = job.interviewSlots[_i3].time_start;
                                                response.referral['manager'] = job.interviewSlots[_i3].manager;
                                                response.referral['contact_phone'] = job.interviewSlots[_i3].contact_phone;
                                                response.referral['contact_phone_ext'] = job.interviewSlots[_i3].contact_phone_ext;
                                                response.referral['notes'] = job.interviewSlots[_i3].notes;
                                            }
                                        }
                                        data.referrals = Object.assign(_defineProperty({}, response.referral.job_order_id.toString(), response.referral), data.referrals);
                                        Swal.close();
                                        Swal.fire({
                                            icon: 'success',
                                            title: eval('`' + t2('You are scheduled for an interview for a ${ job.jobTitleEmployer } position at the ${ job.employer }') + '`'),
                                            confirmButtonText: t2('Ok'),
                                            customClass: {
                                                popup: 'swal-wide-450'
                                            },
                                            html: '\n                                                 <div style="text-align: left">\n                                                    <p>' + (job.noBlueCardRequired ? t2('Remember to dress professionally and bring a copy of your resume.') : t2('Please report to the Union headquarters at 709 8th Avenue at least one hour before your scheduled interview time to pick up your blue referral card. Remember to dress professionally and bring a copy of your resume.')) + '</p>\n                                                    <dl class="input-group">\n                                                        <dt class="col-xs-5">' + t2('Job opening:') + '</dt>\n                                                        <dd class="col-xs-7">' + job.jobTitleEmployer + ' - ' + job.employer + '</dd>\n                                                        <dt class="col-xs-5">' + t2('Interview location:') + '</dt>\n                                                        <dd class="col-xs-7">\n                                                            ' + response.referral.address + '<br/>\n                                                            ' + response.referral.city + ', ' + response.referral.state + ' ' + job.zip + '<br/>\n                                                            ' + (response.referral.room ? response.referral.room + '<br/>' : '') + '\n                                                            <a href="https://www.google.com/maps/search/?api=1&query=' + (response.referral.address + ' ' + response.referral.city + ' ' + response.referral.state + ' ' + response.referral.zip) + '" target="_blank">\n                                                            ' + t2('Get directions') + ' <i class="fa fa-external-link"></i></a>\n                                                        </dd>\n                                                        <dt class="col-xs-5">' + t2('Date:') + '</dt>\n                                                        <dd class="col-xs-7">' + response.referral.date + '</dd>\n                                                        <dt class="col-xs-5">' + t2('Time:') + '</dt>\n                                                        <dd class="col-xs-7">' + response.referral.time_start + '</dd>\n                                                        <dt class="col-xs-5">' + t2('Manager:') + '</dt>\n                                                        <dd class="col-xs-7">\n                                                            ' + response.referral.manager + '<br/>\n                                                            <a href="tel:' + response.referral.contact_phone + '">' + response.referral.contact_phone + '</a>\n                                                            ' + (response.referral.contactPhoneExt ? t2('Extension') + ' ' + response.referral.contactPhoneExt : '') + '\n                                                            ' + (response.referral.notes != null ? '<br/>' + response.referral.notes : '') + '\n                                                        </dd>\n                                                    </dl>\n                                                </div>\n                                            '
                                        });
                                    } else if (response.status == 'restricted') {
                                        Swal.fire({
                                            icon: 'warning',
                                            title: t2('Interview not booked.'),
                                            html: '<p>' + t2("You are not able to apply to interview for Union job openings until ${ moment(response.interviewRestriction.endTs).format(_t['date_format_js']) }.") + '</p>'
                                        });
                                    } else if (response.status == 'validation-checks-failed') {
                                        if (response.validation_errors[0].status == 'already-has-a-slot') {
                                            Swal.fire({
                                                icon: 'warning',
                                                title: t2('Interview not booked.'),
                                                html: '<p>' + t2("You already have an upcoming interview for this job opening.") + '</p>'
                                            });
                                        } else if (response.validation_errors[0].status == 'already-interviewed') {
                                            Swal.fire({
                                                icon: 'warning',
                                                title: t2('Interview not booked.'),
                                                html: '<p>' + t2("You already interviewed for this job opening.") + '</p>'
                                            });
                                        } else if (response.validation_errors[0].status == 'has-a-conflicting-slot') {
                                            Swal.fire({
                                                icon: 'warning',
                                                title: t2('Interview not booked.'),
                                                html: '<p>' + t2("You have an upcoming interview that conflicts with the timing of this interview.") + '</p>'
                                            });
                                        } else if (response.validation_errors[0].status == 'has-max-interviews-in-one-day') {
                                            Swal.fire({
                                                icon: 'warning',
                                                title: t2('Interview not booked.'),
                                                html: '<p>' + t2("You cannot sign up for more than 3 interviews in 1 day.") + '</p>'
                                            });
                                        } else if (response.validation_errors[0].status == 'has-max-interview-days-in-one-week') {
                                            Swal.fire({
                                                icon: 'warning',
                                                title: t2('Interview not booked.'),
                                                html: '<p>' + t2("You cannot sign up for interviews on more than 2 separate days in the same week.") + '</p>'
                                            });
                                        } else if (response.validation_errors[0].status == 'interview-slot-taken') {
                                            Swal.showValidationMessage(t2('This interview slot is no longer available. Please chose another date/time.'));
                                        }
                                    } else {
                                        error_occurred(e);
                                        job.processing = '0';
                                    }
                                }).fail(function (e) {
                                    error_occurred(e);
                                    job.processing = '0';
                                });
                            } else {
                                Swal.fire({
                                    icon: 'warning',
                                    title: t2('Interview not booked.'),
                                    html: '<p>' + t2('The classification for this job opening does not match the intake form you registered with the hiring enforcement office (HEO). Please call HEO at <a href="tel:2129578000">212-957-8000</a> extension 5 if you have any questions.') + '</p>'
                                });
                            }
                        } else {
                            if (data.heoIntakeFormSubmitted) {
                                Swal.fire({
                                    icon: 'warning',
                                    title: t2('Interview not booked.'),
                                    html: '<p>' + t2('Your application submittd to HEO has not been verified yet. Please come back later today. Please call HEO at <a href="tel:2129578000">212-957-8000</a> extension 5 if you have any questions.') + '</p>'
                                });
                            } else {
                                Swal.fire({
                                    icon: 'warning',
                                    title: t2('Interview not booked.'),
                                    html: '<p>' + t2('Before you can book an interview you must first register with the Hiring Enforcement Office (HEO). <a href="javascript:goToPage(\'register-with-heo\')">Click here</a> to eRegister with HEO.') + '</p>'
                                });
                            }
                        }
                        return false;
                    }
                });
                new Vue({
                    el: '#interview-slots-body',
                    delimiters: ['${', '}'],
                    data: function data() {
                        return {
                            job: job,
                            selectedDate: extra.interviewSlot ? extra.interviewSlot.date : "",
                            selectedTime: extra.interviewSlot ? extra.interviewSlot.time_start : "",
                            selectedInterviewSlotId: extra.interviewSlot ? extra.interviewSlot.id : ""
                        };
                    },
                    filters: {
                        date: function date(val) {
                            if (val) {
                                return moment(val).format(_t['date_format_js']);
                            }
                        },
                        time: function time(val) {
                            if (val) {
                                return moment(val).format(_t['time_format_js']);
                            }
                        }
                    },
                    watch: {
                        selectedDate: function selectedDate() {
                            this.selectedTime = null;
                            this.selectedInterviewSlotId = null;
                        },
                        selectedTime: function selectedTime() {
                            this.selectedInterviewSlotId = null;
                        }
                    },
                    computed: {
                        upcomingInterviewSlotDates: function upcomingInterviewSlotDates() {
                            return _.chain(this.job.interviewSlots).map('date').uniq().value();
                        },
                        upcomingInterviewSlotTimes: function upcomingInterviewSlotTimes() {
                            var data = this;
                            if (this.selectedDate) {
                                return _.chain(this.job.interviewSlots).filter(function (i) {
                                    return i.date == data.selectedDate;
                                }).map('time_start').uniq().value();
                            }
                        },
                        upcomingInterviewSlotLocations: function upcomingInterviewSlotLocations() {
                            var data = this;
                            if (this.selectedDate && this.selectedTime) {
                                return _.chain(this.job.interviewSlots).filter(function (i) {
                                    return i.date == data.selectedDate && i.time_start == data.selectedTime;
                                }).value();
                            }
                        },
                        selectedInterviewSlot: function selectedInterviewSlot() {
                            var data = this;
                            if (this.selectedInterviewSlotId) {
                                for (var _i4 = 0; _i4 < this.job.interviewSlots.length; _i4 += 1) {
                                    if (this.job.interviewSlots[_i4].id == this.selectedInterviewSlotId) {
                                        return this.job.interviewSlots[_i4];
                                    }
                                }
                            }
                        }
                    }
                });
            },

            cancelReferral: function cancelReferral(referral) {
                var data = this;
                var job;
                for (var _i5 = 0; _i5 < this.jobs.length; _i5 += 1) {
                    if (this.jobs[_i5].s2uJobOrderId == referral.job_order_id.toString()) {
                        job = this.jobs[_i5];
                        break;
                    }
                }
                Swal.fire({
                    title: t2('Are you sure you want to cancel your interview?'),
                    html: '\n                        <div style="text-align: left; margin-bottom: 1em;">\n                            <dl class="input-group">\n                                <dt class="col-sm-5">' + t2('Job opening:') + '</dt>\n                                <dd class="col-sm-7">' + job.jobTitleEmployer + ' - ' + job.employer + '</dd>\n                                <dt class="col-sm-5">' + t2('Interview location:') + '</dt>\n                                <dd class="col-sm-7">\n                                    ' + referral.address + '<br/>\n                                    ' + referral.city + ', ' + job.state + ' ' + referral.zip + '<br/>\n                                    ' + (referral.room ? referral.room + '<br/>' : '') + '\n                                    <a href="https://www.google.com/maps/search/?api=1&query=' + (referral.address + ' ' + referral.city + ' ' + referral.state + ' ' + referral.zip) + '" target="_blank">\n                                    ' + t2('Get directions') + ' <i class="fa fa-external-link"></i></a>\n                                </dd>\n                                <dt class="col-sm-5">' + t2('Date:') + '</dt>\n                                <dd class="col-sm-7">' + moment(referral.date).format(_t['date_format_js']) + '</dd>\n                                <dt class="col-sm-5">' + t2('Time:') + '</dt>\n                                <dd class="col-sm-7">' + moment('1969-12-31 ' + referral.time_start).format(_t['time_format_js']) + '</dd>\n                                <dt class="col-sm-5">' + t2('Manager:') + '</dt>\n                                <dd class="col-sm-7">' + referral.manager + '</dd>\n                            </dl>\n                            <div class="input-group">\n                                <div class="col-md-12">\n                                    <label>' + t2('Reason for cancellation:') + '</label>\n                                    <select name="cancellationReason" id="cancellation-reason" class="form-control">\n                                        <option></option>\n                                        <option value="Hired at another job!">' + t2('Hired at another job!') + '</option>\n                                        <option value="No longer interested">' + t2('No longer interested') + '</option>\n                                        <option value="Scheduling conflict">' + t2('Scheduling conflict') + '</option>\n                                        <option value="Mistake">' + t2('Mistake') + '</option>\n                                        <option value="Other">' + t2('Other') + '</option>\n                                    </select>\n                                </div>\n                            </div>\n                        </div>\n                    ',
                    customClass: {
                        popup: 'swal-wide-450'
                    },
                    icon: 'question',
                    confirmButtonText: t2('Yes, cancel my interview'),
                    cancelButtonText: t2('No, do not cancel my interview'),
                    showCancelButton: true,
                    reverseButtons: true,
                    focusCancel: true,
                    preConfirm: function preConfirm(response) {
                        var referralId = data.referrals[job.s2uJobOrderId.toString()].id;
                        setTimeout(function () {
                            $('.swal2-actions button').attr('disabled', 'disabled');
                        }, 1);
                        job.processing = '1';
                        if ($('#cancellation-reason').val() == '' || $('#cancellation-reason').val() == 'Other' && $('#cancellation-reason-other').val() == '') {
                            Swal.showValidationMessage(t2('Please provide the reason for the cancellation.'));
                            setTimeout(function () {
                                $('.swal2-actions button').removeAttr('disabled', 'disabled');
                            }, 1);
                            job.processing = '0';
                        } else {
                            $.ajax({
                                url: localeUrlPath + '/hire/referrals/cancel',
                                type: 'post',
                                data: {
                                    referralId: referralId,
                                    cancellationReason: $('#cancellation-reason').val(),
                                    cancellationReasonOther: $('#cancellation-reason-other').val()
                                },
                                dataType: 'json'
                            }).done(function (response) {
                                $('.swal2-actions button').removeAttr('disabled', 'disabled');
                                if (response.status == 'referral-canceled') {
                                    Swal.fire({
                                        icon: 'info',
                                        title: t2('Your interview was canceled.')
                                    });
                                    for (var _i6 = 0; _i6 < job.interviewSlots.length; _i6 += 1) {
                                        if (job.interviewSlots[_i6].id == response.referral.canceled_interview_slot_id) {
                                            job.interviewSlots[_i6].booked = 0;
                                        }
                                    }
                                    delete data.referrals[response.referral.job_order_id];
                                    data.referrals = Object.assign({}, data.referrals);
                                } else {
                                    Swal.fire({
                                        icon: 'warning',
                                        title: t2('Your interview was not canceled.'),
                                        html: '<p>' + t2('Please call the hiring enforecement office (HEO) at <a href="tel:2129578000">212-957-8000</a> extension 5 if you have any questions.') + '</p>'
                                    });
                                }
                                job.processing = '0';
                            }).fail(function (e) {
                                error_occurred(e);
                                job.processing = '0';
                            });
                        }
                        return false;
                    }
                });
            },

            interviewIsUpcoming: function interviewIsUpcoming(job) {
                var referral = this.referralForJob(job);
                return referral && moment(referral.date + ' ' + referral.time_start).isAfter(moment());
            },

            isElligibleForJobClassification: function isElligibleForJobClassification(job) {
                var matchFound = false;
                if (currentUser.sections.indexOf('htc-staff') > -1) {
                    matchFound = true;
                } else if (this.isHEOTermActive) {
                    /* Anyone can apply for these 3 classifications no matter what's on their HEO app */
                    if (job.jobTitleUnion.indexOf('House Attendant') > -1 || job.jobTitleUnion.indexOf('House Person') > -1 || job.jobTitleUnion.indexOf('Room Attendant') > -1 || job.jobTitleUnion.indexOf('Bathroom Attendant') > -1) {
                        matchFound = true;
                        /* Temp fix for mismatch in naming of "Steward, Dish/Potwasher" */
                    } else if (job.jobTitleUnion.indexOf('Steward, Dish/Potwasher') > -1 && this.approvedHEOIntakeForm['titleStewardDishPotwasher']) {
                        matchFound = true;
                    } else {
                        var jobTitlesUnion = job.jobTitleUnion.replace(/[\s+\(\)\/\&]/g, '').split(',');
                        for (var _i7 = 0; _i7 < jobTitlesUnion.length; _i7 += 1) {
                            var v = this.approvedHEOIntakeForm['title' + jobTitlesUnion[_i7]];
                            if (v && v.willing == 'Yes') {
                                matchFound = true;
                                break;
                            }
                        }
                    }
                }
                return matchFound;
            }
        },

        filters: {
            currency: function (_currency) {
                function currency(_x3) {
                    return _currency.apply(this, arguments);
                }

                currency.toString = function () {
                    return _currency.toString();
                };

                return currency;
            }(function (val) {
                return currency(val).format();
            }),
            date: function date(val) {
                if (val) {
                    if (val.includes(':')) {
                        return moment(val + 'Z').format(_t['date_format_js']);
                        /* If it is just a date without a time, don't force UTC */
                    } else {
                        return moment(val).format(_t['date_format_js']);
                    }
                }
            },
            datetime: function datetime(val) {
                if (val) {
                    return moment(val + 'Z').format(_t['datetime_format_js']);
                }
            },
            datetime2: function datetime2(val) {
                if (val) {
                    return moment(val).format(_t['datetime_format_js']);
                }
            },
            time: function time(val) {
                if (val) {
                    return moment(val + 'Z').format(_t['time_format_js']);
                }
            },
            localTime: function localTime(val) {
                if (val) {
                    return moment('1969-01-01 ' + val).format(_t['time_format_js']);
                }
            },
            t: function t(val) {
                if (_t[val]) {
                    return _t[val];
                } else {
                    return val;
                }
            },
            pmType: function pmType(val) {
                return card_types(val);
            },
            eventDatetime: function eventDatetime(event) {
                if (event.eventStartTs && event.eventEndTs) {
                    return moment(event.eventStartTs + 'Z').format('dddd, MMMM D') + ' ' + moment(event.eventStartTs + 'Z').format('h:mma') + '-' + moment(event.eventEndTs + 'Z').format('h:mma');
                }
            },
            nl2br: function nl2br(string) {
                return string.replace(/[\r\n\x0B\x0C\u0085\u2028\u2029]+/g, '<div class="stylable-br"></div>');
            },
            readMoreDescription: function readMoreDescription(job) {
                if (job.description.length > 125 && job.readMore == '0') {
                    return job.description.slice(0, job.description.indexOf(' ', 98));
                } else {
                    return job.description.replace(/[\r\n\x0B\x0C\u0085\u2028\u2029]+/g, '<br/>');
                }
            }
        },

        mounted: function mounted() {
            var data = this;

            $('#hire-loader').hide();
            $('#hire').show();

            window.addEventListener('popstate', function (e) {
                if (e.state && e.state.page) {
                    data.goToPage(e.state.page, false, false);
                }
            });

            $('#personalPhoneNumber').on('keypress', function (e) {
                if ($('#email').val() == '') {
                    $('#personalPhoneNumber').attr('required', 'required');
                } else {
                    $('#personalPhoneNumber').removeAttr('required');
                }

                if ($('#personalPhoneNumber').val() == '') {
                    $('#email').attr('required', 'required');
                } else {
                    $('#email').removeAttr('required');
                }
            });

            $('#email').on('keypress', function (e) {
                if ($('#email').val() == '') {
                    $('#personalPhoneNumber').attr('required', 'required');
                } else {
                    $('#personalPhoneNumber').removeAttr('required');
                }

                if ($('#personalPhoneNumber').val() == '') {
                    $('#email').attr('required', 'required');
                } else {
                    $('#email').removeAttr('required');
                }
            });

            load_member_data(data);
        }
    });
}

function load_member_data(data) {
    $.getJSON('/hire/member-data.json', function (response) {
        data.registrationEventIds = response['registrationEventIds'];
        data.resume = response['resume'];
        data.coverLetter = response['coverLetter'];
        data.heoIntakeFormSubmitted = response['heoIntakeForm'] != null;
        data.heoTermDateStarted = response['heoTermDateStarted'];
        data.heoTermDateEnded = response['heoTermDateEnded'];
        data.interviewRestriction = response['interviewRestriction'];

        if (response['approvedHEOIntakeForm'] && response['approvedHEOIntakeForm']['classifications']) {
            data.approvedHEOIntakeForm = { "psnNameFirst": "", "psnNameLast": "", "psnAddressStreet": "", "psnAddressCity": "", "psnAddressState": "", "psnAddressZip": "", "psnPhCell": "", "psnPhHome": "", "psnEmail": "", "psnSsn4": "", "psnUnionID": "", "reasonsForApplying": "", "reasonShopClosed_ShopName": "", "reasonPermanentLayoff_DepartmentName": "", "lastJobEmployer": "", "lastJobTitle": "", "currentlyWorking": "", "currentlyWorkingWhere": "", "currentlyWorkingJobTitle": "", "currentlyWorkingIsUnion": "", "currentlyWorkingJobType": "", "professionalCertifications": [], "accessToComputer": "", "accessToInternet": "", "accessToSmartphone": "", "languagesSpoken": [], "titleRoomAttendant": { "willing": "No", "experience": "No" }, "titleHousePerson": { "willing": "No", "experience": "No" }, "titleBanquetHouseman": { "willing": "No", "experience": "No" }, "titleHousekeepingSupervisor": { "willing": "No", "experience": "No" }, "titleHousekeepingDispatch": { "willing": "No", "experience": "No" }, "titleBathroomAttendant": { "willing": "No", "experience": "No" }, "titleLaundryAttendant": { "willing": "No", "experience": "No" }, "titleGreeterHost": { "willing": "No", "experience": "No" }, "titleBusAttendantBusser": { "willing": "No", "experience": "No" }, "titleFoodServer": { "willing": "No", "experience": "No" }, "titleBanquetCaptain": { "willing": "No", "experience": "No" }, "titleBanquetServer": { "willing": "No", "experience": "No" }, "titleCaptainMaitreD": { "willing": "No", "experience": "No" }, "titleCafeteriaBreakfastAtt": { "willing": "No", "experience": "No" }, "titleSommelier": { "willing": "No", "experience": "No" }, "titleCoffeeCafeAttdBarista": { "willing": "No", "experience": "No" }, "titleBartender": { "willing": "No", "experience": "No" }, "titleCocktailServer": { "willing": "No", "experience": "No" }, "titleBarAssistBarback": { "willing": "No", "experience": "No" }, "titleTournantAllStations": { "willing": "No", "experience": "No" }, "titleSousChef": { "willing": "No", "experience": "No" }, "titleGardeManger": { "willing": "No", "experience": "No" }, "titleSaucier": { "willing": "No", "experience": "No" }, "titleLineCook": { "willing": "No", "experience": "No" }, "titlePrepCook": { "willing": "No", "experience": "No" }, "titleFoodRunnerExpeditor": { "willing": "No", "experience": "No" }, "titleStewardDishPotwasher": { "willing": "No", "experience": "No" }, "titleCashierOrderTaker": { "willing": "No", "experience": "No" }, "titleRoomServiceServer": { "willing": "No", "experience": "No" }, "titlePastryCookBaker": { "willing": "No", "experience": "No" }, "titleButcher": { "willing": "No", "experience": "No" }, "titlePantryPerson": { "willing": "No", "experience": "No" }, "titleKitchenOther1": { "willing": "No", "experience": "No" }, "titleBellPerson": { "willing": "No", "experience": "No" }, "titleDoorPerson": { "willing": "No", "experience": "No" }, "titleConcierge": { "willing": "No", "experience": "No" }, "titleFrontDesk": { "willing": "No", "experience": "No" }, "titleElevatorAttendant": { "willing": "No", "experience": "No" }, "titleCoatcheck": { "willing": "No", "experience": "No" }, "titleLobbyPorter": { "willing": "No", "experience": "No" }, "titleFrontOfficeAdmin": { "willing": "No", "experience": "No" }, "titleNightAuditor": { "willing": "No", "experience": "No" }, "titleReservationClerk": { "willing": "No", "experience": "No" }, "titleAccountingClerk": { "willing": "No", "experience": "No" }, "titlePBXOperator": { "willing": "No", "experience": "No" }, "titleSecurityGuard": { "willing": "No", "experience": "No" }, "titleConstructionCarpenter": { "willing": "No", "experience": "No" }, "titleElectrician": { "willing": "No", "experience": "No" }, "titleEngineer": { "willing": "No", "experience": "No" }, "titleWatchEngineer": { "willing": "No", "experience": "No" }, "titleMaintenance": { "willing": "No", "experience": "No" }, "titleHVACMechanic": { "willing": "No", "experience": "No" }, "titlePainter": { "willing": "No", "experience": "No" }, "titlePlumber": { "willing": "No", "experience": "No" }, "titleLocksmith": { "willing": "No", "experience": "No" }, "titleUpholstery": { "willing": "No", "experience": "No" }, "titleAudiovisualTechnician": { "willing": "No", "experience": "No" }, "titleDriver": { "willing": "No", "experience": "No" }, "titleRetailCashierSales": { "willing": "No", "experience": "No" }, "titleSeamstressTailor": { "willing": "No", "experience": "No" }, "titleSpaFitnessPoolAttd": { "willing": "No", "experience": "No" }, "titleMasseurMasseuse": { "willing": "No", "experience": "No" }, "titleReceivingStoreMailroom": { "willing": "No", "experience": "No" }, "titleMinibarAttendant": { "willing": "No", "experience": "No" }, "titleHeavyDutyCleaner": { "willing": "No", "experience": "No" }, "titleWindowWasher": { "willing": "No", "experience": "No" }, "titleAquaticsAttendant": { "willing": "No", "experience": "No" }, "titleCageCashier": { "willing": "No", "experience": "No" }, "titleCountTeamAttendant": { "willing": "No", "experience": "No" }, "titleEntertainmentAssociate": { "willing": "No", "experience": "No" }, "titleEVSAttendants": { "willing": "No", "experience": "No" }, "titleFountainBeverageAttendants": { "willing": "No", "experience": "No" }, "titleMainBankerCashier": { "willing": "No", "experience": "No" }, "titleMarketingAmbassador": { "willing": "No", "experience": "No" }, "titlePokerDealer": { "willing": "No", "experience": "No" }, "titlePokerHost": { "willing": "No", "experience": "No" }, "titleRetailAssociate": { "willing": "No", "experience": "No" }, "titleSlotAttendant": { "willing": "No", "experience": "No" }, "titleSlotSupervisor": { "willing": "No", "experience": "No" }, "titleSlotTechnicians": { "willing": "No", "experience": "No" }, "titleSurveillance": { "willing": "No", "experience": "No" }, "titleTableGameDealer": { "willing": "No", "experience": "No" }, "titleWarehouseAttendantClerk": { "willing": "No", "experience": "No" }, "titleRowBoatHandler": { "willing": "No", "experience": "No" }, "titleOther": { "willing": "No", "experience": "No" }, "titleOther2": { "willing": "No", "experience": "No" }, "availForPermanentJobs": "No", "availForSubstituteJobs": "No", "availForAMShift": "No", "availForPMShift": "No", "availForOvernightShift": "No", "availForVariedShift": "No", "availForFullTimeJobs": "No", "availForPartTimeJobs": "No", "availForOnCallExtraJobs": "No", "availForBrooklyn": "No", "availForBronx": "No", "availForManhattan": "No", "availForQueens": "No", "availForNewJersey": "No", "availForUpstateNewYork": "No", "availForLongIsland": "No", "outsideIndustryOK": "No", "okToSmsOrEmail": "Yes", "signed": "No", "signedName": "", "signedDate": "" };
            for (var _i8 = 0; _i8 < response['approvedHEOIntakeForm']['classifications'].length; _i8 += 1) {
                data.approvedHEOIntakeForm['title' + response['approvedHEOIntakeForm']['classifications'][_i8].replace(/[\W_]+/g, "")] = {
                    willing: 'Yes',
                    experience: 'Yes'
                };
            }
            for (var _i9 = 0; _i9 < response['approvedHEOIntakeForm']['shifts'].length; _i9 += 1) {
                data.approvedHEOIntakeForm['availFor' + response['approvedHEOIntakeForm']['shifts'][_i9] + 'Shift'] = "Yes";
            }
        } else {
            data.approvedHEOIntakeForm = response['approvedHEOIntakeForm'];
        }

        /* If no referrals exist, PHP will return an empty array instead of an empty object, which we don't want */
        if (_typeof(response['referrals']) == 'object' && !Array.isArray(response['referrals'])) {
            data.referrals = response['referrals'];
        }

        if (params.get('cancel-interview') && data.referrals[params.get('cancel-interview')]) {
            data.cancelReferral(data.referrals[params.get('cancel-interview')]);
        }

        if (response['heoIntakeForm'] != null) {
            // data.heoIntakeForm = response['heoIntakeForm'];
        }

        for (var i in response['jobActions']) {
            var job = data.jobsById[response['jobActions'][i]['jobOpeningId']];

            if (job) {
                job.memberAction = response['jobActions'][i]['action'];

                if (job.memberAction == 'I did apply') {
                    job.memberDateApplied = response['jobActions'][i]['whenHappenedTs'];
                } else {
                    if (job.memberAction != 'ApplyThruHEO') {
                        job.memberDateApplied = null;
                    }
                }

                if (job.memberAction == 'ApplyThruHEO') {
                    job.memberAppliedThruHEO = true;
                    job.memberDateApplied = response['jobActions'][i]['whenHappenedTs'];
                } else {
                    job.memberAppliedThruHEO = false;

                    if (job.memberAction != 'I did apply') {
                        job.memberDateApplied = null;
                    }
                }
            }
        }

        data.processing = false;

        if (!params.get('cancel-interview')) {
            var pathParts = window.location.pathname.split('/');
            var slug = pathParts[pathParts.length - 1];
            var pages = $('#hire-nav a').map(function () {
                return $(this).data('slug');
            }).toArray();
            var hash = window.location.hash.slice(1);

            if (pages.includes(slug)) {
                data.goToPage(slug, hash);
            } else {
                if (!response['heoIntakeForm'] && !response['approvedHEOIntakeForm']) {
                    data.goToPage('register-with-heo', hash);
                } else {
                    data.goToPage('union-job-openings', hash);
                }
            }
        }
    }).fail(function (e) {
        data.processing = false;
    });
}

window.reset_password_hire = function (e) {
    Swal.fire({
        title: _t["Forgot your password?"],
        html: '<p>' + t2('Enter your email below and we will send you an email with a link you can use to reset your password. <input required="required" id="reset-password-email" type="email" class="swal2-input" required>') + '</p>',
        icon: 'question',
        confirmButtonText: _t['Reset Password'],
        cancelButtonText: _t['cancel'],
        showCancelButton: true,
        preConfirm: function preConfirm() {
            if ($('#reset-password-email').val() == '') {
                Swal.showValidationMessage(_t['Please enter your email.']);
                return false;
            } else {
                return {
                    'email': $('#reset-password-email').val()
                };
            }
        }
    }).then(function (response) {
        if (response.isConfirmed) {
            $.ajax({
                url: localeUrlPath + '/accounts/send-password-reset',
                type: 'post',
                data: {
                    loginName: response.value['email'],
                    page: 'login'
                },
                dataType: 'json'
            });

            Swal.fire({
                title: _t['Password reset link sent. Please check your email.'],
                icon: 'success',
                confirmButtonText: _t['Ok']
            });
        }
    });

    if (e) {
        e.preventDefault();
    }

    return false;
};

function init_auto_logout() {
    var startTs = moment();
    var minutesTillWarning = 59;
    var minutesTillLogout = 60;
    var warningUp = false;

    function show_warning() {
        if (!warningUp) {
            warningUp = true;

            Swal.fire({
                title: _t['Are you still there?'],
                html: '<p>' + _t['Your session will expire soon.'] + '</p>',
                icon: 'warning',
                confirmButtonText: _t["I'm still here"],
                cancelButtonText: _t['Logout now'],
                showCancelButton: true,
                allowOutsideClick: false
            }).then(function (response) {
                if (response.isConfirmed) {
                    warningUp = false;
                    startTs = moment();

                    $.getJSON('/current-user.json', function (response) {
                        if (!response['loggedIn']) {
                            window.location = localeUrlPath + '/login?redirect=' + window.location;
                        }
                    }).fail(function (e) {
                        logout();
                    });
                } else {
                    logout();
                }
            });
        }
    }

    function countdown() {
        if (moment.duration(moment().diff(startTs)).asMinutes() > minutesTillWarning) {
            show_warning();
        }

        if (moment.duration(moment().diff(startTs)).asMinutes() > minutesTillLogout) {
            logout();
        }
    }

    setInterval(countdown, 1000);
}

function logout() {
    /*
    	If the session has timed out, sending the user to /logout?redirect= will
    	enter into a redirect loop. Instead, send the user to /login?redirect= if
    	the user isn't logged in, but if they are logged in send the user
    	to /logout?redirect=.
    */
    $.getJSON('/current-user.json', function (response) {
        if (response['loggedIn']) {
            window.location = localeUrlPath + '/logout?redirect=' + window.location;
        } else {
            window.location = localeUrlPath + '/login?redirect=' + window.location;
        }
    }).fail(function (e) {
        window.location = localeUrlPath + '/login?redirect=' + window.location;
    });
}

function error_occurred(response) {
    if (response.status == '403') {
        $('#hire').hide();
        Swal.fire({
            title: _t['session_timeout'],
            icon: 'info'
        }).then(function () {
            $('#hire-loader').show();
            window.location.reload();
        });
    } else {
        Swal.fire({ title: _t['error_occurred'], icon: 'error' });
    }
}

},{}],18:[function(require,module,exports){
'use strict';

var params = new URLSearchParams(window.location.search);

$(document).on('current-user-loaded', function () {
	if ($('#htc-staff-login').length > 0) {
		$('.forgot-password, .forgot-password-2').on('click', reset_password_hire);

		init_login();
	}
});

function init_login() {
	$('#login form').on('submit', function (e) {
		e.preventDefault();

		var form = $(this);

		form.find('button').attr('disabled', 'disabled');

		$.ajax({
			url: localeUrlPath + '/login',
			type: 'post',
			data: $(this).serializeJSON(),
			dataType: 'json'
		}).done(function (response) {
			if (response.errorCode && response.errorCode == 'invalid_credentials') {
				form.find('button').removeAttr('disabled');
				Swal.fire({
					icon: 'warning',
					title: _t['Invalid email or password.'],
					confirmButtonText: _t['Reset Password'],
					cancelButtonText: _t['Try Again'],
					showCancelButton: true
				}).then(function (response) {
					if (response.isConfirmed) {
						reset_password();
					}
				});
			} else {
				if ($('#login input[name="redirectTo"]').val() == '') {
					if (params.get('redirect')) {
						var hash = window.location.hash.slice(1);
						if (hash) {
							window.location = params.get('redirect') + '#' + hash;
						} else {
							window.location = params.get('redirect');
						}
					} else {
						window.location.reload();
					}
				} else {
					window.location = $('#login input[name="redirectTo"]').val();
				}
			}
		}).fail(function (e) {
			error_occurred(e);
			form.find('button').removeAttr('disabled');
		});

		return false;
	});

	$('#account-loader-htc-staff').hide();
	$('#htc-staff-login').show();
	$(window).resize();
}

function init_password_reset() {
	$('#account-loader-htc-staff').hide();
	$('#password-reset').show();

	$('#password-reset form').on('submit', function (e) {
		if (!$('#newPassword').val().match(passwordRegex)) {
			Swal.fire({
				title: _t['Must be at least 8 characters long and include letters and numbers'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
		} else if ($('#newPassword').val() != $('#newPasswordConfirmation').val()) {
			Swal.fire({
				title: _t['New password and Retype new password must match'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
		} else {
			$.ajax({
				url: localeUrlPath + '/accounts/set-password',
				type: 'post',
				data: {
					vc: params.get('vc'),
					uid: params.get('uid'),
					newPassword: $('#newPassword').val()
				},
				dataType: 'json'
			}).done(function (response) {
				$('#account-loader-htc-staff').show();
				$('#password-reset').hide();

				Swal.fire({
					icon: 'success',
					title: _t['Your password was reset.'],
					confirmButtonText: _t['Ok']
				}).then(function (response) {
					window.location = localeUrlPath + '/htc-staff';
				});
			}).fail(function (e) {
				error_occurred(e);
			});
		}

		e.preventDefault();
		return false;
	});
}

function reset_password(e) {
	$('#account-loader-htc-staff').hide();

	Swal.fire({
		title: _t["Forgot your password?"],
		html: '<p>' + _t['Enter your email below and we will send you an email with a link you can use to reset your password.'] + '<input required="required" id="reset-password-email" type="email" class="swal2-input" required>',
		icon: 'question',
		confirmButtonText: _t['Reset Password'],
		cancelButtonText: _t['cancel'],
		showCancelButton: true,
		preConfirm: function preConfirm() {
			if ($('#reset-password-email').val() == '') {
				Swal.showValidationMessage(_t['Please enter your email.']);
				return false;
			} else {
				return {
					'email': $('#reset-password-email').val()
				};
			}
		}
	}).then(function (response) {
		if (response.isConfirmed) {
			$.ajax({
				url: localeUrlPath + '/accounts/send-password-reset',
				type: 'post',
				data: {
					loginName: response.value['email'],
					page: 'nu-workers'
				},
				dataType: 'json'
			});

			Swal.fire({
				title: _t['Password reset link sent. Please check your email.'],
				icon: 'success',
				confirmButtonText: _t['Ok']
			});
		}
	});

	if (e) {
		e.preventDefault();
	}

	return false;
}

function error_occurred(response) {
	if (response.status == '403') {
		$('#account').hide();
		Swal.fire({
			title: _t['session_timeout'],
			icon: 'info',
			confirmButtonText: _t['Ok']
		}).then(function () {
			$('#account-loader-htc-staff').show();
			window.location.reload();
		});
	} else {
		Swal.fire({
			title: _t['error_occurred'],
			icon: 'error',
			confirmButtonText: _t['Ok']
		});
	}
}

},{}],19:[function(require,module,exports){
'use strict';

var passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\w?\W?]{8,}$/;

var params = new URLSearchParams(window.location.search);

window.handle_recaptcha_2 = function (token) {
	$('input[name="captchaToken"]').val(token);
	$('.g-recaptcha').siblings('p.text-danger').remove();
};

window.handle_recaptcha_expired_2 = function () {
	$('input[name="captchaToken"]').val('');
};

$(document).on('current-user-loaded', function () {
	if ($('#nu-workers-login-or-create-claim').length > 0) {
		$('.forgot-password, .forgot-password-2').on('click', reset_password_hire);

		init_login_or_claim();
	}
});

function init_login_or_claim() {
	$('input[name="personType"]').on('change', function () {
		if ($('input[name="personType"]:checked').val() == 'Member') {
			if ($('#create-account-claim input[name="st"]').val() != '') {
				$('.registration-union-member > :not(.no-registration-code)').find('input,select').attr('required', 'required');
			} else {
				$('.registration-union-member').find('input,select').attr('required', 'required');
			}

			$('.registration-union-member #registration-code-container input').removeAttr('required');
			$('.registration-union-member').show();
			$('.registration-non-union-worker').hide();
		} else if ($('input[name="personType"]:checked').val() == 'Non-Union Worker') {
			$('.registration-union-member').find('input,select').removeAttr('required');
			$('.registration-union-member').hide();
			$('.registration-non-union-worker').show();
		}
	}).change();

	$('#create-account-claim form').on('submit', function (e) {
		e.preventDefault();
		var form = $(this);
		var captchaToken = form.find('input[name="captchaToken"]');
		var hash = window.location.hash.slice(1);

		form.find('button').attr('disabled', 'disabled');

		if (!$(this).find('#password').val().match(passwordRegex)) {
			Swal.fire({
				title: _t['Must be at least 8 characters long and include letters and numbers'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
			form.find('button').removeAttr('disabled');
		} else if ($(this).find('#password').val() != $(this).find('#passwordConfirmation').val()) {
			Swal.fire({
				title: _t['Password and Password confirmation must match'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
			form.find('button').removeAttr('disabled');
		} else if (captchaToken.length > 0 && captchaToken.val() == '') {
			form.find('.g-recaptcha').siblings('p.text-danger').remove();
			form.find('.g-recaptcha').after('<p class="text-danger">' + _t['Please verify that you are not a robot.'] + '</p>');
			form.find('button').removeAttr('disabled');
		} else {
			$.ajax({
				url: localeUrlPath + '/account-claims/create',
				type: 'post',
				data: Object.assign({}, $(this).serializeJSON(), {
					captchaToken: captchaToken.val(),
					redirectToUponVerification: window.location.toString()
				}),
				dataType: 'json'
			}).done(function (response) {
				form.find('button').removeAttr('disabled');

				if (response['acUid']) {
					$('#create-account-claim input[name="acUid"]').val(response['acUid']);
				}

				if (response['status'] == 'data-match-passed') {
					$('#nu-workers-login-or-create-claim form input[name="st"]').val(response['st']);

					form.find('button').attr('disabled', 'disabled');

					$.ajax({
						url: localeUrlPath + '/accounts/create',
						type: 'post',
						data: $(form).serializeJSON(),
						dataType: 'json'
					}).done(function (response) {
						if (response['status'] == 'account-created') {
							$.getScript('/current-user-2.js', function (response) {
								window.location.reload();
							});
						} else if (response['status'] == 'not-eligible') {
							window.scrollTo(0, 0);
							$('#nu-workers-login-or-create-claim').hide();
							$('#not-eligible').show();
						} else if (response['status'] == 'person-already-claimed') {
							Swal.fire({
								title: _t['You already have an account. Please login using your email and password.'],
								icon: 'info',
								confirmButtonText: _t['Ok']
							});
							window.scrollTo(0, 0);
						} else if (response['status'] == 'email-already-in-use') {
							Swal.fire({
								title: _t['Email address already in use.'],
								html: '<p>' + _t['Please try again with a different email address, or use the form below to request help from a Union representative.'] + '</p>',
								icon: 'info',
								confirmButtonText: _t['Ok']
							}).then(function () {
								window.scrollTo(0, 0);
								$('#nu-workers-login-or-create-claim').hide();
								init_login_or_claim();
							});
						} else if (response['status'] == 'username-already-in-use') {
							Swal.fire({
								title: _t['Username already in use.'],
								html: '<p>' + _t['Please try again with a different username, or use the form below to request help from a Union representative.'] + '</p>',
								icon: 'info',
								confirmButtonText: _t['Ok']
							}).then(function () {
								window.scrollTo(0, 0);
								$('#nu-workers-login-or-create-claim').hide();
								init_login_or_claim();
							});
						} else {
							error_occurred(e);
						}
					}).fail(function (e) {
						error_occurred(e);
					});
				} else if (response['status'] == 'invalid-email-work-domain') {
					Swal.fire({
						title: _t['Please use your personal email address, not work your email address.'],
						icon: 'info',
						confirmButtonText: _t['Ok']
					});
				} else if (response['status'] == 'invalid-email-formatting') {
					Swal.fire({
						title: _t['Please provide a valid email address.'],
						icon: 'info',
						confirmButtonText: _t['Ok']
					});
				} else if (response['status'] == 'person-already-claimed') {
					Swal.fire({
						title: _t['You already have an account. Please login using your email and password.'],
						icon: 'info',
						confirmButtonText: _t['Ok']
					});
					window.scrollTo(0, 0);
				} else if (response['status'] == 'email-already-in-use') {
					request_help_hire(_t['Email already in use.'], '<p>' + _t['Please try again with a different email, or use the form below to request help from a Union representative.'] + '</p>', 'question', _t['request_help'], _t['try_again']);
					window.scrollTo(0, 0);
				} else if (response['status'] == 'username-already-in-use') {
					request_help_hire(_t['Username already in use.'], '<p>' + _t['Please try again with a different username, or use the form below to request help from a Union representative.'] + '</p>', 'question', _t['request_help'], _t['try_again']);
					window.scrollTo(0, 0);
				} else if (response['status'] == 'not-eligible') {
					window.scrollTo(0, 0);
					$('#nu-workers-login-or-create-claim').hide();
					$('#not-eligible').show();
				} else if (response['status'] == 'invalid-captcha') {
					$('input[name="captchaToken"]').val('');
					form.find('.g-recaptcha').after('<p class="text-danger">' + _t['Please verify that you are not a robot.'] + '</p>');
					grecaptcha.reset();
				} else {
					request_help_hire(_t['We did not find you in our records.'], '<p>' + _t['Use the form below to request help from a Union representative.'] + '</p>', 'question', _t['request_help'], _t['try_again']);
				}
			}).fail(function (e) {
				error_occurred(e);
				form.find('button').removeAttr('disabled');
			});
		}

		e.preventDefault();
		return false;
	});

	$('#login form').on('submit', function (e) {
		var form = $(this);

		form.find('button').attr('disabled', 'disabled');

		$.ajax({
			url: localeUrlPath + '/login',
			type: 'post',
			data: $(this).serializeJSON(),
			dataType: 'json'
		}).done(function (response) {
			if (response.errorCode && response.errorCode == 'invalid_credentials') {
				form.find('button').removeAttr('disabled');
				Swal.fire({
					icon: 'warning',
					title: _t['Invalid email or password.'],
					confirmButtonText: _t['Reset Password'],
					cancelButtonText: _t['Try Again'],
					showCancelButton: true
				}).then(function (response) {
					if (response.isConfirmed) {
						reset_password();
					}
				});
			} else {
				if ($('#login input[name="redirectTo"]').val() == '') {
					if (params.get('redirect')) {
						var hash = window.location.hash.slice(1);
						if (hash) {
							window.location = params.get('redirect') + '#' + hash;
						} else {
							window.location = params.get('redirect');
						}
					} else {
						window.location.reload();
					}
				} else {
					window.location = $('#login input[name="redirectTo"]').val();
				}
			}
		}).fail(function (e) {
			error_occurred(e);
			form.find('button').removeAttr('disabled');
		});

		e.preventDefault();
		return false;
	});

	$('#account-loader-nu-workers').hide();
	$('#nu-workers-login-or-create-claim').show();
	$(window).resize();
}

function init_password_reset() {
	$('#account-loader-nu-workers').hide();
	$('#password-reset').show();

	$('#password-reset form').on('submit', function (e) {
		if (!$('#newPassword').val().match(passwordRegex)) {
			Swal.fire({
				title: _t['Must be at least 8 characters long and include letters and numbers'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
		} else if ($('#newPassword').val() != $('#newPasswordConfirmation').val()) {
			Swal.fire({
				title: _t['New password and Retype new password must match'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
		} else {
			$.ajax({
				url: localeUrlPath + '/accounts/set-password',
				type: 'post',
				data: {
					vc: params.get('vc'),
					uid: params.get('uid'),
					newPassword: $('#newPassword').val()
				},
				dataType: 'json'
			}).done(function (response) {
				$('#account-loader-nu-workers').show();
				$('#password-reset').hide();

				Swal.fire({
					icon: 'success',
					title: _t['Your password was reset.'],
					confirmButtonText: _t['Ok']
				}).then(function (response) {
					window.location = localeUrlPath + '/hire';
				});
			}).fail(function (e) {
				error_occurred(e);
			});
		}

		e.preventDefault();
		return false;
	});
}

function reset_password(e) {
	$('#account-loader-nu-workers').hide();

	Swal.fire({
		title: _t["Forgot your password?"],
		html: '<p>' + _t['Enter your email below and we will send you an email with a link you can use to reset your password.'] + '<input required="required" id="reset-password-email" type="email" class="swal2-input" required>',
		icon: 'question',
		confirmButtonText: _t['Reset Password'],
		cancelButtonText: _t['cancel'],
		showCancelButton: true,
		preConfirm: function preConfirm() {
			if ($('#reset-password-email').val() == '') {
				Swal.showValidationMessage(_t['Please enter your email.']);
				return false;
			} else {
				return {
					'email': $('#reset-password-email').val()
				};
			}
		}
	}).then(function (response) {
		if (response.isConfirmed) {
			$.ajax({
				url: localeUrlPath + '/accounts/send-password-reset',
				type: 'post',
				data: {
					loginName: response.value['email'],
					page: 'nu-workers'
				},
				dataType: 'json'
			});

			Swal.fire({
				title: _t['Password reset link sent. Please check your email.'],
				icon: 'success',
				confirmButtonText: _t['Ok']
			});
		}
	});

	if (e) {
		e.preventDefault();
	}

	return false;
}

function error_occurred(response) {
	if (response.status == '403') {
		$('#account').hide();
		Swal.fire({
			title: _t['session_timeout'],
			icon: 'info',
			confirmButtonText: _t['Ok']
		}).then(function () {
			$('#account-loader-nu-workers').show();
			window.location.reload();
		});
	} else {
		Swal.fire({
			title: _t['error_occurred'],
			icon: 'error',
			confirmButtonText: _t['Ok']
		});
	}
}

},{}],20:[function(require,module,exports){
'use strict';

var passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\w?\W?]{8,}$/;

var params = new URLSearchParams(window.location.search);

window.handle_recaptcha_2 = function (token) {
	$('input[name="captchaToken"]').val(token);
	$('.g-recaptcha').siblings('p.text-danger').remove();
};

window.handle_recaptcha_expired_2 = function () {
	$('input[name="captchaToken"]').val('');
};

$(document).on('current-user-loaded', function () {
	$('#memberEmployer, #employer2').html('<option> <\/option><option>' + shops.join('<\/option><option>') + '<\/option>');
	$('#memberEmployer, #employer2').select2({ width: '100%' });

	if ($('#create-account-2').length > 0) {
		if (currentUser.loggedIn && currentUser.verificationLevel == 'verified') {
			if (currentUser.sections.indexOf('htc-staff')) {
				window.location = localeUrlPath + '/htc-staff';
			} else if (currentUser.sections.indexOf('nu-workers')) {
				window.location = localeUrlPath + '/nu-workers';
			} else if (currentUser.sections.indexOf('dues-users')) {
				window.location = localeUrlPath + '/payments';
			} else if (currentUser.sections.indexOf('hire-users')) {
				window.location = localeUrlPath + '/hire';
			}
		} else {
			$('.forgot-password, .forgot-password-2').on('click', reset_password_hire);

			// Change the c param to vc at some point to better differentiate it from the ac param - jer 2021-09-23 
			if (params.get('c')) {
				init_quick_2f_verification();
			} else if (params.get('a') == 'set-password') {
				init_password_reset();
			} else if (params.get('a') == 'verify-email') {
				init_verify_email();
			} else if (currentUser.loggedIn && currentUser.verificationLevel == 'noMfa') {
				init_login_or_claim();
			} else if (currentUser.loggedIn && currentUser.verificationLevel != 'emailverified') {
				init_finish_creating_your_account();
			} else if (currentUser.loggedIn) {
				if (currentUser.twoFactorVerification.tooManyAttempts) {
					$('#account-loader-2').hide();
					$('#too-many-attempts').show();
				} else if (currentUser.twoFactorVerification && currentUser.twoFactorVerification.expiresAt) {
					init_validate_2f_code(currentUser.twoFactorVerification.deliveryMethod);
				} else {
					init_choose_2f_method();
				}
			} else if (params.get('ac')) {
				authorize_code_and_then(params.get('ac'), 'account-creation', function (response) {
					if (response['status'] == 'success') {
						$('#create-account-claim input[name="st"]').val(response['st']);
						if ('redirectTo' in response['data']) {
							$('input[name="redirectTo"]').val(response['data']['redirectTo']);
						}
						$('#registration-code-container').hide();
					} else {
						$('#registration-code-container').show();
					}

					init_login_or_claim();
				});
			} else {
				init_login_or_claim();
			}
		}
	}
});

function runCurrentUser() {
	return new Promise(function (resolve, reject) {
		var currentUserScript = document.createElement('script');
		currentUserScript.src = '/current-user.js';
		// currentUserScript.async = true;
		currentUserScript.onload = resolve;
		currentUserScript.onerror = reject;
		document.head.appendChild(currentUserScript);
	});
}

function init_quick_2f_verification() {
	if (currentUser.loggedIn) {
		quick_2f_verification();
	} else {
		$('#members-login-container form').off('submit').on('submit', function (e) {
			var form = $(this);
			form.find('button').attr('disabled', 'disabled');

			$.ajax({
				url: localeUrlPath + '/login',
				type: 'post',
				data: $(this).serializeJSON(),
				dataType: 'json'
			}).done(function (response) {
				if (response.errorCode && response.errorCode == 'invalid_credentials') {
					form.find('button').removeAttr('disabled');
					Swal.fire({
						icon: 'warning',
						title: _t['Invalid email or password.'],
						confirmButtonText: _t['Reset Password'],
						cancelButtonText: _t['Try Again'],
						showCancelButton: true
					}).then(function (response) {
						if (response.isConfirmed) {
							reset_password();
						}
					});
				} else {
					quick_2f_verification();
				}
			}).fail(function (e) {
				error_occurred(e);
				form.find('button').removeAttr('disabled');
			});

			e.preventDefault();
			return false;
		});

		$('#members-login-container').show();
		$('#account-loader-2').hide();
	}
}

function quick_2f_verification() {
	$.ajax({
		url: localeUrlPath + '/accounts/validate-two-factor-verification-code',
		type: 'post',
		data: {
			code: params.get('c')
		},
		dataType: 'json'
	}).done(function (response) {
		$('#account-loader-2').hide();

		if (response['status'] == 'invalid-code') {
			Swal.fire({
				title: _t['Your 6-digit verfication code has expired.'],
				icon: 'question',
				confirmButtonText: _t['Ok']
			}).then(function (response) {
				if (params.get('redirect')) {
					window.location = params.get('redirect');
				} else {
					window.location = localeUrlPath + '/hire';
				}
			});
		} else if (response['status'] == 'too-many-attempts') {
			$('#verify-2f-enter-code').hide();
			$('#too-many-attempts').show();
		} else {
			$('#verify-2f-choose-delivery-method').hide();
			$('#verify-2f-enter-code').hide();

			Swal.fire({
				title: _t['Thank you!'],
				icon: 'success',
				confirmButtonText: _t['Ok']
			}).then(function () {
				window.location = localeUrlPath + '/hire';
			});

			setTimeout(function () {
				window.location = localeUrlPath + '/hire';
			}, 5000);
		}

		setTimeout(function () {
			if (params.get('redirect')) {
				window.location = params.get('redirect');
			} else {
				window.location = localeUrlPath + '/hire';
			}
		}, 2000);
	});
}

function init_login_or_claim() {
	$('input[name="personType"]').on('change', function () {
		if ($('input[name="personType"]:checked').val() == 'Member') {
			if ($('#create-account-claim input[name="st"]').val() != '') {
				$('.registration-union-member > :not(.no-registration-code)').find('input,select').attr('required', 'required');
			} else {
				$('.registration-union-member').find('input,select').attr('required', 'required');
			}

			$('.registration-union-member #registration-code-container input').removeAttr('required');
			$('.registration-union-member').show();
			$('.registration-non-union-worker').hide();
		} else if ($('input[name="personType"]:checked').val() == 'Non-Union Worker') {
			$('.registration-union-member').find('input,select').removeAttr('required');
			$('.registration-union-member').hide();
			$('.registration-non-union-worker').show();
		}
	}).change();

	$('#create-account-claim form').on('submit', function (e) {
		e.preventDefault();
		var form = $(this);
		var captchaToken = form.find('input[name="captchaToken"]');
		var hash = window.location.hash.slice(1);

		form.find('button').attr('disabled', 'disabled');

		if (captchaToken.length > 0 && captchaToken.val() == '') {
			form.find('.g-recaptcha').siblings('p.text-danger').remove();
			form.find('.g-recaptcha').after('<p class="text-danger">' + _t['Please verify that you are not a robot.'] + '</p>');
			form.find('button').removeAttr('disabled');
		} else {
			$.ajax({
				url: localeUrlPath + '/account-claims/create',
				type: 'post',
				data: Object.assign({}, $(this).serializeJSON(), {
					captchaToken: captchaToken.val(),
					redirectToUponVerification: window.location.toString()
				}),
				dataType: 'json'
			}).done(function (response) {
				if (response['acUid']) {
					$('#create-account-claim input[name="acUid"]').val(response['acUid']);
				}

				if (response['status'] == 'data-match-passed') {
					$('#create-account-2 form input[name="st"]').val(response['st']);
					init_create_account();
				} else if (response['status'] == 'invalid-email-work-domain') {
					Swal.fire({
						title: _t['Please use your personal email address, not work your email address.'],
						icon: 'info',
						confirmButtonText: _t['Ok']
					});
				} else if (response['status'] == 'invalid-email-formatting') {
					Swal.fire({
						title: _t['Please provide a valid email address.'],
						icon: 'info',
						confirmButtonText: _t['Ok']
					});
				} else if (response['status'] == 'person-already-claimed') {
					Swal.fire({
						title: _t['You already have an account. Please login using your email and password.'],
						icon: 'info',
						confirmButtonText: _t['Ok']
					});

					window.scrollTo(0, 0);
				} else if (response['status'] == 'email-already-in-use') {
					request_help_hire(_t['Email already in use.'], '<p>' + _t['Please try again with a different email, or use the form below to request help from a Union representative.'] + '</p>', 'question', _t['request_help'], _t['try_again']);

					window.scrollTo(0, 0);
				} else if (response['status'] == 'not-eligible') {
					window.scrollTo(0, 0);
					$('#members-login-or-create-claim').hide();
					$('#not-eligible').show();
				} else if (response['status'] == 'invalid-captcha') {
					$('input[name="captchaToken"]').val('');
					form.find('.g-recaptcha').after('<p class="text-danger">' + _t['Please verify that you are not a robot.'] + '</p>');
					form.find('button').removeAttr('disabled');
					grecaptcha.reset();
				} else {
					form.find('button').removeAttr('disabled');
					request_help_hire(_t['We did not find you in our records.'], '<p>' + _t['Use the form below to request help from a Union representative.'] + '</p>', 'question', _t['request_help'], _t['try_again']);
				}

				form.find('button').removeAttr('disabled');
			}).fail(function (e) {
				error_occurred(e);
				form.find('button').removeAttr('disabled');
			});
		}

		e.preventDefault();
		return false;
	});

	// This is where Login starts
	$('#members-login form').on('submit', function (e) {
		var form = $(this);
		form.find('button').attr('disabled', 'disabled');
		$.ajax({
			url: localeUrlPath + '/login',
			type: 'post',
			data: $(this).serializeJSON(),
			dataType: 'json'
		}).then(function (response) {
			if (response.errorCode && response.errorCode == 'invalid_credentials') {
				form.find('button').removeAttr('disabled');
				Swal.fire({
					icon: 'warning',
					title: _t['Invalid email or password.'],
					confirmButtonText: _t['Reset Password'],
					cancelButtonText: _t['Try Again'],
					showCancelButton: true
				}).then(function (response) {
					if (response.isConfirmed) {
						reset_password();
					}
				});
			} else {
				executeScripts();
			}
		}).fail(function (e) {
			error_occurred(e);
			form.find('button').removeAttr('disabled');
		});

		function MfaVerification() {
			try {
				$.ajax({
					url: localeUrlPath + '/accounts/send-two-factor-verification-code',
					type: 'post',
					data: $.param({
						deliveryMethod: 'email'
					}),
					dataType: 'json'
				}).done(function (response) {
					if (response['status'] == 'email-sent') {
						Swal.fire({
							title: 'A 6-digit verification code was sent to your email address.',
							inputLabel: 'Please enter your verification code below.',
							input: "text",
							inputAttributes: {
								autocapitalize: "off"
							},
							showCancelButton: false,
							confirmButtonText: "Verify",
							showLoaderOnConfirm: true,
							preConfirm: async function preConfirm(vCode) {
								try {
									var isVerified = $.ajax({
										url: localeUrlPath + '/accounts/validate-two-factor-verification-code',
										type: 'post',
										data: $.param({
											code: vCode
										}),
										dataType: 'json'
									});
									isVerified.done(function (response) {
										if (response['status'] == 'too-many-attempts') {
											//change this to another swal? - no 
											request_help_hire('Too many attempts.', '<p>Please use the form below to request help from a Union representative.', 'question', _t['submit'], _t['cancel']);
										} else if (response['status'] !== 'verified') {
											Swal.fire({
												icon: 'warning',
												title: 'Invalid verification code.',
												cancelButtonText: _t['Try Again'],
												showCancelButton: true
											});
										} else if (response['status'] == 'verified') {
											if ($('#members-login input[name="redirectTo"]').val() == '') {
												if (params.get('redirect')) {
													var hash = window.location.hash.slice(1);
													if (hash) {
														window.location = params.get('redirect') + '#' + hash;
													} else {
														window.location = params.get('redirect');
													}
												} else if (window.location.pathname == '/login' || window.location.pathname == '/es/login' || window.location.pathname == '/zh/login') {
													window.location = localeUrlPath + '/hire';
												} else {
													window.location.reload();
												}
											} else {
												window.location = $('#members-login input[name="redirectTo"]').val();
											}
										}
									});
									isVerified.fail(function (error) {
										Swal.fire({
											icon: 'warning',
											title: _t['An error occurred. Please refresh this page and try again.'],
											confirmButtonText: _t['Try Again']
										});
									});
								} catch (error) {
									Swal.fire({
										icon: 'warning',
										title: _t['An error occurred. Please refresh this page and try again.'],
										confirmButtonText: _t['Try Again']
									});
								}
							},
							allowOutsideClick: function allowOutsideClick() {
								return !Swal.isLoading();
							}
						});
					} else if (response['status'] == 'too-many-attempts') {
						request_help_hire('Too many attempts.', '<p>Please use the form below to request help from a Union representative.', 'question', _t['submit'], _t['cancel']);
					} else {
						error_occurred(response);
					}
				}).fail(function (error) {
					Swal.fire({
						icon: 'warning',
						title: _t['An error occurred. Please refresh this page and try again.'],
						confirmButtonText: _t['Try Again']
					});
				});
			} catch (error) {
				Swal.fire({
					icon: 'warning',
					title: _t['An error occurred. Please refresh this page and try again.'],
					confirmButtonText: _t['Try Again']
				});
			}
		}

		async function executeScripts() {
			try {
				await runCurrentUser();
				MfaVerification();
			} catch (err) {
				error_occured(err);
			}
		}

		e.preventDefault();
		return false;
	});
	$('#account-loader-2').hide();
	$('#members-login-or-create-claim').show();
	$(window).resize();
}

function init_create_account() {
	$('#create-account-2 form').off('submit').on('submit', function (e) {
		if (!$(this).find('#password').val().match(passwordRegex)) {
			Swal.fire({
				title: _t['Must be at least 8 characters long and include letters and numbers'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
		} else if ($(this).find('#password').val() != $(this).find('#passwordConfirmation').val()) {
			Swal.fire({
				title: _t['Password and Password confirmation must match'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
		} else {
			var form2 = $(this);
			form2.find('button').attr('disabled', 'disabled');

			$.ajax({
				url: localeUrlPath + '/accounts/create',
				type: 'post',
				data: $(this).serializeJSON(),
				dataType: 'json'
			}).done(function (response) {
				if (response['status'] == 'account-created') {
					$.getScript('/current-user-2.js', function (response) {
						init_finish_creating_your_account();
						window.scrollTo(0, 0);
					});
				} else if (response['status'] == 'not-eligible') {
					window.scrollTo(0, 0);
					$('#create-account-2').hide();
					$('#not-eligible').show();
				} else if (response['status'] == 'person-already-claimed') {
					Swal.fire({
						title: _t['You already have an account. Please login using your email and password.'],
						icon: 'info',
						confirmButtonText: _t['Ok']
					});

					window.scrollTo(0, 0);
				} else if (response['status'] == 'email-already-in-use') {
					Swal.fire({
						title: _t['Email address already in use.'],
						html: '<p>' + _t['Please use a different email address.'] + '</p>',
						icon: 'info',
						confirmButtonText: _t['Ok']
					}).then(function () {
						window.scrollTo(0, 0);
						$('#create-account-2').hide();
						init_login_or_claim();
					});
				} else {
					form2.find('button').removeAttr('disabled');
					error_occurred(e);
				}
			}).fail(function (e) {
				form2.find('button').removeAttr('disabled');
				error_occurred(e);
			});
		}

		e.preventDefault();
		return false;
	});

	$('#members-login-or-create-claim').hide();
	$('#create-account-2').show();
	window.scrollTo(0, 0);
}

function init_verify_email() {
	$('#account-loader-2').show();

	if (currentUser && currentUser.loggedIn) {
		verify_email();
	} else {
		request_login_before_verifying_email();
	}
}

function verify_email() {
	$.ajax({
		url: localeUrlPath + '/accounts/verify-email',
		type: 'post',
		data: {
			vc: params.get('vc'),
			uid: params.get('uid')
		},
		dataType: 'json'
	}).done(function (response) {
		var redirectTo = response['redirectTo'];

		if (response['status'] == 'success') {
			$('#verify-email').hide();
			$('#account-loader-2').hide();

			$.getScript('/current-user-2.js', function (response) {
				if (currentUser.verificationLevel == 'emailverified' || currentUser.verificationLevel == 'verified') {
					Swal.fire({
						title: _t['Thank you for verifying your email address!'],
						icon: 'success',
						confirmButtonText: _t['Ok']
					}).then(function (response) {
						$('#account-loader-2').show();
					});
				}

				setTimeout(function () {
					if (currentUser.verificationLevel == 'verified') {
						if (redirectTo) {
							window.location = redirectTo;
						} else {
							if (currentUser.sections.indexOf('htc-staff')) {
								window.location = localeUrlPath + '/htc-staff';
							} else if (currentUser.sections.indexOf('nu-workers')) {
								window.location = localeUrlPath + '/nu-workers';
							} else if (currentUser.sections.indexOf('dues-users')) {
								window.location = localeUrlPath + '/payments';
							} else if (currentUser.sections.indexOf('hire-users')) {
								window.location = localeUrlPath + '/hire';
							}
						}
					} else {
						window.location = localeUrlPath + '/login?uv';
					}
				}, 2000);
			});
		} else if (response['status'] == 'invalid-code') {
			$('#account-loader-2').hide();
			Swal.fire({
				title: _t['Your email verification link has expired.'],
				html: '<p>' + _t['Just now we sent you a new link to your email address. Please check your email.'] + '</p>',
				icon: 'info',
				confirmButtonText: _t['Ok']
			}).then(function (response) {
				$('#verify-email').hide();
				$('#account-loader-2').show();
				window.location = localeUrlPath + '/';
			});
		} else if (response['status'] == 'uid-not-found') {
			$('#account-loader-2').hide();
			Swal.fire({
				title: _t['Invalid link.'],
				html: '<p>' + _t['Please try again copying and pasting the entire link into your browser.'] + '</p>',
				icon: 'info',
				confirmButtonText: _t['Ok']
			}).then(function (response) {
				$('#account-loader-2').show();
				window.location = localeUrlPath + '/';
			});
		} else {
			$('#account-loader-2').show();
			window.location = localeUrlPath + '/';
		}
	}).fail(function (e) {
		error_occurred(e);
	});
}

function request_login_before_verifying_email() {
	$('#account-loader-2').hide();
	$('#verify-email form').on('submit', function (e) {
		var form = $(this);
		form.find('button').attr('disabled', 'disabled');
		$.ajax({
			url: localeUrlPath + '/login',
			type: 'post',
			data: $(this).serializeJSON(),
			dataType: 'json'
		}).done(function (response) {
			if (response.errorCode && response.errorCode == 'invalid_credentials') {
				form.find('button').removeAttr('disabled');
				Swal.fire({
					icon: 'warning',
					title: _t['Invalid email or password.'],
					confirmButtonText: _t['Reset Password'],
					cancelButtonText: _t['Try Again'],
					showCancelButton: true
				}).then(function (response) {
					if (response.isConfirmed) {
						reset_password();
					}
				});
			} else {
				$.getScript('/current-user-2.js', function (response) {
					verify_email();
				});
			}
		}).fail(function (e) {
			error_occurred(e);
			form.find('button').removeAttr('disabled');
		});

		e.preventDefault();
		return false;
	});

	$('#verify-email').show();
}

function init_finish_creating_your_account() {
	$('#account-loader-2').hide();
	$('#create-account-2').hide();
	$('#finish-creating-your-account-sent').show();
	$('#send-email-verification').off('click').on('click', function () {
		$('#finish-creating-your-account-sent').hide();
		$('#account-loader-2').show();
		send_email_verification();
	});
}

function send_email_verification() {
	$.ajax({
		url: localeUrlPath + '/accounts/send-email-verification',
		type: 'post',
		data: $(this).serializeJSON(),
		dataType: 'json'
	}).done(function (response) {
		$('#finish-creating-your-account-sent').show();
		$('#account-loader-2').hide();
	}).fail(function (e) {
		error_occurred(e);
	});
}

function init_choose_2f_method() {
	var html = '';

	$('#account-loader-2').hide();
	$('#create-account-2').hide();
	$('#verify-2f-enter-code').hide();
	$('#members-login-or-create-claim').hide();

	if (currentUser.twoFactorVerification.deliveryMethods.phone == '' && currentUser.twoFactorVerification.deliveryMethods.email == '' && currentUser.twoFactorVerification.deliveryMethods.address == '') {
		window.scrollTo(0, 0);
		$('#not-eligible').show();
	} else {
		$('#deliveryMethod-phone-container, #deliveryMethod-email-container, #deliveryMethod-address-container').hide();

		if (currentUser.twoFactorVerification.deliveryMethods.phone != '') {
			$('#deliveryMethod-phone').html(currentUser.twoFactorVerification.deliveryMethods.phone);
			$('#deliveryMethod-phone-container').show();
		}
		if (currentUser.twoFactorVerification.deliveryMethods.email != '') {
			$('#deliveryMethod-email').html(currentUser.twoFactorVerification.deliveryMethods.email);
			$('#deliveryMethod-email-container').show();
		}
		if (currentUser.twoFactorVerification.deliveryMethods.address != '') {
			$('#deliveryMethod-address').html(currentUser.twoFactorVerification.deliveryMethods.address);
			$('#deliveryMethod-address-container').show();
		}

		$('#verify-2f-choose-delivery-method form').off('submit').on('submit', function (e) {
			var form = $(this);
			form.find('button').attr('disabled', 'disabled');

			$.ajax({
				url: localeUrlPath + '/accounts/send-two-factor-verification-code',
				type: 'post',
				data: $(this).serializeJSON(),
				dataType: 'json'
			}).done(function (response) {
				if (response['status'] == 'sms-sent') {
					init_validate_2f_code('sms');
				} else if (response['status'] == 'email-sent') {
					init_validate_2f_code('email');
				} else if (response['status'] == 'postal-sent') {
					$('#verify-2f-choose-delivery-method').hide();
					$('#two-factor-mailed').show();
				} else if (response['status'] == 'too-many-attempts') {
					request_help_hire('Too many attempts.', '<p>Please use the form below to request help from a Union representative.', 'question', _t['submit'], _t['cancel']);
				}

				form.find('button').removeAttr('disabled');
			}).fail(function (response, responseText) {
				Swal.fire({
					title: _t['error_occurred'],
					icon: 'error',
					confirmButtonText: _t['Ok']
				});
				form.find('button').removeAttr('disabled');
			});

			e.preventDefault;
			return false;
		});

		$('#verify-2f-choose-delivery-method').show();
		window.scrollTo(0, 0);
	}
}

function init_validate_2f_code(deliveryMethod) {
	$('#account-loader-2').hide();

	$('#verify-2f-enter-code').find('.delivered-2f-postal, .delivered-2f-email, .delivered-2f-sms').hide();
	if (!deliveryMethod || deliveryMethod == 'sms') {
		$('#verify-2f-enter-code .delivered-2f-sms').show();
	} else if (deliveryMethod == 'email') {
		$('#verify-2f-enter-code .delivered-2f-email').show();
	} else {
		$('#verify-2f-enter-code .delivered-2f-postal').show();
	}

	$('#verify-2f-choose-delivery-method').hide();
	$('#verify-2f-enter-code input[name="code"]').val('');
	$('#verify-2f-enter-code').show();

	$('.verify-2f-choose-delivery-method-btn').off('click').on('click', function () {
		init_choose_2f_method();
		$('#verify-2f-enter-code').hide();
	});

	$('#verify-2f-enter-code form').off('submit').on('submit', function (e) {
		var form = $(this);
		form.find('button').attr('disabled', 'disabled');

		$.ajax({
			url: localeUrlPath + '/accounts/validate-two-factor-verification-code',
			type: 'post',
			data: $(this).serializeJSON(),
			dataType: 'json'
		}).done(function (response) {
			if (response['status'] == 'invalid-code') {
				Swal.fire({
					title: _t['Your 6-digit verification code is invalid.'],
					icon: 'question',
					confirmButtonText: _t['try_again'],
					denyButtonText: _t['Send a new code'],
					cancelButtonText: _t['request_help'],
					denyButtonColor: '#3085d6',
					cancelButtonColor: '#3085d6',
					showCancelButton: true,
					showDenyButton: true,
					width: 450
				}).then(function (response) {
					if (response.isDenied) {
						init_choose_2f_method();
					} else if (response.isDismissed) {
						request_help_hire(_t['request_help'], '', 'question', _t['submit'], _t['cancel']);
					}
				});
			} else if (response['status'] == 'too-many-attempts') {
				Swal.fire({
					title: _t['invalid_code'],
					icon: 'question',
					confirmButtonText: _t['Ok'],
					cancelButtonText: _t['request_help'],
					cancelButtonColor: '#3085d6',
					showCancelButton: true
				}).then(function (response) {
					if (!response.isConfirmed) {
						request_help_hire(_t['request_help'], '', 'question', _t['submit'], _t['cancel']);
					}
				});

				$('#verify-2f-enter-code').hide();
				$('#too-many-attempts').show();
			} else {
				$('#account-loader-2').show();
				$('#verify-2f-choose-delivery-method').hide();
				$('#verify-2f-enter-code').hide();

				Swal.fire({
					title: _t['Thank you!'],
					icon: 'success',
					confirmButtonText: _t['Ok']
				}).then(function () {
					setTimeout(function () {
						if (response['redirectTo']) {
							window.location = response['redirectTo'];
						} else {
							window.location = localeUrlPath + '/hire';
						}
					}, 5000);
				});

				setTimeout(function () {
					if (response['redirectTo']) {
						window.location = response['redirectTo'];
					} else {
						window.location = localeUrlPath + '/hire';
					}
				}, 5000);
			}

			form.find('button').removeAttr('disabled');
		});

		e.preventDefault;
		return false;
	});

	if (params.get('c')) {
		$('#verify-2f-enter-code form input[name="code"]').val(params.get('c'));
		// $('#verify-2f-enter-code form').trigger('submit');
	}
}

function init_password_reset() {
	$('#account-loader-2').hide();
	$('#password-reset').show();

	$('#password-reset form').on('submit', function (e) {
		if (!$('#newPassword').val().match(passwordRegex)) {
			Swal.fire({
				title: _t['Must be at least 8 characters long and include letters and numbers'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
		} else if ($('#newPassword').val() != $('#newPasswordConfirmation').val()) {
			Swal.fire({
				title: _t['New password and Retype new password must match'],
				icon: 'error',
				confirmButtonText: _t['Ok']
			});
		} else {
			$.ajax({
				url: localeUrlPath + '/accounts/set-password',
				type: 'post',
				data: {
					vc: params.get('vc'),
					uid: params.get('uid'),
					newPassword: $('#newPassword').val()
				},
				dataType: 'json'
			}).done(function (response) {
				if (response.status == 'invalid-code') {
					Swal.fire({
						title: _t['Invalid link.'],
						html: '<p>' + _t['Please try again copying and pasting the entire link into your browser.'] + '</p>',
						icon: 'info',
						confirmButtonText: _t['Ok']
					}).then(function (response) {
						$('#account-loader-2').hide();
						$('#password-reset').show();
						window.location = localeUrlPath + '/';
					});
				} else {
					$('#account-loader-2').show();
					$('#password-reset').hide();

					Swal.fire({
						icon: 'success',
						title: _t['Your password was reset.'],
						confirmButtonText: _t['Ok']
					}).then(function (response) {
						window.location = localeUrlPath + '/hire';
					});
				}
			}).fail(function (e) {
				error_occurred(e);
			});
		}

		e.preventDefault();
		return false;
	});
}

function reset_password(e) {
	$('#account-loader-2').hide();

	Swal.fire({
		title: _t["Forgot your password?"],
		html: '<p>' + _t['Enter your email below and we will send you an email with a link you can use to reset your password.'] + '<input required="required" id="reset-password-email" type="email" class="swal2-input" required>',
		icon: 'question',
		confirmButtonText: _t['Reset Password'],
		cancelButtonText: _t['cancel'],
		showCancelButton: true,
		preConfirm: function preConfirm() {
			if ($('#reset-password-email').val() == '') {
				Swal.showValidationMessage(_t['Please enter your email.']);
				return false;
			} else {
				return {
					'email': $('#reset-password-email').val()
				};
			}
		}
	}).then(function (response) {
		if (response.isConfirmed) {
			$.ajax({
				url: localeUrlPath + '/accounts/send-password-reset',
				type: 'post',
				data: {
					loginName: response.value['email'],
					page: 'login'
				},
				dataType: 'json'
			});

			Swal.fire({
				title: _t['Password reset link sent. Please check your email.'],
				icon: 'success',
				confirmButtonText: _t['Ok']
			});
		}
	});

	if (e) {
		e.preventDefault();
	}

	return false;
}

function error_occurred(response) {
	if (response.status == '403') {
		$('#account').hide();
		Swal.fire({
			title: _t['session_timeout'],
			icon: 'info',
			confirmButtonText: _t['Ok']
		}).then(function () {
			$('#account-loader-2').show();
			window.location.reload();
		});
	} else {
		Swal.fire({
			title: _t['error_occurred'],
			icon: 'error',
			confirmButtonText: _t['Ok']
		});
	}
}

},{}],21:[function(require,module,exports){
'use strict';

$(window).resize(function () {
	/* Only provide a slideshow if the screen is larger than 600px */
	if ($(window).width() >= 601) {
		$(".grid .tile.image").off('click').on('click', function () {
			create_slideshow($(this).closest('.grid'), $(this));
		});
		$(".grid .tile.image img").each(function () {
			$(this).attr('src', $(this).data('grid'));
		});
		/* Otherwise, show the slides full width of the window with captions underneath */
	} else {
		$(".grid .tile.image").off('click');
		$(".grid .tile.image img").each(function () {
			$(this).attr('src', $(this).data('mobile'));
		});
		$('.slideshow').remove();
	}
}).resize();

function create_slideshow(media_grid, tile) {
	/* Build the slideshow HTML and append it to the DOM after the grid */
	var slideshow = $('<div class="slideshow"><div class="close">X</div></div>');
	var slideshow_inner = $('<div class="slideshow-inner"></div>');
	var initial_slide_index,
	    initial_slide,
	    slide,
	    caption = '',
	    caption_class;
	media_grid.find('.tile.image').each(function (i) {
		if ($(this).find('figcaption').length == 1) {
			caption = '<figcaption>' + $(this).find('figcaption').html() + '</figcaption>';
			caption_class = 'with-caption';
		} else {
			caption_class = 'without-caption';
		}
		slide = $('<div class="slide ' + caption_class + '"><div class="slide-inner">' + '<div class="payload"><img src="' + $(this).find('img').data('slideshow') + '" /></div>' + caption + '</div></div>');
		slideshow_inner.append(slide);
		if (tile[0] == this) {
			initial_slide_index = i;
			initial_slide = slide;
		}
	});
	slideshow.append(slideshow_inner);
	media_grid.after(slideshow);

	/* Initialize the slick slider and go to the slide that was clicked */
	$(slideshow_inner).slick({
		infinite: true,
		slidesToShow: 1,
		arrows: true,
		dots: false,
		autoplay: false,
		adaptiveHeight: false,
		focusOnSelect: false,
		fade: true
	}).slick('slickGoTo', initial_slide_index);

	/* This is necessary so that the arrow keys work right away without having to click into the slideshow */
	$(initial_slide).focus();

	/* Close the slideshow */
	function close() {
		slideshow.remove();
	}

	/* Close if the transparent back background is clicked */
	slideshow.on('click', close);

	/* Close if the X link is clicked */
	slideshow.find('.close').on('click', close);

	/* Do not bubble up the click event if the inner slideshow is clicked on */
	slideshow_inner.on('click', function (e) {
		e.preventDefault();
		return false;
	});

	/* close if the escape key is pressed */
	$(document).off('keyup').on('keyup', function (e) {
		if (e.keyCode === 27) {
			close();
		}
	});
}

},{}],22:[function(require,module,exports){
'use strict';

$(document).ready(function () {
    if ($('#mildred-grossman-gallery').length == 1) {
        var gallery_items = [{ 'type': 'image', 'url': '/images/mildred-grossman/31_t_3513350286_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/32_t_3512543407_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/33_t_3513350392_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/34_t_3512543501_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/35_t_3513350554_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/36_t_3512543713_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/37_t_3512543793_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/38_t_3512543855_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/39_t_3513350836_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/40_t_3513350916_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/41_t_3513350984_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/42_t_3512544133_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/43_t_3513351156_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/44_t_3512544285_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/45_t_3513351334_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/46_t_3513351410_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/47_t_3513351520_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/48_t_3512544631_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/49_t_3513351700_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/50_t_3513351772_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/51_t_3512544815_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/52_t_3512544871_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/53_t_3512544959_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/54_t_3512545027_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/55_t_3513352194_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/56_t_3513352260_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/57_t_3513352374_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/58_t_3512545373_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/60_t_3510363263_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/61_t_3511172516_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/62_t_3511172570_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/63_t_3510363465_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/64_t_3511172722_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/65_t_3511172806_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/66_t_3510363669_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/67_t_3510363755_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/68_t_3510363833_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/69_t_3510363935_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/70_t_3510364033_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/71_t_3510364165_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/72_t_3510364283_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/73_t_3510364385_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/74_t_3511170638_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/75_t_3511170692_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/76_t_3510361579_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/77_t_3511170806_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/79_t_3511170946_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/80_t_3511171000_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/81_t_3510361933_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/83_t_3510362077_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/84_t_3510362171_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/85_t_3511171416_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/86_t_3510362439_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/87_t_3511171670_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/88_t_3510362639_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/89_t_3510362739_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/90_t_3510362859_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/91_t_3511172070_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/92_t_3510363063_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/93_t_3511172284_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00001_4370674559_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00003_4370674611_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00005_4370674673_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00007_4371423956_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00009_4371424014_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00011_4370674851_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00013_4370674919_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00015_4371424206_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00017_4370675067_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00019_4370675147_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00021_4370675213_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00023_4370675311_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00025_4370675391_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00027_4371424664_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00029_4370675531_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00031_4371424840_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00033_4371424916_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00035_4371424994_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00037_4370675839_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00039_4371425196_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00041_4370676005_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00043_4371425414_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00045_4371425482_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00047_4370676257_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00049_4370676327_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00051_4371425688_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00053_4371425778_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00055_4371470490_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00057_4371470536_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00059_4370720781_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00061_4370720827_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00063_4370720897_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00065_4370720945_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00067_4370721011_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00069_4371470894_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00071_4371470972_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00073_4370721265_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00075_4370721357_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00077_4370721413_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00079_4371471222_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00081_4371471342_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00083_4370721737_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00085_4371471450_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00087_4370721871_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00089_4371471616_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00091_4370722047_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00093_4370722089_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00095_4371471810_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00097_4370722227_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00099_4371471942_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00101_4371556564_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00103_4370808173_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00105_4371556644_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00107_4371556678_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00109_4371556714_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00111_4370808455_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00113_4370808491_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00115_4370808517_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00117_4371556932_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00119_4370808585_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00121_4370808627_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00123_4370808673_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00127_4370808703_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00129_4370808731_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00131_4370808811_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00133_4371557244_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00135_4371557288_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00137_4371557366_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00139_4371557412_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00141_4370809369_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00143_4371558084_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00145_4371558150_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00147_4371558206_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00149_4370809883_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00151_4370809929_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00153_4371558360_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00155_4370810009_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00157_4370810073_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00159_4371558636_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00161_4371558732_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00163_4379093945_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00165_4379849300_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00167_4379094197_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00169_4379094311_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00171_4379094399_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00173_4379849710_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00175_4379849768_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00177_4379849830_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00179_4379094665_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00181_4379849958_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00183_4379094789_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00185_4379850116_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00187_4379094947_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00189_4379094999_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00191_4379850342_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00193_4379850398_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00195_4379095203_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00197_4379095317_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00199_4379850874_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00201_4379850956_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00203_4383228282_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00205_4383228348_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00207_4382469549_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00209_4382469611_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00211_4383228500_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00213_4383228568_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00215_4383228620_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00217_4383228668_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00219_4382469919_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00221_4383228770_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00223_4383228812_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00225_4382470079_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00227_4383228968_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00229_4383229040_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00231_4383229078_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00233_4383229148_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00235_4383229206_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00237_4383229260_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00239_4383229320_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00241_4383229348_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00243_4383229398_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00245_4382470691_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00247_4382470753_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00249_4383229592_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00251_4382470903_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00253_4382470971_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00255_4383229784_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00257_4382471093_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00259_4382471169_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00261_4383230052_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00263_4382471317_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00265_4383230230_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00267_4382471445_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00269_4383230344_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00271_4383230422_o.jpg', 'caption': '' }, { 'type': 'image', 'url': '/images/mildred-grossman/mg_00273_4383230524_o.jpg', 'caption': '' }];

        var gallery = new Vue({
            el: '#mildred-grossman-gallery',
            delimiters: ['${', '}'],
            data: function data() {
                return {
                    items: gallery_items,
                    current_item_index: 0,
                    full_screen: false
                };
            },
            methods: {
                goto: function goto(index) {
                    if (index < 0) {
                        this.current_item_index = this.items.length - 1;
                    } else if (this.current_item_index + 1 > this.items.length) {
                        this.current_item_index = 0;
                    } else {
                        this.current_item_index = index;
                    }

                    // var left = $('#mildred-grossman-gallery ol li img[src="' + this.items[this.current_item_index].url + '"]').
                    //     closest('li').position().left;
                    // $('#mildred-grossman-gallery nav')[0].scrollLeft = left - ($('#mildred-grossman-gallery').width() / 2) + 100;
                },
                previous: function previous() {
                    this.goto(this.current_item_index - 1);
                },
                next: function next() {
                    this.goto(this.current_item_index + 1);
                },
                down: function down() {
                    $('#mildred-grossman-gallery .view-caption-container')[0].scrollTop += 100;
                },
                maximize: function maximize() {
                    $('#mildred-grossman-gallery').addClass('full-screen');
                    this.full_screen = true;
                    $('body').addClass('no-scroll');
                },
                minimize: function minimize() {
                    $('#mildred-grossman-gallery').removeClass('full-screen');
                    this.full_screen = false;
                    $('body').removeClass('no-scroll');
                }
            },
            filters: {
                slugify: function slugify(text) {
                    return text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
                }
            },
            mounted: function mounted() {
                var self = this;

                window.addEventListener('keydown', function (e) {
                    if (e.keyCode == 37) {
                        self.goto(self.current_item_index - 1);
                    } else if (e.keyCode == 39) {
                        self.goto(self.current_item_index + 1);
                    } else if (e.keyCode == 27) {
                        self.minimize();
                    }
                });
            }
        });
    }
});

},{}],23:[function(require,module,exports){
'use strict';

$(document).ready(function () {
  if ($('#rich-videos').length >= 1) {
    var player = new Vimeo.Player($('iframe')[0]);
    player.on('ended', function () {
      window.location = $('#videos-next-up .slider a').first().attr('href');
    });
  }
});

},{}],24:[function(require,module,exports){
'use strict';

window.request_help_hire = function () {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _t['request_help'];
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'question';
    var confirmButtonText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _t['request_help'];
    var cancelButtonText = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _t['cancel'];
    var cancelCallback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};
    var additionalInfo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

    Swal.fire({
        title: title,
        html: message + '<input required="required" id="help-name" class="swal2-input" placeholder="' + _t['name'] + '" required>' + '<input required="required" id="help-shop" class="swal2-input" placeholder="' + _t['employer'] + '">' + '<input required="required" id="help-phone" class="swal2-input" placeholder="' + _t['phone_number'] + '" required>' + '<textarea id="help-message" class="swal2-textarea" placeholder="' + _t['message'] + '..."></textarea>',
        icon: icon,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        showCancelButton: true,
        preConfirm: function preConfirm() {
            if ($('#help-name').val() == '') {
                Swal.showValidationMessage(_t['name_required']);
                return false;
            } else if ($('#help-phone').val() == '') {
                Swal.showValidationMessage(_t['phone_required']);
                return false;
            } else if (!$('#help-phone').val().match(/^((\d{3})-(\d{3})-(\d{4})|\d{10})$/)) {
                Swal.showValidationMessage(_t['invalid_phone_number']);
                return false;
            } else {
                return {
                    'name': $('#help-name').val(),
                    'shop': $('#help-shop').val(),
                    'phone': $('#help-phone').val(),
                    'message': $('#help-message').val()
                };
            }
        }
    }).then(function (response) {
        if (response.isConfirmed) {
            $.ajax({
                url: '/form-entries/store',
                type: 'post',
                data: {
                    'language': localeName,
                    'name': response.value['name'],
                    'shop': response.value['shop'],
                    'phone': response.value['phone'],
                    'message': response.value['message'],
                    'additionalInfo': additionalInfo,
                    'dialog_title': title,
                    'dialog_message': message,
                    'url': window.location.toString(),
                    'fid': 31, // hire-help-request
                    'accountClaimUid': $('#create-account-claim input[name="acUid"]').val()
                },
                dataType: 'json'
            }).done(function (response) {
                Swal.fire({
                    title: _t['thank_you_help'],
                    icon: 'success'
                });
            }).fail(function () {
                Swal.fire({
                    title: _t['error_occurred'],
                    icon: 'error'
                });
            });
        } else {
            cancelCallback(response);
        }
    });
};

$(document).ready(function () {
    $('.request-help').on('click', function (e) {
        request_help($(this).data('title'), $(this).data('message'), $(this).data('icon'), $(this).data('cancel-button-text'), $(this).data('cancel-callback'));

        e.preventDefault();
        return false;
    });

    if (window.location.hash == '#request-help') {
        request_help();
    }
});

},{}],25:[function(require,module,exports){
'use strict';

window.request_help_nu_workers = function () {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _t['request_help'];
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'question';
    var confirmButtonText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _t['request_help'];
    var cancelButtonText = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _t['cancel'];
    var cancelCallback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};
    var additionalInfo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

    Swal.fire({
        title: title,
        html: message + '<input required="required" id="help-name" class="swal2-input" placeholder="' + _t['name'] + '" required>' + '<input required="required" id="help-shop" class="swal2-input" placeholder="' + _t['employer'] + '">' + '<input required="required" id="help-phone" class="swal2-input" placeholder="' + _t['phone_number'] + '" required>' + '<textarea id="help-message" class="swal2-textarea" placeholder="' + _t['message'] + '..."></textarea>',
        icon: icon,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        showCancelButton: true,
        preConfirm: function preConfirm() {
            if ($('#help-name').val() == '') {
                Swal.showValidationMessage(_t['name_required']);
                return false;
            } else if ($('#help-phone').val() == '') {
                Swal.showValidationMessage(_t['phone_required']);
                return false;
            } else if (!$('#help-phone').val().match(/^((\d{3})-(\d{3})-(\d{4})|\d{10})$/)) {
                Swal.showValidationMessage(_t['invalid_phone_number']);
                return false;
            } else {
                return {
                    'name': $('#help-name').val(),
                    'shop': $('#help-shop').val(),
                    'phone': $('#help-phone').val(),
                    'message': $('#help-message').val()
                };
            }
        }
    }).then(function (response) {
        if (response.isConfirmed) {
            $.ajax({
                url: '/form-entries/store',
                type: 'post',
                data: {
                    'language': localeName,
                    'name': response.value['name'],
                    'shop': response.value['shop'],
                    'phone': response.value['phone'],
                    'message': response.value['message'],
                    'additionalInfo': additionalInfo,
                    'dialog_title': title,
                    'dialog_message': message,
                    'url': window.location.toString(),
                    'fid': 31, // hire-help-request
                    'accountClaimUid': $('#create-account-claim input[name="acUid"]').val()
                },
                dataType: 'json'
            }).done(function (response) {
                Swal.fire({
                    title: _t['thank_you_help'],
                    icon: 'success'
                });
            }).fail(function () {
                Swal.fire({
                    title: _t['error_occurred'],
                    icon: 'error'
                });
            });
        } else {
            cancelCallback(response);
        }
    });
};

$(document).ready(function () {
    $('.request-help').on('click', function (e) {
        request_help($(this).data('title'), $(this).data('message'), $(this).data('icon'), $(this).data('cancel-button-text'), $(this).data('cancel-callback'));

        e.preventDefault();
        return false;
    });

    if (window.location.hash == '#request-help') {
        request_help();
    }
});

},{}],26:[function(require,module,exports){
'use strict';

window.request_help_with_account = function () {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _t['request_help'];
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'question';
    var confirmButtonText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _t['request_help'];
    var cancelButtonText = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _t['cancel'];
    var cancelCallback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};
    var additionalInfo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

    Swal.fire({
        title: title,
        html: message + '<input required="required" id="help-name" class="swal2-input" placeholder="' + _t['name'] + '" required>' + '<input required="required" id="help-shop" class="swal2-input" placeholder="' + _t['employer'] + '">' + '<input required="required" id="help-phone" class="swal2-input" placeholder="' + _t['phone_number'] + '" required>' + '<textarea id="help-message" class="swal2-textarea" placeholder="' + _t['message'] + '..."></textarea>',
        icon: icon,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        showCancelButton: true,
        preConfirm: function preConfirm() {
            if ($('#help-name').val() == '') {
                Swal.showValidationMessage(_t['name_required']);
                return false;
            } else if ($('#help-phone').val() == '') {
                Swal.showValidationMessage(_t['phone_required']);
                return false;
            } else if (!$('#help-phone').val().match(/^((\d{3})-(\d{3})-(\d{4})|\d{10})$/)) {
                Swal.showValidationMessage(_t['invalid_phone_number']);
                return false;
            } else {
                return {
                    'name': $('#help-name').val(),
                    'shop': $('#help-shop').val(),
                    'phone': $('#help-phone').val(),
                    'message': $('#help-message').val()
                };
            }
        }
    }).then(function (response) {
        if (response.isConfirmed) {
            $.ajax({
                url: '/form-entries/store',
                type: 'post',
                data: {
                    'language': localeName,
                    'name': response.value['name'],
                    'shop': response.value['shop'],
                    'phone': response.value['phone'],
                    'message': response.value['message'],
                    'additionalInfo': additionalInfo,
                    'dialog_title': title,
                    'dialog_message': message,
                    'url': window.location.toString(),
                    'fid': 9 // payments-help-request
                },
                dataType: 'json'
            }).done(function (response) {
                Swal.fire({
                    title: _t['thank_you_help'],
                    icon: 'success'
                });
            }).fail(function () {
                Swal.fire({
                    title: _t['error_occurred'],
                    icon: 'error'
                });
            });
        } else {
            cancelCallback(response);
        }
    });
};

$(document).ready(function () {
    $('.request-help').on('click', function (e) {
        request_help($(this).data('title'), $(this).data('message'), $(this).data('icon'), $(this).data('cancel-button-text'), $(this).data('cancel-callback'));

        e.preventDefault();
        return false;
    });

    if (window.location.hash == '#request-help') {
        request_help();
    }
});

},{}],27:[function(require,module,exports){
'use strict';

window.request_help = function () {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _t['request_help'];
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'question';
    var confirmButtonText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _t['request_help'];
    var cancelButtonText = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _t['cancel'];
    var cancelCallback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};
    var additionalInfo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

    Swal.fire({
        title: title,
        html: message + '<input required="required" id="help-name" class="swal2-input" placeholder="' + _t['name'] + '" required>' + '<input required="required" id="help-shop" class="swal2-input" placeholder="' + _t['employer'] + '">' + '<input required="required" id="help-phone" class="swal2-input" placeholder="' + _t['phone_number'] + '" required>' + '<input required="required" id="help-code" class="swal2-input" placeholder="' + _t['payment_code'] + '" >' + '<div style="text-align:left; margin-top: 0.5em;">' + '  <h6>' + _t['how_can_help'] + '</h6>' + '  <input type="radio" required="required" id="reason-invalid-code" name="reason" class="swal2-radio" value="CodeNotWorking"> <label for="reason-invalid-code">' + _t['payment_code_not_working'] + '</label><br>' + '  <input type="radio" required="required" id="reason-need-code" name="reason" class="swal2-radio" value="NoCode"> <label for="reason-need-code">' + _t['do_not_have_payment_code'] + '</label><br>' + '  <input type="radio" required="required" id="reason-other" name="reason" class="swal2-radio" value="Other"> <label for="reason-other">' + _t['other'] + '</label><br>' + '</div>' + '<textarea id="help-message" class="swal2-textarea" placeholder="' + _t['message'] + '..."></textarea>',
        icon: icon,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        showCancelButton: true,
        preConfirm: function preConfirm() {
            if ($('#help-name').val() == '') {
                Swal.showValidationMessage(_t['name_required']);
                return false;
            } else if ($('#help-phone').val() == '') {
                Swal.showValidationMessage(_t['phone_required']);
                return false;
            } else if (!$('#help-phone').val().match(/^((\d{3})-(\d{3})-(\d{4})|\d{10})$/)) {
                Swal.showValidationMessage(_t['invalid_phone_number']);
                return false;
            } else if (!$('input[name="reason"]:checked').val()) {
                Swal.showValidationMessage(_t['how_can_help']);
                return false;
            } else {
                return {
                    'name': $('#help-name').val(),
                    'shop': $('#help-shop').val(),
                    'phone': $('#help-phone').val(),
                    'code': $('#help-code').val(),
                    'reason': $('input[name="reason"]:checked').val(),
                    'message': $('#help-message').val()
                };
            }
        }
    }).then(function (response) {
        if (response.isConfirmed) {
            $.ajax({
                url: '/form-entries/store',
                type: 'post',
                data: {
                    'language': localeName,
                    'name': response.value['name'],
                    'shop': response.value['shop'],
                    'phone': response.value['phone'],
                    'code': response.value['code'],
                    'reason': response.value['reason'],
                    'message': response.value['message'],
                    'additionalInfo': additionalInfo,
                    'dialog_title': title,
                    'dialog_message': message,
                    'url': window.location.toString(),
                    'fid': 9 // payments-help-request
                },
                dataType: 'json'
            }).done(function (response) {
                Swal.fire({
                    title: _t['thank_you_help'],
                    icon: 'success'
                });
            }).fail(function () {
                Swal.fire({
                    title: _t['error_occurred'],
                    icon: 'error'
                });
            });
        } else {
            cancelCallback(response);
        }
    });
};

$(document).ready(function () {
    $('.request-help').on('click', function (e) {
        request_help($(this).data('title'), $(this).data('message'), $(this).data('icon'), $(this).data('cancel-button-text'), $(this).data('cancel-callback'));

        e.preventDefault();
        return false;
    });

    if (window.location.hash == '#request-help') {
        request_help();
    }
});

},{}],28:[function(require,module,exports){
'use strict';

/* Force the browser to scroll to a table-of-content's anchor when the page loads.
  this is necessary when referring from a different page, not a page refresh. */
$(document).ready(function () {
	function scrollto() {
		if (window.location.hash.indexOf('#find-union-hotels') >= 0) {
			return;
		}

		if (window.location.hash) {
			var element = $('#' + window.location.hash.toString().slice(1));
			var y;

			if (element.length > 0) {
				if (window.outerWidth >= 850) {
					y = element.offset()['top'] - 191 - 15;
				} else {
					y = element.offset()['top'] - 42 - 15;
				}

				window.scrollTo({ top: y, behavior: 'smooth' });
			}
		}
	}
	setTimeout(scrollto, 1000);

	$('#content a[href^="#"]').on('click', function (e) {
		var href = $(this).attr('href');

		if (href.length > 1) {
			var element = $(href);
			var y;

			if (element.length > 0) {
				if (window.outerWidth >= 850) {
					y = element.offset()['top'] - 191 - 15;
				} else {
					y = element.offset()['top'] - 42 - 15;
				}

				window.scrollTo({ top: y, behavior: 'smooth' });
			}

			window.location.hash = $(this).attr('href');

			e.preventDefault();
			return false;
		}
	});
});

},{}],29:[function(require,module,exports){
"use strict";

$(document).ready(function () {
	if (!document.getElementById("share-btns-template")) {
		return;
	}

	var share_btns_template = Handlebars.compile(document.getElementById("share-btns-template").innerHTML);
	var safari_desktop = /Safari/i.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor) && !/Mobi|Android/i.test(navigator.userAgent);

	window.share = function (e) {
		if (e) {
			e.preventDefault();
		}

		if (!safari_desktop && navigator.share) {
			navigator.share({
				title: $('meta[property="og:title"]').attr('content'),
				url: $('meta[property="og:url"]').attr('content')
			}).then(function () {
				console.log('Thanks for sharing!');
			}).catch(console.error);
		} else {
			Swal.fire({
				title: 'Share',
				showCloseButton: true,
				showCancelButton: false,
				showConfirmButton: false,
				width: '400px',
				html: share_btns_template({
					title: $('meta[property="og:title"]').attr('content'),
					url: $('meta[property="og:url"]').attr('content')
				})
			});

			window.Sharer.init();

			return false;
		}
	};

	$('.band.shareable, .band.title').find('h1').each(function () {
		var slug, url, title, html, lang;

		if ($(this).closest('.list-container').length == 0) {
			slug = slugify($(this).text());
			title = $(this).clone() //clone the element
			.children() //select all the children
			.remove() //remove all the children
			.end() //again go back to selected element
			.text().trim();
			url = window.location + '#' + slug;

			$(this).attr('id', slug);
			$(this).data('toc-text', title);

			lang = window.location.pathname.split('/');
			if (lang.length >= 2) {
				lang = lang[1];
			} else {
				lang = 'es';
			}

			if (lang == 'zh') {
				html = $('<a href="' + url + '" class="share">分享' + '<img src="/images_new/share-15.png" /></a>');
			} else if (lang == 'es') {
				html = $('<a href="' + url + '" class="share">Comparte' + '<img src="/images_new/share-15.png" /></a>');
			} else {
				html = $('<a href="' + url + '" class="share">Share' + '<img src="/images_new/share-15.png" /></a>');
			}

			$(this).prepend(html);

			$(this).find('.share').on('click', share);
		}
	});
});

},{}],30:[function(require,module,exports){
'use strict';

$(document).ready(function () {
    Toc.init({
        $nav: $('#toc'),
        $scope: $('article.entry:not(".related")')
    });

    $('body').scrollspy({
        target: '#toc',
        scope: $('article.entry:not(".related")'),
        offset: 250
    });

    var toc = $('#toc');
    $(document).on('scroll', function () {
        if (window.scrollY <= 100) {
            toc.css({ top: 150 + 100 - window.scrollY });
        } else {
            toc.css({ top: 150 });
        }
    });

    toc.find('a').on('click', function (e) {
        var element = $($(this).attr('href'));
        var y;

        if (element.length > 0) {
            if (window.outerWidth >= 850) {
                y = element.offset()['top'] - 150 - 15;
            } else {
                y = element.offset()['top'] - 42 - 15;
            }

            window.scrollTo({ top: y, behavior: 'smooth' });
        }

        e.preventDefault();
        return false;
    });
});

},{}],31:[function(require,module,exports){
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

$(document).ready(function () {
	$(window).on('resize', resize_tiles);
	$('.tiles-container').imagesLoaded().done(resize_tiles);
	$(window).resize();
});

function config(tiles_container) {
	var tile_width = 300;
	var gutter = 15;
	var tile_min_width = 250;
	var tile_max_width = 400;
	var num_columns = 4;

	if (tiles_container.data('columns')) {
		num_columns = parseInt(tiles_container.data('columns'));
	}

	if (tiles_container.data('min-width')) {
		tile_min_width = parseInt(tiles_container.data('min-width'));
	}

	if (tiles_container.data('max-width')) {
		tile_max_width = parseInt(tiles_container.data('max-width'));
	}

	if (tiles_container.data('gutter')) {
		gutter = parseInt(tiles_container.data('gutter'));
	}

	while (num_columns > 1 && tiles_container.width() / num_columns < tile_min_width) {
		num_columns -= 1;
	}

	while (num_columns < 50 && tiles_container.width() / num_columns > tile_max_width) {
		num_columns += 1;
	}

	tile_width = tiles_container.width() / num_columns + gutter / num_columns;

	return [tile_width, gutter, num_columns];
}

function remove_columns(tiles_container) {
	var tiles = tiles_container.find('.tiles');
	var tiles2 = [];
	var i;

	if (tiles_container.find('.column').length > 0) {
		tiles_container.find('.tile').each(function () {
			tiles2[parseInt($(this).data('index'))] = $(this);
		});
		for (i = 0; i < tiles2.length; i++) {
			$(tiles2[i]).detach().appendTo(tiles);
		}
		tiles_container.find('.column').remove();
	}
}

function shortest_column(tiles_container) {
	var i, shortest;
	var shortest_height = 99999999999999;
	var columns = tiles_container.find('.column');

	for (i = 0; i < columns.length; i++) {
		if ($(columns[i]).height() < shortest_height) {
			shortest = $(columns[i]);
			shortest_height = $(columns[i]).height();
		}
	}

	return shortest;
}

function resize_tiles() {
	$('.tiles-container').each(function () {
		var tile_width, gutter, num_columns, i, columns, tiles, column;
		var tiles_container = $(this);

		var _config = config(tiles_container);

		var _config2 = _slicedToArray(_config, 3);

		tile_width = _config2[0];
		gutter = _config2[1];
		num_columns = _config2[2];


		if (num_columns > 1) {
			columns = [];
			tiles = tiles_container.find('.tiles');
			tiles.data('columns', num_columns);

			if (true || tiles_container.find('.column').length != num_columns) {
				remove_columns(tiles_container);

				for (i = 0; i < num_columns; i++) {
					column = $('<div class="column column-' + i + '"></div>');
					tiles.append(column);
					columns[i] = column;
				}

				tiles_container.find('.tile').each(function (i, tile) {
					$(tile).detach().appendTo(shortest_column(tiles_container));
				});
			}

			tiles_container.find('.column').each(function (index, column) {
				$(column).css({
					width: tile_width - gutter,
					'margin-right': (index < num_columns - 1 ? gutter : 0) + 'px'
				});
			});
		} else {
			remove_columns(tiles_container);
		}
		tiles_container.css('visibility', 'visible');
	});
}

},{}],32:[function(require,module,exports){
"use strict";

window.utc2local = function (t) {
	return moment.tz(t, "utc").tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
};

},{}],33:[function(require,module,exports){
'use strict';

$(document).ready(function () {
	var main_entry_id = $('[data-main-entry-id]').data('main-entry-id');
	$('.top-stories').find('[data-entry-id="' + main_entry_id + '"]').remove();
});

},{}],34:[function(require,module,exports){
'use strict';

// Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
};

window.pluralize = function (val) {
    if (val == 'Houseman') {
        return 'Housemen';
    } else if (val == 'Room Inspector/Housekeeping Supervisor') {
        return 'Room Inspectors/Housekeeping Supervisors';
    } else if (val == 'Security') {
        return 'Security Officers';
    } else {
        return val + 's';
    }
};

function slugify(text) {
    return text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
}

$(document).ready(function () {
    if ($('.union-comparison-survey').length > 0) {
        init_nu_survey();
    }
});

function init_nu_survey() {
    var nu_survey = $('#union-comparison-survey');

    nu_survey.detach();
    $('body').append(nu_survey);

    var sections;
    var applicable_sections_count = 0;
    var slides = nu_survey.find('#slides');
    var actions = nu_survey.find('#actions');
    var responses = {
        mergeVars: {
            masterZone: '',
            wageRate: '',
            wageItemRates: '',
            classification: ''
        }
    };
    var previous_classification = '',
        previous_zip = '';
    var scores = {};
    var question_slide_template = Handlebars.compile($("#question-slide-template").html());
    var comparison_slide_template = Handlebars.compile($("#comparison-slide-template").html());
    var nu_survey_template = Handlebars.compile($("#nu-survey-template").html());
    var union_score;
    var non_union_score;
    var fe_key = null;
    var h_fe_key = null;
    var s_fe_key = null;
    var fid = 14;
    var survey_data = {};

    $.getJSON(localeUrlPath + '/non-union-survey/get-data.json', function (results) {
        survey_data['masterZones'] = results['masterZones'];
        survey_data['classifications'] = results['classifications'];
        survey_data['zips'] = results['zips'];
        survey_data['wageRates'] = results['wageRates'];
        survey_data['wageItemRates'] = results['wageItemRates'];
    });

    function calc_merge_vars() {
        if (responses.zip in survey_data['zips']) {
            responses.mergeVars.masterZone = survey_data['masterZones'][survey_data['zips'][responses.zip]['masterZone']];
            responses.mergeVars.county = survey_data['zips'][responses.zip]['county'];
            responses.mergeVars.classification = survey_data['classifications'][responses.classification];

            if (responses.mergeVars.masterZone) {
                responses.mergeVars.wageRate = survey_data['wageRates'][responses.mergeVars.masterZone['name']][responses.classification];
                responses.mergeVars.wageItemRates = survey_data['wageItemRates'][responses.mergeVars.masterZone['name']];

                if (responses.mergeVars.classification) {
                    if (responses.mergeVars.masterZone.contractName == 'IWA') {
                        responses.mergeVars.classification.tipped = responses.mergeVars.classification.tippedIwa;
                    } else if (responses.mergeVars.masterZone.contractName == 'GRIWA') {
                        responses.mergeVars.classification.tipped = responses.mergeVars.classification.tippedGriwa;
                    }
                }
            }
        }
    }

    function apply_merge_vars() {
        if (!responses.mergeVars.masterZone) {
            return;
        }

        for (var i = 1; i < sections.length; i++) {
            var section_evaluated = JSON.parse(JSON.stringify(sections[i]));

            if (section_evaluated['label_' + responses.mergeVars.masterZone.contractName]) {
                section_evaluated['label'] = eval('`' + section_evaluated['label_' + responses.mergeVars.masterZone.contractName] + '`');
            } else if (section_evaluated['label_' + responses.mergeVars.masterZone.contractName]) {
                section_evaluated['label'] = eval('`' + section_evaluated['label_' + responses.mergeVars.masterZone.contractName] + '`');
            } else if (section_evaluated['label']) {
                section_evaluated['label'] = eval('`' + section_evaluated['label'] + '`');
            }

            if (section_evaluated['body_' + responses.mergeVars.masterZone.contractName]) {
                section_evaluated['body'] = eval('`' + section_evaluated['body_' + responses.mergeVars.masterZone.contractName] + '`');
            } else if (section_evaluated['body_' + responses.mergeVars.masterZone.contractName]) {
                section_evaluated['body'] = eval('`' + section_evaluated['body_' + responses.mergeVars.masterZone.contractName] + '`');
            } else if (section_evaluated['body']) {
                section_evaluated['body'] = eval('`' + section_evaluated['body'] + '`');
            }

            for (var k in section_evaluated.blocks) {
                if (section_evaluated['blocks'][k]['label_' + responses.mergeVars.masterZone.contractName]) {
                    section_evaluated['blocks'][k]['label'] = eval('`' + section_evaluated['blocks'][k]['label_' + responses.mergeVars.masterZone.contractName] + '`');
                } else if (section_evaluated['blocks'][k]['label_' + responses.mergeVars.masterZone.contractName]) {
                    section_evaluated['blocks'][k]['label'] = eval('`' + section_evaluated['blocks'][k]['label_' + responses.mergeVars.masterZone.contractName] + '`');
                } else if (section_evaluated['blocks'][k]['label']) {
                    section_evaluated['blocks'][k]['label'] = eval('`' + section_evaluated['blocks'][k]['label'] + '`');
                }

                if (section_evaluated['blocks'][k]['body_' + responses.mergeVars.masterZone.contractName]) {
                    section_evaluated['blocks'][k]['body'] = eval('`' + section_evaluated['blocks'][k]['body_' + responses.mergeVars.masterZone.contractName] + '`');
                } else if (section_evaluated['blocks'][k]['body_' + responses.mergeVars.masterZone.contractName]) {
                    section_evaluated['blocks'][k]['body'] = eval('`' + section_evaluated['blocks'][k]['body_' + responses.mergeVars.masterZone.contractName] + '`');
                } else if (section_evaluated['blocks'][k]['body']) {
                    section_evaluated['blocks'][k]['body'] = eval('`' + section_evaluated['blocks'][k]['body'] + '`');
                }

                if (section_evaluated['blocks'][k]['body_2_' + responses.mergeVars.masterZone.contractName]) {
                    section_evaluated['blocks'][k]['body_2'] = eval('`' + section_evaluated['blocks'][k]['body_2_' + responses.mergeVars.masterZone.contractName] + '`');
                } else if (section_evaluated['blocks'][k]['body_2_' + responses.mergeVars.masterZone.contractName]) {
                    section_evaluated['blocks'][k]['body_2'] = eval('`' + section_evaluated['blocks'][k]['body_2_' + responses.mergeVars.masterZone.contractName] + '`');
                } else if (section_evaluated['blocks'][k]['body_2']) {
                    section_evaluated['blocks'][k]['body_2'] = eval('`' + section_evaluated['blocks'][k]['body_2'] + '`');
                }
            }

            section_evaluated.complete = false;

            if (!sections[i].complete) {
                $('.question-slide[data-section-index="' + i + '"] .slide-inner').html(question_slide_template(section_evaluated));
                nu_survey.find('form').off('submit').on('submit', next_slide);

                if (sections[i].comparable) {
                    $('.comparison-slide[data-section-index="' + i + '"] .slide-inner').html(comparison_slide_template(section_evaluated));
                }
            }
        }

        render_nav();
    }

    function render_nav() {
        var i = 0;
        var section;
        var nav_html = "";
        var current_slide = slides.find('.slick-current');
        var current_section_index = parseInt(current_slide.data('section-index'));

        applicable_sections_count = 0;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                section = _step.value;

                if (!sections[0].complete || !section.applicable_if || eval(section.applicable_if)) {
                    nav_html += '<li data-slide-index="' + i + '" class="' + (section.complete ? 'complete' : 'not-complete') + '">' + section.label + '</li>';
                } else {
                    nav_html += '<li data-slide-index="' + i + '" class="' + (section.complete ? 'complete' : 'not-complete') + ' not-applicable">' + section.label + '</li>';
                }

                applicable_sections_count += 1;

                section.slide_index = i;

                if (section.comparable) {
                    i += 2;
                } else {
                    i += 1;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        nu_survey.find('.sections-nav ol').html(nav_html);
        nu_survey.find('.sections-nav li').off('click').on('click', function (e) {
            if ($(this).hasClass('not-applicable')) {
                return;
            } else {
                $('.sections-nav').removeClass('open');

                var current_slide = slides.find('.slick-current');
                var current_slide_form = current_slide.find('form');
                var current_section_index = current_slide.data('section-index');

                if (current_section_index == 0) {
                    if (current_slide_form[0].reportValidity()) {
                        $.extend(responses, current_slide_form.serializeJSON());
                    } else {
                        return;
                    }
                }

                nu_survey.animate({ scrollTop: 0 }, 'fast');
                slides.slick('slickGoTo', $(this).data('slide-index'));
            }
        });

        if (current_section_index == 0) {
            nu_survey.find('.sections-overview').html(eval('`' + t2('Section 1 of ${applicable_sections_count} <i class="fa fa-caret-down"></i>') + '`'));
            actions.find('.begin').show();
            actions.find('.next').hide();
            actions.find('.compare').hide();
            actions.find('.print-results').hide();
            actions.find('.share-results').hide();
            actions.find('.start-over').hide();
        } else if (current_section_index + 1 >= sections.length) {
            nu_survey.find('.sections-overview').html(t2('Final Results <i class="fa fa-caret-down"></i>'));
            actions.find('.begin').hide();
            actions.find('.next').hide();
            actions.find('.compare').hide();
            actions.find('.print-results').show();
            actions.find('.share-results').show();
            actions.find('.start-over').show();
            record_finished();
        } else {
            nu_survey.find('.sections-overview').html(eval('`' + t2('Section ${current_section_index + 1} of ${applicable_sections_count} <i class="fa fa-caret-down"></i>') + '`'));

            if (current_slide.hasClass('comparison-slide')) {
                actions.find('.begin').hide();
                actions.find('.next').show();
                actions.find('.compare').hide();
                actions.find('.print-results').hide();
                actions.find('.share-results').hide();
                actions.find('.start-over').hide();
            } else {
                actions.find('.begin').hide();
                actions.find('.next').hide();
                actions.find('.compare').show();
                actions.find('.print-results').hide();
                actions.find('.share-results').hide();
                actions.find('.start-over').hide();
            }
        }
    }

    function render_final_results_slide() {
        var final_results_html = '',
            final_results_html_2 = '';

        if (!responses.mergeVars.masterZone) {
            return;
        }

        for (var k in sections) {
            if (sections[k].comparable) {
                var include_section = false;
                var section_evaluated = JSON.parse(JSON.stringify(sections[k]));

                if (section_evaluated['label_' + responses.mergeVars.masterZone.contractName]) {
                    section_evaluated['label'] = eval('`' + section_evaluated['label_' + responses.mergeVars.masterZone.contractName] + '`');
                } else if (section_evaluated['label_' + responses.mergeVars.masterZone.contractName]) {
                    section_evaluated['label'] = eval('`' + section_evaluated['label_' + responses.mergeVars.masterZone.contractName] + '`');
                } else if (section_evaluated['label']) {
                    section_evaluated['label'] = eval('`' + section_evaluated['label'] + '`');
                }

                if (section_evaluated['body_' + responses.mergeVars.masterZone.contractName]) {
                    section_evaluated['body'] = eval('`' + section_evaluated['body_' + responses.mergeVars.masterZone.contractName] + '`');
                } else if (section_evaluated['body_' + responses.mergeVars.masterZone.contractName]) {
                    section_evaluated['body'] = eval('`' + section_evaluated['body_' + responses.mergeVars.masterZone.contractName] + '`');
                } else if (section_evaluated['body']) {
                    section_evaluated['body'] = eval('`' + section_evaluated['body'] + '`');
                }

                for (var i in section_evaluated['blocks']) {
                    if (section_evaluated['blocks'][i]['type'] == 'question' && responses[sections[k]['blocks'][i]['handle']] != undefined) {
                        if (section_evaluated['blocks'][i]['applicable_if'] == '' || eval(section_evaluated['blocks'][i]['applicable_if']) == true) {
                            if (section_evaluated['blocks'][i]['label_' + responses.mergeVars.masterZone.contractName]) {
                                section_evaluated['blocks'][i]['label'] = eval('`' + section_evaluated['blocks'][i]['label_' + responses.mergeVars.masterZone.contractName] + '`');
                            } else if (section_evaluated['blocks'][i]['label_' + responses.mergeVars.masterZone.contractName]) {
                                section_evaluated['blocks'][i]['label'] = eval('`' + section_evaluated['blocks'][i]['label_' + responses.mergeVars.masterZone.contractName] + '`');
                            } else if (section_evaluated['blocks'][i]['label']) {
                                section_evaluated['blocks'][i]['label'] = eval('`' + section_evaluated['blocks'][i]['label'] + '`');
                            }
                            include_section = true;

                            if (sections[k]['blocks'][i]['flip_comparison_' + responses.mergeVars.masterZone.contractName] != undefined) {
                                var flip_comparison = sections[k]['blocks'][i]['flip_comparison_' + responses.mergeVars.masterZone.contractName];
                            } else {
                                var flip_comparison = sections[k]['blocks'][i]['flip_comparison'];
                            }

                            if (sections[k]['blocks'][i]['union_comparison_value_' + responses.mergeVars.masterZone.contractName]) {
                                var union_comparison_value = eval(sections[k]['blocks'][i]['union_comparison_value_' + responses.mergeVars.masterZone.contractName]);
                            } else {
                                var union_comparison_value = eval(sections[k]['blocks'][i]['union_comparison_value']);
                            }

                            var non_union_comparison_value = '';
                            if (sections[k]['blocks'][i]['field'] == 'radio') {
                                for (var m in sections[k]['blocks'][i]['choices']) {
                                    if (responses[sections[k]['blocks'][i]['handle']] == sections[k]['blocks'][i]['choices'][m]['value']) {
                                        non_union_comparison_value = sections[k]['blocks'][i]['choices'][m]['comparison_value'];
                                    }
                                }
                            } else {
                                non_union_comparison_value = eval(responses[sections[k]['blocks'][i]['handle']]);
                            }

                            if (sections[k]['blocks'][i]['field'] == 'boolean') {
                                section_evaluated['blocks'][i]['non_union_response'] = non_union_comparison_value ? t2('Yes') : t2('No');
                            } else if (sections[k]['blocks'][i]['field'] == 'radio') {
                                section_evaluated['blocks'][i]['non_union_response'] = responses[sections[k]['blocks'][i]['handle']];
                            } else if (sections[k]['blocks'][i]['field'] == 'money') {
                                section_evaluated['blocks'][i]['non_union_response'] = currency(non_union_comparison_value).format();
                            } else {
                                section_evaluated['blocks'][i]['non_union_response'] = non_union_comparison_value;
                            }

                            if (section_evaluated['blocks'][i].evaluable) {
                                if (flip_comparison ? union_comparison_value < non_union_comparison_value : union_comparison_value > non_union_comparison_value) {
                                    scores[sections[k]['blocks'][i]['handle']] = { union: 1, non_union: 0 };
                                    section_evaluated['blocks'][i]['union_won'] = 1;
                                    section_evaluated['blocks'][i]['non_union_won'] = 0;
                                } else if (flip_comparison ? union_comparison_value > non_union_comparison_value : union_comparison_value < non_union_comparison_value) {
                                    scores[sections[k]['blocks'][i]['handle']] = { union: 0, non_union: 1 };
                                    section_evaluated['blocks'][i]['union_won'] = 0;
                                    section_evaluated['blocks'][i]['non_union_won'] = 1;
                                } else {
                                    scores[sections[k]['blocks'][i]['handle']] = { union: 1, non_union: 1 };
                                    section_evaluated['blocks'][i]['union_won'] = 1;
                                    section_evaluated['blocks'][i]['non_union_won'] = 1;
                                }
                            }
                        } else {
                            scores[sections[k]['blocks'][i]['handle']] = { union: 0, non_union: 0 };
                            section_evaluated['blocks'][i]['union_won'] = 0;
                            section_evaluated['blocks'][i]['non_union_won'] = 0;
                        }
                    }

                    if (section_evaluated['blocks'][i]['union_response_' + responses.mergeVars.masterZone.contractName + '_' + responses[section_evaluated['blocks'][i].handle]]) {
                        section_evaluated['blocks'][i]['union_response'] = eval('`' + sections[k]['blocks'][i]['union_response_' + responses.mergeVars.masterZone.contractName + '_' + responses[section_evaluated['blocks'][i].handle]] + '`');
                    } else if (section_evaluated['blocks'][i]['union_response_' + responses.mergeVars.masterZone.contractName]) {
                        section_evaluated['blocks'][i]['union_response'] = eval('`' + sections[k]['blocks'][i]['union_response_' + responses.mergeVars.masterZone.contractName] + '`');
                    } else if (section_evaluated['blocks'][i]['union_response']) {
                        section_evaluated['blocks'][i]['union_response'] = eval('`' + sections[k]['blocks'][i]['union_response'] + '`');
                    }
                }

                if (include_section) {
                    final_results_html += comparison_slide_template(section_evaluated);
                }
            }
        }

        final_results_html_2 = '<div class="winner">';
        if (union_score > non_union_score) {
            final_results_html_2 += '<h1>' + t2('Union workers have better conditions in your area.') + '</h1>';
        } else {
            final_results_html_2 += '<h1>' + t2('It seems like your working conditions are good, but without a union contract, this could change at any time.') + '</h1>';
        }

        final_results_html_2 += '<p>' + eval('`' + t2('<a target="_blank" href="/non-union-workers?s_fe_key2=${fe_key || s_fe_key}#contact-us--it-s-confidential">Click here</a> if you are interested in learning more about how to organize your workplace and win improvements to your wages, benefits, and working conditions!') + '`') + '</p></div>';

        $('#final-results .slide-inner').html(final_results_html_2 + final_results_html);
    }

    function render_results_slides() {
        var current_slide = slides.find('.slick-current');
        var current_slide_form = current_slide.find('form');
        var current_section_index = parseInt(current_slide.data('section-index'));

        $.extend(responses, current_slide_form.serializeJSON());

        if (!responses.mergeVars.masterZone) {
            return;
        }

        if (sections[current_section_index].comparable) {
            var section_evaluated = JSON.parse(JSON.stringify(sections[current_section_index]));

            if (section_evaluated['label_' + responses.mergeVars.masterZone.contractName]) {
                section_evaluated['label'] = eval('`' + section_evaluated['label_' + responses.mergeVars.masterZone.contractName] + '`');
            } else if (section_evaluated['label_' + responses.mergeVars.masterZone.contractName]) {
                section_evaluated['label'] = eval('`' + section_evaluated['label_' + responses.mergeVars.masterZone.contractName] + '`');
            } else if (section_evaluated['label']) {
                section_evaluated['label'] = eval('`' + section_evaluated['label'] + '`');
            }

            if (section_evaluated['body_' + responses.mergeVars.masterZone.contractName]) {
                section_evaluated['body'] = eval('`' + section_evaluated['body_' + responses.mergeVars.masterZone.contractName] + '`');
            } else if (section_evaluated['body_' + responses.mergeVars.masterZone.contractName]) {
                section_evaluated['body'] = eval('`' + section_evaluated['body_' + responses.mergeVars.masterZone.contractName] + '`');
            } else if (section_evaluated['body']) {
                section_evaluated['body'] = eval('`' + section_evaluated['body'] + '`');
            }

            for (var i in section_evaluated['blocks']) {
                if (section_evaluated['blocks'][i]['type'] == 'question' && (section_evaluated['blocks'][i]['applicable_if'] == '' || eval(section_evaluated['blocks'][i]['applicable_if']) == true) && responses[section_evaluated['blocks'][i]['handle']] != undefined) {
                    if (section_evaluated['blocks'][i]['label_' + responses.mergeVars.masterZone.contractName]) {
                        section_evaluated['blocks'][i]['label'] = eval('`' + section_evaluated['blocks'][i]['label_' + responses.mergeVars.masterZone.contractName] + '`');
                    } else if (section_evaluated['blocks'][i]['label_' + responses.mergeVars.masterZone.contractName]) {
                        section_evaluated['blocks'][i]['label'] = eval('`' + section_evaluated['blocks'][i]['label_' + responses.mergeVars.masterZone.contractName] + '`');
                    } else if (section_evaluated['blocks'][i]['label']) {
                        section_evaluated['blocks'][i]['label'] = eval('`' + section_evaluated['blocks'][i]['label'] + '`');
                    }

                    if (section_evaluated['blocks'][i]['flip_comparison_' + responses.mergeVars.masterZone.contractName] != undefined) {
                        var flip_comparison = section_evaluated['blocks'][i]['flip_comparison_' + responses.mergeVars.masterZone.contractName];
                    } else {
                        var flip_comparison = section_evaluated['blocks'][i]['flip_comparison'];
                    }

                    var union_comparison_value = eval(section_evaluated['blocks'][i]['union_comparison_value']);

                    if (section_evaluated['blocks'][i]['union_comparison_value_' + responses.mergeVars.masterZone.contractName]) {
                        var union_comparison_value = eval(section_evaluated['blocks'][i]['union_comparison_value_' + responses.mergeVars.masterZone.contractName]);
                    } else {
                        var union_comparison_value = eval(section_evaluated['blocks'][i]['union_comparison_value']);
                    }

                    var non_union_comparison_value = '';
                    if (section_evaluated['blocks'][i]['field'] == 'radio') {
                        for (var m in section_evaluated['blocks'][i]['choices']) {
                            if (responses[section_evaluated['blocks'][i]['handle']] == section_evaluated['blocks'][i]['choices'][m]['value']) {
                                non_union_comparison_value = section_evaluated['blocks'][i]['choices'][m]['comparison_value'];
                            }
                        }
                    } else {
                        non_union_comparison_value = eval(responses[section_evaluated['blocks'][i]['handle']]);
                    }

                    if (section_evaluated['blocks'][i]['field'] == 'boolean') {
                        section_evaluated['blocks'][i]['non_union_response'] = non_union_comparison_value ? t2('Yes') : t2('No');
                    } else if (section_evaluated['blocks'][i]['field'] == 'radio') {
                        section_evaluated['blocks'][i]['non_union_response'] = responses[section_evaluated['blocks'][i]['handle']];
                    } else if (section_evaluated['blocks'][i]['field'] == 'money') {
                        section_evaluated['blocks'][i]['non_union_response'] = currency(non_union_comparison_value).format();
                    } else {
                        section_evaluated['blocks'][i]['non_union_response'] = non_union_comparison_value;
                    }

                    if (section_evaluated['blocks'][i].evaluable) {
                        if (flip_comparison ? union_comparison_value < non_union_comparison_value : union_comparison_value > non_union_comparison_value) {
                            scores[section_evaluated['blocks'][i]['handle']] = { union: 1, non_union: 0 };
                            section_evaluated['blocks'][i]['union_won'] = 1;
                            section_evaluated['blocks'][i]['non_union_won'] = 0;
                        } else if (flip_comparison ? union_comparison_value > non_union_comparison_value : union_comparison_value < non_union_comparison_value) {
                            scores[section_evaluated['blocks'][i]['handle']] = { union: 0, non_union: 1 };
                            section_evaluated['blocks'][i]['union_won'] = 0;
                            section_evaluated['blocks'][i]['non_union_won'] = 1;
                        } else {
                            scores[section_evaluated['blocks'][i]['handle']] = { union: 1, non_union: 1 };
                            section_evaluated['blocks'][i]['union_won'] = 1;
                            section_evaluated['blocks'][i]['non_union_won'] = 1;
                        }
                    }
                }

                if (section_evaluated['blocks'][i]['union_response_' + responses.mergeVars.masterZone.contractName + '_' + responses[section_evaluated['blocks'][i].handle]]) {
                    section_evaluated['blocks'][i]['union_response'] = eval('`' + section_evaluated['blocks'][i]['union_response_' + responses.mergeVars.masterZone.contractName + '_' + responses[section_evaluated['blocks'][i].handle]] + '`');
                } else if (section_evaluated['blocks'][i]['union_response_' + responses.mergeVars.masterZone.contractName]) {
                    section_evaluated['blocks'][i]['union_response'] = eval('`' + sections[current_section_index]['blocks'][i]['union_response_' + responses.mergeVars.masterZone.contractName] + '`');
                } else if (section_evaluated['blocks'][i]['union_response']) {
                    section_evaluated['blocks'][i]['union_response'] = eval('`' + sections[current_section_index]['blocks'][i]['union_response'] + '`');
                }
            }

            nu_survey.find('.comparison-slide[data-section-index="' + current_section_index + '"] .slide-inner').html(comparison_slide_template(section_evaluated));
        }

        render_final_results_slide();
        render_nav();
        toggle_applicable_questions();
    }

    var toggle_applicable_questions = debounce(function (e) {
        if (!responses.mergeVars.masterZone) {
            return;
        }

        var current_slide = slides.find('.slick-current');
        var current_section_index = parseInt(current_slide.data('section-index'));
        var section = sections[current_section_index];

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = sections[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var section = _step2.value;

                if (section.blocks) {
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = section['blocks'][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var block = _step3.value;

                            if (block.type == 'question') {
                                if (block.applicable_if == '') {
                                    $('.question_' + block.handle).find('[data-required="required"]').attr('required', 'required');
                                } else if (eval(block.applicable_if) == true) {
                                    if ($('.question_' + block.handle).css('display') == 'none') {
                                        $('.question_' + block.handle).slideDown();
                                    }
                                    $('.question_' + block.handle).find('[data-required="required"]').attr('required', 'required');
                                    $('.question_response_' + block.handle).slideDown();
                                } else {
                                    if ($('.question_' + block.handle).css('display') != 'none') {
                                        $('.question_' + block.handle).slideUp();
                                    }
                                    $('.question_' + block.handle).find('[required]').removeAttr('required');
                                    $('.question_response_' + block.handle).hide();
                                }
                            } else if (block.type == 'sectionheader') {
                                if (block.applicable_if != undefined) {
                                    if (block.applicable_if != '' && eval(block.applicable_if) == true) {
                                        if ($('#sectionheader-' + block.handle).css('display') == 'none') {
                                            $('#sectionheader-' + block.handle).slideDown();
                                        }
                                    } else {
                                        if ($('#sectionheader-' + block.handle).css('display') != 'none') {
                                            $('#sectionheader-' + block.handle).slideUp();
                                        }
                                    }
                                }
                            } else if (block.type == 'subsectionheader') {
                                if (block.applicable_if != undefined) {
                                    if (block.applicable_if != '' && eval(block.applicable_if) == true) {
                                        if ($('#subsection-' + block.handle).css('display') == 'none') {
                                            $('#subsection-' + block.handle).slideDown();
                                        }

                                        $('.question_response_' + block.handle).slideDown();
                                    } else {
                                        if ($('#subsection-' + block.handle).css('display') != 'none') {
                                            $('#subsection-' + block.handle).slideUp();
                                        }

                                        $('.question_response_' + block.handle).hide();
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        slides.slick('reinit');
    }, 250);

    function record_finished() {
        if (fe_key) {
            $.ajax({
                url: '/form-entries/store',
                type: 'post',
                data: $.extend(responses, {
                    'fe_state': 'complete',
                    'language': localeName,
                    'fid': fid,
                    'fe_key': fe_key,
                    'h_fe_key': h_fe_key,
                    's_fe_key': s_fe_key
                }),
                dataType: 'json'
            }).done(function (response) {
                fe_key = response.fe_key;
                h_fe_key = response.h_fe_key;
            });
        }
    }

    function store_responses() {
        $.ajax({
            url: '/form-entries/store',
            type: 'post',
            data: $.extend(responses, {
                'fe_state': 'pending',
                'language': localeName,
                'fid': fid,
                'fe_key': fe_key,
                'h_fe_key': h_fe_key,
                's_fe_key': s_fe_key
            }),
            dataType: 'json'
        }).done(function (response) {
            fe_key = response.fe_key;
            h_fe_key = response.h_fe_key;
        });
    }

    function calc_scores() {
        union_score = 0;
        non_union_score = 0;
        for (var i in scores) {
            union_score += scores[i]['union'];
            non_union_score += scores[i]['non_union'];
        }
        $('.union-score').html(union_score);
        $('.non-union-score').html(non_union_score);
    }

    function next_slide(e) {
        if (e) {
            e.preventDefault();
        }

        var current_slide = slides.find('.slick-current');
        var current_slide_form = current_slide.find('form');
        var current_section_index = parseInt(current_slide.data('section-index'));

        if (current_slide_form.length > 0) {
            if (current_slide_form[0].reportValidity()) {
                if (current_section_index == 0) {
                    if (responses.classification != previous_classification || responses.zip != previous_zip) {
                        previous_classification = '';
                        previous_zip = '';
                        scores = {};
                        responses = {
                            mergeVars: {
                                masterZone: '',
                                wageRate: '',
                                wageItemRates: '',
                                classification: ''
                            }
                        };
                        for (var i = 1; i < sections.length; i++) {
                            sections[i].complete = false;
                        }
                        $.extend(responses, current_slide_form.serializeJSON());
                    }

                    calc_merge_vars();
                    apply_merge_vars();
                }

                if (!responses.mergeVars.masterZone) {
                    Swal.fire({
                        title: t2('You have entered a zip code outside of our jurisdiction in New York and New Jersey. Please enter a zip code within our jurisdiction to continue.'),
                        icon: 'warning'
                    });
                } else {
                    calc_scores();
                    store_responses();
                    sections[current_section_index].complete = true;
                    slides.slick('slickNext');
                }
            }
        } else if (current_section_index + 2 >= sections.length) {
            var incomplete_sections = '';

            for (var i = 1; i < sections.length - 1; i++) {
                if (!sections[i].complete && (!sections[i].applicable_if || eval(sections[i].applicable_if))) {
                    incomplete_sections += '<li>' + sections[i].label + '</li>';
                }
            }

            if (incomplete_sections == '') {
                slides.slick('slickNext');
            } else {
                Swal.fire({
                    title: t2('You haven\'t responded to the following sections:'),
                    html: '<ul style="text-align:left">' + incomplete_sections + '</ul>',
                    icon: 'question',
                    confirmButtonText: t2('Complete Survey'),
                    cancelButtonText: t2('View Partial Results'),
                    showCancelButton: true,
                    cancelButtonColor: '#3085d6'
                }).then(function (response) {
                    if (response.isConfirmed) {
                        for (var i = 1; i < sections.length; i++) {
                            if (!sections[i].complete && (!sections[i].applicable_if || eval(sections[i].applicable_if))) {
                                slides.slick('slickGoTo', $('[data-section-index="' + i + '"]').attr('data-slick-index'));
                                break;
                            }
                        }
                    } else {
                        slides.slick('slickNext');
                    }
                });
            }
        } else {
            for (var i = 1; i < sections.length; i++) {
                if (!sections[i].complete && (!sections[i].applicable_if || eval(sections[i].applicable_if))) {
                    slides.slick('slickGoTo', $('[data-section-index="' + i + '"]').attr('data-slick-index'));
                    break;
                }
            }
        }

        return false;
    }

    function print_results() {
        $('body').removeClass('no-scroll');
        $('body').addClass('print-nu-survey');
        print();
        $('body').removeClass('print-nu-survey');
        $('body').addClass('no-scroll');
    }

    function share_results() {
        var share_btns_template = Handlebars.compile(document.getElementById("share-btns-template").innerHTML);
        var safari_desktop = /Safari/i.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor) && !/Mobi|Android/i.test(navigator.userAgent);
        var url = 'https://' + window.location.hostname + window.location.pathname + '?s_fe_key=' + (fe_key || s_fe_key);

        if (!safari_desktop && navigator.share) {
            navigator.share({
                title: t2('Union vs Non-union Comparison Survey'),
                url: url
            });
        } else {
            Swal.fire({
                title: 'Share',
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                width: '400px',
                html: share_btns_template({
                    title: t2('Union vs Non-union Comparison Survey'),
                    url: url
                })
            });

            window.Sharer.init();
        }
    }

    function start_over() {
        previous_classification = '';
        previous_zip = '';
        scores = {};
        responses = {
            mergeVars: {
                masterZone: '',
                wageRate: '',
                wageItemRates: '',
                classification: ''
            }
        };
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = sections[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var section = _step4.value;

                section.complete = false;
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        nu_survey.find('.question input[type="text"], .question input[type="money"], .question input[type="number"], .question select').val('');
        nu_survey.find('.question input:checked').prop('checked', false);
        slides.slick('slickGoTo', 0);
        calc_scores();
        render_nav();
    }

    $('body').on('keyup change click', '#union-comparison-survey form input, #union-comparison-survey form select, #union-comparison-survey form textarea', function () {
        var form = $(this).closest('form');
        setTimeout(function () {
            if (previous_classification == '' && previous_zip == '') {
                previous_classification = responses.classification;
                previous_zip = responses.zip;
            }

            render_results_slides();
        }, 10);
    });

    $.getJSON(localeUrlPath + '/nu-survey-questions.json', function (sections2) {
        sections = sections2;
        sections.push({ label: t2('Final results'), comparable: false });

        var params = new URLSearchParams(window.location.search);

        if (params.get('s_fe_key')) {
            s_fe_key = params.get('s_fe_key');

            $.ajax({
                url: '/form-entries/get',
                type: 'get',
                data: {
                    'fid': fid,
                    'fe_key': params.get('s_fe_key')
                },
                dataType: 'json'
            }).done(function (response) {

                responses = response;

                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = sections[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var section = _step5.value;

                        if (section.blocks) {
                            var _iteratorNormalCompletion6 = true;
                            var _didIteratorError6 = false;
                            var _iteratorError6 = undefined;

                            try {
                                for (var _iterator6 = section['blocks'][Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                    var block = _step6.value;

                                    if (block.type == 'question' && block.handle in responses) {
                                        if (block.field == 'boolean') {
                                            if (responses[block.handle] == true) {
                                                nu_survey.find('#' + block.handle + '_yes').prop('checked', true);
                                            } else {
                                                nu_survey.find('#' + block.handle + '_no').prop('checked', true);
                                            }
                                        } else if (block.field == 'radio') {} else if (block.field == 'select' || block.field == 'money' || block.field == 'number' || block.field == 'input' || block.field == 'zip') {
                                            nu_survey.find('#' + block.handle).val(responses[block.handle]);
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError6 = true;
                                _iteratorError6 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                        _iterator6.return();
                                    }
                                } finally {
                                    if (_didIteratorError6) {
                                        throw _iteratorError6;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }

                render_final_results_slide();
                calc_scores();
                $('.union-comparison-survey').click();
                slides.slick('slickGoTo', slides.find('.slide').length - 1);
            });
        }

        applicable_sections_count = sections.length;

        for (var i = 1; i < sections.length; i++) {
            for (var k in sections[i].blocks) {
                /* Allow translations to be accessible in the templates */
                sections[i].yes = t2('Yes');
                sections[i].no = t2('No');
                sections[i].union = t2('Union');
                sections[i].nonUnion = t2('Non-Union');

                if (sections[i]['blocks'][k]['type'] == 'sectionheader' || sections[i]['blocks'][k]['type'] == 'subsectionheader') {
                    sections[i]['blocks'][k]['handle'] = slugify(sections[i]['blocks'][k]['body']);
                }
            }
        }

        nu_survey.find('.close').off('click').on('click', function (e) {
            $('body').removeClass('no-scroll').removeClass('nu-survey-active');
            nu_survey.hide();
            e.preventDefault();
            return false;
        });

        /* close if the escape key is pressed */
        $(document).off('keyup').on('keyup', function (e) {
            if (e.keyCode === 27) {
                $('body').removeClass('no-scroll nu-survey-active');
                nu_survey.hide();
            }
        });

        render_nav();

        nu_survey.find('.sections-overview').off('click').on('click', function () {
            $('.sections-nav').toggleClass('open');
        });

        slides.html(nu_survey_template({ sections: sections }));

        if (!sections[0].complete) {
            $('.question-slide[data-section-index="' + 0 + '"] .slide-inner').html(question_slide_template(sections[0]));
        }

        nu_survey.find('form').off('submit').on('submit', next_slide);
        actions.find('.begin').off('click').on('click', next_slide);
        actions.find('.next').off('click').on('click', next_slide);
        actions.find('.compare').off('click').on('click', next_slide);
        actions.find('.print-results').off('click').on('click', print_results);
        actions.find('.share-results').off('click').on('click', share_results);
        actions.find('.start-over').off('click').on('click', start_over);

        $('.union-comparison-survey').off('click').on('click', function () {
            $('body').trigger('union-comparison-survey');
        });

        $('body').off('union-comparison-survey').on('union-comparison-survey', function (e) {
            $('body').addClass('no-scroll').addClass('nu-survey-active');
            nu_survey.show();

            if (!nu_survey.hasClass('initialized')) {
                slides.slick({
                    infinite: false,
                    slidesToShow: 1,
                    arrows: false,
                    dots: false,
                    draggable: false,
                    autoplay: false,
                    adaptiveHeight: true,
                    focusOnSelect: false,
                    fade: true,
                    accessibility: false
                }).on('afterChange', function (e) {
                    var current_slide = slides.find('.slick-current');
                    var current_section_index = parseInt(current_slide.data('section-index'));

                    render_nav();
                    toggle_applicable_questions();

                    nu_survey.animate({ scrollTop: 0 }, 'fast');
                });
            }

            toggle_applicable_questions();
            render_nav();

            nu_survey.addClass('initialized');

            e.preventDefault();
            return false;
        });
    });
}

},{}],35:[function(require,module,exports){
'use strict';

$(document).ready(function () {
	$(window).on('resize', function () {
		var vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', vh + 'px');
	}).resize();
});

},{}]},{},[3]);
